var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-do",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M83.7 80.3h364.9v364.9h-365z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "translate(-117.4 -112.7) scale(1.403)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00319c",
    fillRule: "evenodd",
    d: "M313.2 314.8h318.1V510H313.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d62918",
    fillRule: "evenodd",
    d: "M-99.2 315.4H218V510H-99.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00319c",
    fillRule: "evenodd",
    d: "M-98.6-1.8h317.2V216H-98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d62918",
    fillRule: "evenodd",
    d: "M315 0h315.7v218H315z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M-99 215.8h731v101H-99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M217.3-.7h98.5v511h-98.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m259.3 218.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m259.8 218.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m260.3 218.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#848c9c",
    d: "m263.8 218.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#848ca5",
    d: "m264.7 219 .3.1-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#848c9c",
    d: "m265.3 218.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m268.9 218.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m269.4 218.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m269.9 218.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m255.8 219.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m256.3 219.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m256.8 219.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "m257.3 219.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425a84",
    d: "m257.8 219.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m258.7 219.4.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m259.7 219.4.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M251.7 224c-6 0-13.9.4-19 3.4-3.5 2-3.1 7.6 1.4 7.5v.5h-1v.4l7.6-1.9v-.4h-3v-.5h3.5l-1-2 18-1.8-1-3.4c6.7-.8 12-.2 18.6 1.5v.4l-4-1c.4 2.2 2.7 1.6 4.4 1l-5 1v.5l11.6 1 12 2.8v.5l-6.5-1v.5l8 2.4-1.5-1.5v-.4l2 2.3c3.2.2 5.6.9 7.5 3.4l-7-2.9 4 9h.5V244h.5v1.4l4.5-1c-1.1-4.8-3.2-10.5-8-12.9.4-1.8 0-2.6-1.5-3.8 1.9 3.7-1.2 5.2-4 2.4l-1 1 1-3.4-3 2.9.5-3.3h-.5l-.5 2.8-1.5-1.4-.5 1.4-8-1V225l1 1.4h.5V225l2.5 1.4h.5l10 .5.5 3.8h.5l1.5-3.3a53.3 53.3 0 0 0-19-3.4c.3-3.2-3.3-3.8-6-4.2-4.9-.7-19.6-2.4-20.1 4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m269.7 219.4.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m270.7 219.4.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314a7b",
    d: "m271.4 219.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "m271.9 219.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m272.4 219.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m272.9 219.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m273.4 219.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m254.3 219.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m254.8 219.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "m255.3 219.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "m255.8 219.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m256.3 219.7.5.5-.5-.5m16.6 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m273.4 219.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "m273.9 219.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "m274.4 219.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m274.9 219.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m252.8 220.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m253.3 220.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "m253.8 220.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m254.3 220.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "m259.3 220.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "m259.8 220.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295284",
    d: "m260.3 220.2.5.5-.5-.5m1 0 .5.5-.5-.5zm3 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "m267.4 220.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "m268.9 220.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "m269.4 220.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m274.9 220.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "m275.4 220.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m275.9 220.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m276.4 220.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m251.8 220.7-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m252.3 220.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "m252.8 220.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "m255.8 220.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "m256.3 220.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad9431",
    d: "m256.8 220.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "m257.3 220.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "m257.8 220.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "m259.3 220.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "m260.3 220.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "m261.3 220.7.5.5-.5-.5zm3 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "m269.4 220.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "m271.7 220.8.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295284",
    d: "m272.4 220.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m276.4 220.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m276.9 220.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m277.4 220.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31394a",
    d: "m251.8 221.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "m255.8 221.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "m257.8 221.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "m259.3 221.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "m260.3 221.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "m265.8 221.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "m266.3 221.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "m266.9 221.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "m267.9 221.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "m270.9 221.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "m272.4 221.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "m277.4 221.2 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m277.9 221.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212139",
    d: "m251.3 221.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "m255.8 221.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "m256.3 221.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "m257 222 .2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "m257.5 222 .2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "m258.3 221.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "m259.8 221.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "m260.8 221.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "m265.8 221.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "m266.3 221.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "m266.9 221.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "m267.9 221.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295284",
    d: "m268.4 221.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "m270.9 221.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "m272.4 221.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m278.4 221.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m250.8 222.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m251.3 222.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "m255.8 222.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "m258.3 222.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295284",
    d: "m258.8 222.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "m259.8 222.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "m260.3 222.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad9431",
    d: "m260.8 222.1.5.5-.5-.5m6.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "m268.5 222.4.2.4-.2-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "m270.9 222.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad9431",
    d: "m271.4 222.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "m271.9 222.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad9431",
    d: "m272.4 222.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m277.9 222.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m278.4 222.1.5.5-.5-.5m-27.6.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m251.5 223 .1.2-.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "m255.8 222.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "m256.8 222.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "m258.3 222.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "m258.8 222.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "m259.8 222.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "m260.3 222.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "m265.8 222.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "m266.3 222.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "m266.9 222.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "m270.4 222.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "m271.4 222.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "m272.2 222.8.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m250.8 223 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "m255.8 223 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "m256.8 223 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "m257.3 223 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "m257.8 223 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "m258.8 223 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "m261.3 223 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "m266 223.4.2.3-.2-.3m.8-.3 1 1.4-1-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "m268.4 223 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "m270.4 223 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "m271.9 223 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m248.8 223.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "m250.8 223.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m251.3 223.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "m256.8 223.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "m258.8 223.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "m259.3 223.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "m259.8 223.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295284",
    d: "m260.3 223.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "m260.8 223.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "m261.3 223.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "m268.4 223.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad9431",
    d: "m270.9 223.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "m271.9 223.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "m272.9 223.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m277.9 223.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "m278.4 223.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m280.4 223.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m282.4 223.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m242.8 224 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m243.3 224 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m244.1 224.2.4.2-.4-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "m244.8 224 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314a7b",
    d: "m245.3 224 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m246.1 224.2.4.2-.4-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m246.8 224 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "m256.8 224 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "m258.8 224 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "m259.3 224 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "m260.8 224 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "m261.3 224 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "m262.3 224 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "m262.8 224 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "m263.3 224 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "m265.3 224 .5.5-.5-.5m1.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "m268.4 224 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "m268.9 224 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "m269.9 224 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "m270.9 224 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "m271.9 224 .5.5-.5-.5m1 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m282.4 224 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m283.2 224.2.4.2-.4-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314a7b",
    d: "m283.9 224 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "m284.4 224 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m284.9 224 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m285.4 224 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m285.9 224 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m286.4 224 .5.5-.5-.5m-46.6.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m240.3 224.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m240.8 224.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "m241.3 224.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#29396b",
    d: "m241.8 224.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m242.3 224.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m242.8 224.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m243.3 224.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m250.8 224.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "m256.3 224.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "m256.8 224.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "m271.9 224.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "m272.4 224.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295284",
    d: "m272.9 224.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m277.4 224.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m286.2 224.7.4.1-.4-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m286.9 224.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "m287.4 224.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "m287.9 224.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "m288.4 224.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m288.9 224.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m289.4 224.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m237.8 225 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m238.3 225 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525a6b",
    d: "m238.8 225 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "m239.3 225 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m239.8 225 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "m245.3 225 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m250.8 225 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "m277.4 225-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "m279.9 225 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "m280.4 225 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "m281.4 225 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m289.4 225 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m290 225 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "m290.4 225 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m291 225 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m291.4 225 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m292 225 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m235.8 225.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m236.3 225.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314a7b",
    d: "m236.8 225.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m237.3 225.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m237.8 225.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "m241.3 225.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "m241.8 225.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "m242.3 225.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "m244.3 225.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "m244.8 225.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "m245.6 225.6.4.2-.4-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "m246.3 225.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "m250.8 225.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m259.2 225.6.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "m259.8 225.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m260.3 225.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#29396b",
    d: "m260.8 225.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425a84",
    d: "m261.3 225.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "m264.3 225.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#737b94",
    d: "m264.8 225.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#29396b",
    d: "m268.4 225.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m269.2 225.6.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m270.2 225.6.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b6b4a",
    d: "m277.4 225.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "m280.4 225.5 1 3.8-1-3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "m282.9 225.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "m283.4 225.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "m284.4 225.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "m286.4 225.5-.5 1.9.5-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m291.4 225.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "m292 225.5.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314a7b",
    d: "m292.4 225.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m293 225.5.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m293.4 225.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m234.3 226 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m234.8 226 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31425a",
    d: "m235.3 226 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m235.8 226 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "m240.8 226 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "m242.8 226 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "m244.6 226.1.4.2-.4-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "m245.3 226 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "m246.1 226.1.4.2-.4-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m251.3 226 .5.4-.5-.5m6 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m257.8 226 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m269.9 226 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m270.4 226 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m270.9 226 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m271.4 226 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m272 226.3.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "m276.9 226 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "m277.4 226 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "m281.9 226 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "m282.4 226-.5.9.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "m282.9 226 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "m284.4 226 1 .9-1-1zm3 0 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "m287.9 226 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "m288.4 226 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad9431",
    d: "m288.9 226 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "m289.4 226 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m293.4 226 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "m294 226 .4.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m294.4 226 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m295 226 .4.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m233.3 226.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525a6b",
    d: "m233.8 226.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "m234.3 226.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "m238.8 226.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "m241.3 226.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "m241.8 226.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "m242.3 226.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "m243.3 226.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "m244.3 226.4 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "m244.8 226.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "m245.3 226.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295284",
    d: "m245.8 226.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "m246.3 226.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "m251.3 226.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m255.8 226.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m256.3 226.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m256.8 226.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m257.8 226.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m270.9 226.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m271.5 226.7.2.4-.2-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m272.5 226.7.2.4-.2-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "m276.9 226.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295284",
    d: "m280.9 226.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "m282.4 226.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "m282.9 226.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "m283.9 226.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "m284.4 226.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "m285.4 226.4.5.5-.5-.5m1.7.3.1.4-.1-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "m287.4 226.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "m287.9 226.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "m288.4 226.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295284",
    d: "m290 226.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "m290.4 226.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "m291 226.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "m291.4 226.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "m292 226.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "m292.4 226.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m295 226.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31394a",
    d: "m295.4 226.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m296 226.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m296.4 226.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m232.3 226.9.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212139",
    d: "m232.8 226.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m233.3 226.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "m235.3 226.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "m235.8 226.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "m236.3 226.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "m237.3 226.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "m238.8 226.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "m239.8 226.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "m240.3 226.9.5 1.4-.5-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "m241.3 226.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M241.8 226.9v1.9h1v-1.9h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "m242.8 226.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "m243.3 226.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "m244.3 226.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "m245.3 226.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "m245.8 226.9-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "m246.3 226.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "m251.3 226.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m253.3 226.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M254.5 227.6v1.1h2.4l-2.4-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "m255.3 226.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m255.8 226.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31394a",
    d: "m257.8 226.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m274.4 226.9 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m274.9 226.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m276.5 227.2.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "m276.9 226.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "m283.4 226.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "m284 227.2.2.3-.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "m284.9 226.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "m285.4 226.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295284",
    d: "m286.4 226.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad9431",
    d: "m287.9 226.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "m288.4 226.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295284",
    d: "m288.9 226.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "m290 226.9.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "m290.4 226.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "m291 226.9.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "m291.4 227.8 1.5-.4-1.5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "m293 226.9.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295284",
    d: "m294 226.9-.6 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "m296.4 226.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m297 226.9.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m231.3 227.4.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "m231.8 227.4.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m232.3 227.4.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad9431",
    d: "m235.3 227.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "m236.6 227.5.3.2-.3-.2m1.2-.1.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "m238.8 227.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "m241.3 227.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "m244.4 227.7.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "m244.8 227.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "m246.1 227.5.4.2-.4-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "m246.8 227.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m252 227.7.1.3-.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m252.3 227.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "m252.8 227.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m253.3 227.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "m257.8 227.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m258.3 227.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "m271.4 227.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m275.4 227.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "m281.9 227.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "m282.4 227.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "m282.9 227.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "m283.4 227.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "m286.4 227.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "m286.9 227.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "m287.9 227.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "m288.4 227.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "m288.9 227.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "m290 227.4.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "m291 227.4.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "m292 227.4.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "m292.4 227.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "m293 227.4.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "m294.4 227.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m297 227.4.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212139",
    d: "m297.4 227.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m298 227.4.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m230.8 227.8-.6 1 .6-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "m231.3 227.8.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "m235.3 227.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295284",
    d: "m236.3 227.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M236.8 227.8v2h.5l-.5-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "m237.3 227.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "m238.3 227.8 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "m238.8 227.8.5.5-.5-.5zm6 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "m245.6 228 .4.2-.4-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "m246.3 227.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "m246.8 227.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "m252.5 228.2.1.3-.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m257.8 227.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m258.3 227.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m270.9 227.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m271.4 227.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000818",
    d: "m275.9 227.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "m281.9 227.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "m282.4 227.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "m282.9 227.8-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "m283.4 227.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "m284.9 227.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "m285.9 227.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "m286.7 228 .4.2-.4-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "m291 227.8.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "m291.4 227.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "m293.4 227.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "m296.4 227.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "m297 227.8.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m298 227.8.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m298.4 227.8 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m230.8 228.3.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295284",
    d: "m235.3 228.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "m237.3 228.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "m238.3 228.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "m239.8 228.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "m241.3 228.3.5.5-.5-.5m1.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "m244.3 228.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "m245.3 228.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "m246.5 228.7.1.3-.1-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad9431",
    d: "m246.8 228.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m252.8 228.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m252.8 229.3 1.5-1-1.5 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m254.3 228.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525a6b",
    d: "m258.3 228.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m270.9 228.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m273.9 228.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m273.9 229.3 1.5-1-1.5 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m275.4 228.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m275.9 228.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "m280.9 228.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "m281.9 228.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "m282.9 228.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "m283.4 228.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "m284.9 228.3.5.5-.5-.5zm2 0 .5.5-.5-.5m1 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "m288.4 228.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "m288.9 228.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "m291 228.3.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "m291.4 228.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "m293 228.3.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "m297.4 228.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m298.4 228.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m229.8 228.8.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m230.3 228.8.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "m235.8 228.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "m236.3 228.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "m238.4 229.1.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad9431",
    d: "m239.8 228.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "m240.8 228.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad9431",
    d: "m242.1 229 .3.1-.3-.1m1.2-.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "m244.8 228.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "m246.8 228.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m257.3 228.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "m258.3 228.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m270.4 228.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "m270.9 228.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "m276.9 228.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "m283.4 228.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "m286.4 228.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "m286.9 228.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "m287.9 228.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "m291.4 228.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "m292.4 228.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "m293 228.8.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "m293.4 228.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "m294 228.8-.6 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "m296 228.8.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "m296.4 228.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "m298 228.8.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m299 228.8.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m299.4 228.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525a6b",
    d: "m229.8 229.3.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "m235.8 229.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "m236.3 229.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "m237.3 229.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "m239.3 229.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "m239.8 229.3-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad9431",
    d: "m241.3 229.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "m242.8 229.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "m245.3 229.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "m245.8 229.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "m246.3 229.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "m257.8 229.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m258.3 229.3.5.5-.5-.5m12 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m270.9 229.3 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31394a",
    d: "m271.4 229.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "m284.4 229.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "m284.9 229.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "m286.4 229.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad9431",
    d: "m286.9 229.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "m288.9 229.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "m290.4 229.3.5.5-.5-.5m1 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "m292.4 229.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "m294 229.3.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "m294.4 229.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "m297 229.3-.6 1.9h.5v-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "m297.4 229.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "m298.4 229.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425a84",
    d: "m299.6 229.6.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "m229.8 229.8.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "m235.8 229.8.5.4-.5-.4m1 0 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "m237.3 229.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "m238.3 229.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "m239.8 229.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m256.3 229.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "m256.8 229.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m257.3 229.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m257.8 229.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m271.9 229.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "m272.4 229.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m272.9 229.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "m287.4 229.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "m288.9 229.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "m289.4 229.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "m290.4 229.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "m292 229.8.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "m294.4 229.8-.5 1.4.5-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "m295.4 229.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "m296 229.8.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "m296.4 229.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "m297.4 229.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "m298.4 229.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m229.8 230.2.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "m235.8 230.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "m237.8 230.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "m239.3 230.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m245.3 230.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m245.8 230.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m246.3 230.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "m246.8 230.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525a6b",
    d: "m253.3 230.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#848c9c",
    d: "m253.8 230.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m256.3 230.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m272.9 230.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#848c9c",
    d: "m275.4 230.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "m275.9 230.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "m282.4 230.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m282.9 230.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m283.4 230.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m283.9 230.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "m290.4 230.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "m291 230.2.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "m292 230.2.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "m292.4 230.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "m293.4 230.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "m294 230.2.4.5-.5-.5m1.9.2.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "m297.4 230.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "m298.4 230.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525a6b",
    d: "m299.4 230.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m229.8 230.7.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m230.3 230.7.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "m236.3 230.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "m236.8 230.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m240.3 231.7 1.5-.5-1.5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "m241.8 230.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m242.3 230.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314a7b",
    d: "m242.8 230.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "m243.3 230.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "m243.8 230.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m244.3 230.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m244.8 230.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m245.3 230.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m245.8 230.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m283.4 230.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m283.9 230.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m284.4 230.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m284.9 230.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m285.4 230.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "m285.9 230.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314a7b",
    d: "m286.4 230.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m286.9 230.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "m287.4 230.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m288.2 230.9.4.1-.4-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "m292.4 230.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "m295 230.7.4.5-.5-.5zm1 0 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295284",
    d: "m297 230.7.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "m298 230.7.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m299.4 230.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m229.8 231.2.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "m230.3 231.2.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m240.8 231.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m241.3 231.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m241.8 231.2-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m287.9 231.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m288.4 231.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m288.9 231.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "m294 231.2.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "m294.4 231.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "m295 231.2.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "m296 231.2.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "m296.4 231.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "m299 231.2.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m299.4 231.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m228.7 231.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m229.3 231.7.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M230 232v.3-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m238.8 231.7-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m239.3 231.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m239.8 231.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "m240.8 231.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m287.9 231.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212139",
    d: "m288.4 231.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m288.9 231.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m289.6 232 .1.3-.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "m295 231.7.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "m295.4 231.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295284",
    d: "m297.4 231.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m299.4 231.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "m300 231.7.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m300.4 231.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m228.2 232.1-1 1.5 1-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "m228.7 232.1-1 1.5 1-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M229.3 232.1c-1.5 1.5-3.5 3.2-2.6 5.3-2.6 1.4-3 4.5-4 7.1l5.6 1 4-9-5.6.4v-.5l5-.4-2.4-3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m236.3 232.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "m236.8 232.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m237.6 232.3.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m238.8 232.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m241.3 232.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m287.9 232.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m288.4 232.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m291.4 232.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "m296 232.1.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "m296.4 232.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "m300.4 232.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m301 232.1 1.4 1.5-1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m229.8 232.6.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m230.3 232.6.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m234.8 232.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m235.6 232.8.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m236.3 232.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "m241.3 232.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "m287.9 232.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m291.4 232.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "m292 232.6.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m292.8 232.8.3.1-.4-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m293.6 233 .1.3-.1-.4m7.3-.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "m230.3 233.1.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m233.4 233.4.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m234 233.3.4.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "m237.8 233.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m240.8 233.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "m241.3 233.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m287.4 233.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "m287.9 233.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m288.7 233.3.4.1-.4-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "m289.4 233.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m290 233.1.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m290.4 233.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m294.3 233.3.3.1-.4-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m301.4 233.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m226.7 233.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212139",
    d: "m227.2 233.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m230.3 233.6.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m230.8 233.6.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m232.6 233.7.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m236.3 233.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m236.8 233.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m237.3 233.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "m240.8 233.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m241.3 233.6-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m287.4 233.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m287.9 233.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "m288.4 233.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m290.4 233.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m291.2 233.7.4.2-.4-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m292 233.6.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m295 233.6.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m295.4 233.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m296 233.6.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m302 233.6.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m302.4 233.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "m226.7 234 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m232.3 234 .4.5-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m235.6 234.2.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m236.3 234 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "m240.3 234 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m288.4 234 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "m288.9 234 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m292 234 .4.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "m292.4 234 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m293 234 .4.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31425a",
    d: "m302.4 234 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m303 234 .4.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m226.2 234.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m226.7 234.5.5.5-.5-.5m4 0 .6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m234.6 234.7.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m238.8 234.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "m239.3 234.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m239.8 234.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m240.3 234.5.5.5-.5-.5m48.6 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m289.4 234.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314a7b",
    d: "m290 234.5.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m290.4 234.5.5.5-.5-.5m2.5 0-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "m293.4 234.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m294 234.5.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m303 234.5.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m225.7 235 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "m226.2 235 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m231.8 235 .4.5-.4-.5m1 0 .4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m233.6 235.2.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m236.3 235 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m236.8 235 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m237.3 235 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "m237.8 235 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m238.3 235 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m238.8 235 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m290.4 235 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m291 235 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525a6b",
    d: "m291.4 235 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "m292 235 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m293 235 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "m293.4 235 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m294 235 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "m294.4 235 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m295 235 .4.5-.5-.5m2 0 .5.5-.5-.5m6 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m303.4 235 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m225.7 235.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "m231.8 235.5.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m232.8 235.5.5.5-.5-.5m1.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "m234.8 235.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525a6b",
    d: "m235.3 235.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m236.3 235.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m236.8 235.5.5.5-.5-.5m55.6 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m293 235.5.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525a6b",
    d: "m294 235.5.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "m294.4 235.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m296.4 235.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "m303.4 235.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m225.2 236 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "m225.7 236 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "m229.8 236 .4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "m233.3 236 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "m233.8 236 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m234.3 236 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m236.3 236 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m292 236 .4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m292.4 236 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m294.3 236.1.3.2-.4-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m295 236 .4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "m295.4 236 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#080829",
    d: "m296 236 .4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m298.4 236 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m304 236 .4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m225.2 236.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "m226.7 236.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m227.6 236.6.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m228.2 236.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m232.8 236.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m233.3 236.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m296.4 236.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "m297 236.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m300 236.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m300.8 236.6.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m301.6 236.8.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212139",
    d: "m304 236.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m224.7 237 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "m231.8 237 .4.4-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m232.3 237-.6.9.6-1m64.6 0 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "m297.4 237 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m302 237 .4.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m302.4 237 2 1.8-2-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m304 237 .4.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m304.4 237 .6.4-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m224.7 237.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "m225.2 237.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "m231.3 237.4.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101831",
    d: "m298 237.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "m304.4 237.4.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m224.2 237.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101829",
    d: "m224.7 237.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m230.8 237.9.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m231.3 237.9.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m235.8 237.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M236.3 237.9v.4h57.6l-17.5-.4h-40.1m61.6 0 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "m298.4 237.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m304.4 237.9.6.4-.6-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m305 237.9.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "m224.2 238.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m224.7 238.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "m230.8 238.3.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m235.8 238.3 2.5 2.4-2.5-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m236.3 238.3 1.5 1.5-1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "m236.8 238.3 4.2 5.3.3 18.6h4.5c0-6 1.3-12-3-16.7l6 3.8-2.5-7.1 14 13.3-10.5-16.2 10 12.9h.5v-13.9h-23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M260.3 238.3v14.4h.5l-.5-14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M268.9 238.3v14.4h.5l-.5-14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M269.4 238.3v13.4l10.5-12.4-10.5 16.2 14.5-13.3-3 6.6 6-3.8c-3.2 6-3 10.4-3 17.2h4.5l.3-18.6 4.2-5.3h-23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m293 238.3.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m293.4 238.3-1 1.5 1-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m298.4 238.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m299 238.3.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m305 238.3.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m223.7 238.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000818",
    d: "m224.2 238.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m230.3 238.8.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m230.8 238.8.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m292.4 238.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "m299 238.8.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m304 238.8.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "m305 238.8.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m305.4 238.8.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "m223.7 239.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m224.2 239.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m230.3 239.3.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m249.8 239.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m299 239.3.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m304.6 239.6.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m305.4 239.3.6.5-.6-.5m-82 .8.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "m223.7 239.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m229.8 239.8.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m230.3 239.8.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "m237.8 239.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "m249.8 239.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212139",
    d: "m250.3 239.8 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#100808",
    d: "m279.4 239.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m292 239.8-3 3.3 3-3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m299 239.8.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "m299.4 239.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31425a",
    d: "m305.4 239.8.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "m223.7 240.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "m229.8 240.3.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "m238.3 240.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m249.8 240.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b5a00",
    d: "m250.3 240.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m278.4 240.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b5a00",
    d: "m278.9 240.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m299.4 240.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m305.4 240.3.6.4-.6-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m306 240.3.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m223.2 240.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m229.3 240.7.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m229.8 240.7.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m238.3 240.7 2.5 2.4-2.5-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "m238.8 240.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392121",
    d: "m250.3 240.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cea508",
    d: "m251 241 .1.4-.1-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "m251.3 240.7 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m277.9 240.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#634a00",
    d: "m278.9 240.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m279.4 240.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m299.4 240.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m300 240.7.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "m306 240.7.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "m223.2 241.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "m229.3 241.2.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "m239.3 241.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m250.3 241.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "m251.3 241.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2908",
    d: "m277.4 241.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "m278.4 241.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m278.9 241.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "m300 241.2.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "m306 241.2.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m222.7 241.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "m223.2 241.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m229.3 241.7.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "m239.8 241.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#634a00",
    d: "m250.8 241.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb508",
    d: "m251.3 241.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "m251.8 241.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "m277.4 241.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m278.9 241.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m300 241.7.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m300.4 241.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m306 241.7.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m306.4 241.7.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m222.7 242.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m223.2 242.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m228.7 242.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m229.3 242.2.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "m240.3 242.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m246.5 242.5.1.3-.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "m250.8 242.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000818",
    d: "m251.3 242.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "m251.8 242.2 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m252.3 242.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m276.9 242.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "m277.4 242.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#210800",
    d: "m277.9 242.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m278.4 242.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m282.9 242.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m283.4 242.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m288.9 242.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m300.4 242.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m306.4 242.2.6.4-.6-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "m222.7 242.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "m228.7 242.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "m240.8 242.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#102110",
    d: "m246.8 242.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m247.3 242.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "m251.8 242.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m252.8 242.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m276.4 242.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "m277.2 242.8.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m277.9 242.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m281.9 242.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2908",
    d: "m282.4 242.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "m282.9 242.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m288.4 242.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "m300.4 242.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314a7b",
    d: "m306.4 242.6.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "m222.7 243.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "m228.7 243.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M240.8 243.1v19.6h.5c0-5.6 1.7-14.4-.5-19.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#634a00",
    d: "m246.8 243.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c7300",
    d: "m247.3 243.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "m247.8 243.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m251.8 243.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "m252.3 243.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "m252.8 243.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m275.9 243.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311000",
    d: "m276.4 243.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "m276.9 243.1-1 1.5 1-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m277.4 243.1.5.5-.5-.5m4 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b5a00",
    d: "m281.9 243.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b5a00",
    d: "m282.4 243.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m282.9 243.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M288.4 243.1v19.1h.5c0-5.5 1.7-14-.5-19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m300.4 243.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m306.4 243.1.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m307 243.1.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m222.2 243.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m222.7 243.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m228.2 243.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m228.7 243.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "m246.8 243.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9408",
    d: "m247.3 243.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cea508",
    d: "m247.8 243.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "m248.3 243.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m248.8 243.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m252.3 243.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "m252.8 243.6 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101829",
    d: "m253.3 243.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m275.9 243.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "m276.9 243.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m280.4 243.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2908",
    d: "m280.9 243.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9408",
    d: "m281.4 243.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "m281.9 243.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m282.4 243.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m300.4 243.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m301 243.6.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m307 243.6.4.5-.4-.5m-84.8.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "m228.2 244 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m228.7 244 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313918",
    d: "m247.3 244 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "m247.8 244 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad8c08",
    d: "m248.3 244 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "m248.8 244 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101829",
    d: "m252.8 244 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m253.8 244 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m275.4 244 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m276.9 244 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m280.4 244 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b5a00",
    d: "m280.9 244 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "m281.4 244 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#634a00",
    d: "m281.9 244-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m282.4 244 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "m301 244 .4.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m302 244 .4.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525a6b",
    d: "m307 244 .4.5-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m221.7 244.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m222.2 244.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m222.7 244.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m223.2 244.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "m223.7 244.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m224.2 244.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m224.7 244.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314a7b",
    d: "m228.2 244.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m247.3 244.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#423100",
    d: "m247.8 244.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "m248.3 244.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "m248.8 244.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m249.3 244.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "m253.3 244.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "m253.8 244.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m254.3 244.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m274.9 244.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m276.4 244.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m279.9 244.6-.5.9.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "m280.9 244.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m281.9 244.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "m301 244.6.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000818",
    d: "m302 244.6.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m304.4 244.6.6.4-.6-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m305 244.6.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314a7b",
    d: "m305.4 244.6.6.4-.6-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "m306 244.6.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m306.4 244.6.6.4-.6-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m307 244.6.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m222.7 245 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m223.2 245 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m223.7 245 .5.5-.5-.5m1 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m225.2 245 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314a7b",
    d: "m225.7 245 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m226.2 245 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m228.2 245 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m229.3 245 .4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m229.8 245 .4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "m248.3 245 1.5 1.5-1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "m248.8 245 3.5 3.4-3.5-3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "m249.3 245 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m253.3 245 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "m253.8 245 1.5 1.5-1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "m254.3 245 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "m274.9 245 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "m275.4 245 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m275.9 245 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "m280.9 245 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m281.4 245 .5.5-.5-.5m5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m301 245 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "m302 245 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m303 245 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "m303.4 245 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m304 245 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m305.8 245.2.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m221.2 245.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m221.7 245.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m223.2 245.5 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m223.7 245.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m224.2 245.5 1.5 1.9-1.5-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m224.7 245.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m225.6 245.7.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m226.2 245.5-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m226.7 245.5 1.5 2.4-1.5-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314a7b",
    d: "m227.2 245.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m227.7 245.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m228.2 245.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "m229.3 245.5.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m229.8 245.5.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m286 245.2.6.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000818",
    d: "m243.3 245.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m243.8 245.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "m249.8 245.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "m253.8 245.5.5.5-.5-.5m1 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m274.4 245.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "m274.9 245.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m279.4 245.5-1 1.4 1-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "m279.9 245.5-1.5 1.9 1.5-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m280.9 245.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m285.4 245.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "m285.9 245.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m286.4 245.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m295 245.8.3.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m297.4 245.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m298 245.5.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m301 245.5.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#080829",
    d: "m301.4 245.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m302 245.5.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "m302.4 245.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m303 245.5 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m303.4 245.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "m305 245.5.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m305.4 245.5.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m221.2 246 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m221.7 246 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m223.2 246 .5.5-.5-.5m3.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m227.6 246.1.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m228.7 246 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m229.3 246 .4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m229.8 246 .4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m230.3 246 .4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m243.3 246 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c7300",
    d: "m243.8 246 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392121",
    d: "m244.3 246 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m244.8 246 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M248.8 246v3.3h.5l-.5-3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "m250.3 246 .5.5-.5-.5m4 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "m255.3 246 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m273.9 246 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "m273.9 247 1.5-.5-1.5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m275.4 246 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "m279.9 246-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b1821",
    d: "m280.4 246 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m284.4 246 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2908",
    d: "m284.9 246 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c7300",
    d: "m285.4 246 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m285.9 246 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m295.4 246-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "m298 246 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m298.4 246 .5.5-.5-.5m2.4.1.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m301.4 246 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m302 246 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "m302.4 246 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m303 246 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "m305 246 .4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m305.4 246 .6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m221.2 246.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m222 246.6.4.2-.3-.2m2 0 .3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m225.7 246.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m226.2 246.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m227.2 246.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m228.2 246.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m228.7 246.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m229.3 246.4.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "m229.8 246.4-1 3.9h-.6l1-3.4h-.4l-.6 3.8 2-1-2.4 3.9 2-1.4-2.6 1.9-.4 2.4h.4l5-5.8-1.4.5v-.5l1.4-.4v-.5h-2l-.4-3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "m230.3 246.4.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#102121",
    d: "m243.8 246.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "m244.3 246.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad8c08",
    d: "m244.8 246.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#102121",
    d: "m245.3 246.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m245.8 246.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M249.3 246.4c0 3.9 2.3 5.6 5.5 7.7-.2-3.2-3-5.7-5.5-7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "m249.8 246.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "m250.8 246.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m254.3 246.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "m255.2 246.6.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m255.8 246.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m273.4 246.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "m274.4 246.4-1 1.5 1-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m274.9 246.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "m279.9 246.4-5 7.7c2.7-1.7 6.5-4.1 5-7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m283.4 246.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b2908",
    d: "m283.9 246.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c7b08",
    d: "m284.4 246.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "m284.9 246.4-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m285.9 246.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "m298 246.4 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m298.4 246.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m300.8 246.6.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "m301.4 246.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "m302 246.4.4 10h.5l1.5-8.5h-.5l-1 5.7h-.5l-.5-7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "m302.4 246.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m303 246.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m304.4 246.4.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m305.4 246.4.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m306.4 246.4.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m307 246.4-.6 1 .6-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m308.5 246.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m221.2 247 1.5 1.4-1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m222.2 247 .5 1.4h.5l-1-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m222.7 247 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m224.2 247 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m224.7 247-.5.9.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m225.7 247 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "m226.2 247 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m226.7 247 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m228.2 247 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m229.4 247.3.2.3-.2-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m230.3 247 .4.4-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m230.8 247 .4.4-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a4208",
    d: "m244.3 247 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "m244.8 247 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9408",
    d: "m245.3 247 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m245.8 247 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "m250.3 247 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "m251.3 247 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "m254.8 247 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "m255.3 247 1 .9-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "m255.8 247 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m265.8 247 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "m273.4 247 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m274.4 247 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m277.9 247 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "m278.9 247-1 1.4 1-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m279.4 247 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m283.4 247 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b5a00",
    d: "m283.9 247 .5.4-.5-.5m1 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m285.4 247 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m295 247 .4.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "m295.4 247 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m296 247 .4.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "m298 247 .4.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m301 247 .4.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m301.4 247 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b8c73",
    d: "m302.4 247 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "m304 247 .4.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "m304.4 247 .6.4-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m307 247 .4.4-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m308 247 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m308.5 247 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m221.2 247.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m224.7 247.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "m225.2 247.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m225.7 247.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m226.2 247.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m226.7 247.4 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m228.2 247.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m230.8 247.4.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m244.3 247.4 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b5a00",
    d: "m244.8 247.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "m245.3 247.4 1.5 1-1.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m246.3 247.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "m250.8 247.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "m251.8 247.4.5.5-.5-.5m3.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m256.3 247.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9408",
    d: "M264.3 247.4v.5l1 1.9h.5l-1.5-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m272.9 247.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311000",
    d: "m273.9 247.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m274.4 247.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m277.4 247.4-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "m277.9 247.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m278.9 247.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m282.9 247.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "m283.4 247.4-1 1.4 1-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "m283.9 247.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b5a00",
    d: "m284.4 247.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m284.9 247.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m295 247.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m295.4 247.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m296 247.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "m298 247.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m298.4 247.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m299 247.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "m301 247.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m301.4 247.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "M302.4 247.4v2.4h.5l-.5-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m303.4 247.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m304.3 247.6.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m305 247.4.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m305.4 247.4.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m306.3 247.6.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m307 247.4-.6 1 .6-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m307.4 247.4.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "m308 247.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m308.5 247.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m220.7 247.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m221.2 247.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m223.2 247.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m224.7 247.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "m225.2 247.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M225.7 247.9v1.4l1.5-.5v-.4l-1.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "m226.7 247.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m227.7 247.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m229 248 .4.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m230.8 247.9.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m245.3 247.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m246.8 247.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m250.8 247.9 1.5 1.4-1.5-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "m251.3 247.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m252.3 247.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "m255.8 247.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "m256.5 248.2.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m256.8 247.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b5a00",
    d: "M263.8 247.9v1.9h.5l-.5-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M264.3 247.9v2.4h-2v1.4h2v5.7h.5l.5-5.7h2.5v-1.4h-2.5v-2.4h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m272.4 247.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "m273.2 248 .3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m273.9 247.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "m277.4 247.9-1.5 1.9 1.5-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m278.4 247.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m282.4 247.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m283.9 247.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m284.4 247.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m295.4 247.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m296 247.9.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m296.4 247.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m298 247.9.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "m298.4 247.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m299 247.9.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "m301 247.9.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "m303.4 247.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m304.4 247.9.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "m305 247.9.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m305.4 247.9.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m306 247.9.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "m307 247.9.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m307.4 247.9.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m308 247.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m221.7 248.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m222.2 248.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m223 248.5.4.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m223.7 248.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "m224.7 248.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M225.2 248.4c-1.3 2.9-1.1 4.7 0 7.6h1l1-7.2h-.5l-.5 5.8h-1v-6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "m227.2 248.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M229 248.7v.3-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "m230.8 248.4.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m245.8 248.4 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#100808",
    d: "m246.3 248.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "m246.8 248.4 2 1.9-2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "m247.3 248.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "m251.8 248.4 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "m252.3 248.4 2 2.3-2-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m252.8 248.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m255.8 248.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "m256.8 248.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311000",
    d: "m272.4 248.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "m272.9 248.4-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m273.4 248.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m276.4 248.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m277.9 248.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m281.9 248.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m283.4 248.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "m295.4 248.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "m296 248.4.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "m296.4 248.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m297 248.4.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m298 248.4.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m298.4 248.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m299 248.4.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m299.4 248.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "m301 248.4.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m303.4 248.4.5.4-.5-.4m1 0 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m305 248.4.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m305.8 248.5.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m306.4 248.4.6.4-.6-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m307 248.4.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m307.4 248.4.6.4-.6-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m308 248.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m224.7 248.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m227.2 248.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m230.8 248.8.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M245.8 248.8v13.4h-4.5v.5l5-.5v2.4h.5c0-4.1 1.6-12.4-1-15.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "m246.8 248.8.5.5-.5-.5m1 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m253.3 248.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m256.3 248.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "m256.8 248.8 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101829",
    d: "m257.3 248.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m271.9 248.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "m272.9 248.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m275.9 248.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m277.4 248.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m280.9 248.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m281.4 248.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "m281.9 248.8-1.5 2 1.5-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "m282.4 248.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m282.9 248.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M283.4 248.8v13.4h.5l-.5-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m295.4 248.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m296.3 249 .3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "m297 248.8.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m298 248.8.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m298.4 248.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "m299 248.8 2 12h.4a15 15 0 0 0-2.5-12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m299.4 248.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m300.4 248.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m301 248.8.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m303.4 248.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m304.4 248.8.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m306.4 248.8.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "m307 248.8.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "m307.4 248.8.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m223.7 249.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m224.2 249.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m225.9 249.6.2.4-.2-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m227.2 249.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m228.6 249.5.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m230.3 249.3.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "m231 249.5.4.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m231.8 249.3.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "m232.3 249.3.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m232.8 249.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m233.3 249.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M246.8 249.3c0 3.6-1.8 13 .5 15.9 1 1.3 3.5 1.4 5 1.8 0-7.3 1.5-13.1-5.5-17.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101829",
    d: "m247.3 249.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#100808",
    d: "m248.3 249.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "m248.8 249.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m252.3 249.3.5.5-.5-.5m1.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "m256.8 249.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m257.8 249.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m271.4 249.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "m271.4 250.3 1.5-1-1.5 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m272.9 249.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m275.4 249.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m276.9 249.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1831",
    d: "m280.4 249.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311000",
    d: "m280.9 249.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "m281.9 249.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M277.4 267c1.6-.4 4-.6 5.2-1.8 2.6-2.6.8-12.4.8-15.9-7.8 3.5-6 10.8-6 17.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m295.4 249.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m296 249.3.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "m296.4 249.3 4 15.3h-.5c-.8-2.7-4-12.9-8-9 5.4.1 7.2 9.2 8 13.3h.5l6.6-19.1h-.6l-5 12.4h-.5c-1.3-4-1.2-9.8-4.5-12.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m297 249.3.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m297.4 249.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m298 249.3.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m298.4 249.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m299.4 249.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m300 249.3.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m300.4 249.3-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m301 249.3.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "m303 249.3.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "m304.4 249.3.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m306 249.3.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m306.8 249.5.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m307.4 249.3.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m223.7 249.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m227.2 249.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m228.2 249.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m229.3 249.8-2 .5v.4l2-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m229.8 249.8.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m232.4 250.1.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "m232.8 249.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m233.3 249.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "m233.8 249.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "m247.8 249.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "m248.8 249.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m249.3 249.8 1 1-1-1m3.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "m253.8 249.8 1.5 1.4-1.5-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m254.3 249.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "m257.6 250 .4.1-.4-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m258.3 249.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m261.3 249.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada584",
    d: "m261.8 249.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c7b08",
    d: "m263.8 249.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cea508",
    d: "m265.3 249.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9463",
    d: "m265.8 249.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdb584",
    d: "M266.3 249.8v.5h1.5l-1.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m267.9 249.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m270.9 249.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m272.4 249.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m274.9 249.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#210800",
    d: "m275.4 249.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "m275.9 249.8-1 1.4 1-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m276.4 249.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m279.9 249.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#100808",
    d: "m280.4 249.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101829",
    d: "m281.4 249.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m293.4 249.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m294 249.8.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "m296 249.8.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "m297.4 249.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m298 249.8.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m298.4 249.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m299.4 249.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "m300.4 249.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "m302.4 249.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m303 249.8.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "m304.4 249.8.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m305.4 249.8.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m306 249.8.4.5-.4-.5m1 0 .4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m307.4 249.8.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "m223.7 250.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M225.7 250.3v1.4h.5l-.5-1.4m3.6 0 .4.4-.4-.4m2.3.1.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m232.8 250.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m233.3 250.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "m248.3 250.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M248.8 250.3v.4l1.5.5-1.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m253.3 250.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m254.8 250.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m257.3 250.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "m257.8 250.3 1.5 1.4-1.5-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "m258.3 250.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9408",
    d: "M261.8 250.3v1.4h.5l-.5-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "m270.9 250.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "m271.4 250.3-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m271.9 250.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m274.4 250.3-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311000",
    d: "m274.9 250.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "m275.9 250.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m279.4 250.3-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "m279.9 250.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "m280.9 250.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "m294 250.3.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m294.4 250.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m296 250.3.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m297.4 250.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m298 250.3.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "m298.4 250.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m300 250.3.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m300.4 250.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M302.4 250.3v2.8h.5l-.5-2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m303 250.3.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m304.4 250.3.6.4-.6-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m305.4 250.3.6.4-.6-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m306 250.3.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "m307 250.3.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m223.7 250.8.5.4-.5-.4m4 0 .5.4-.5-.4m1 0 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m230.8 250.8.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m231.3 250.8.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m232.3 250.8.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m232.8 250.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m248.8 250.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "m250.3 250.8 1 .9-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m253.8 250.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "m254.3 250.8 4 3.8-4-3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "m257.8 250.8.5.4-.5-.4m1 0 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m270.4 250.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311000",
    d: "m271.4 250.8.5.4-.5-.4m3 0 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "m275.4 250.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "m278.9 251.7 1.5-.5-1.5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "m280.4 250.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m294 250.8.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m294.4 250.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m296 250.8.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m296.4 250.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295210",
    d: "m298 250.8.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "m298.4 250.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m300 250.8.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m300.4 250.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m304 250.8.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m304.4 250.8.6.4-.6-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m305 250.8.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m305.4 250.8.6.4-.6-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m306.4 250.8.6.4-.6-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m307 250.8.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m223.2 251.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m223.7 251.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m227.7 251.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m228.2 251.2-.5 1.5h.5v-1.5m2 0-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m231.8 251.2.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m232.3 251.2.4.5-.4-.5m2 0 .4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m249.3 251.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "m250.3 251.2 2 2-2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "m254.3 251.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "m255.3 251.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "m258.3 251.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m259.3 251.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m269.9 251.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "m269.9 252.2 1.5-.5-1.5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m271.4 251.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "m273.9 251.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#422100",
    d: "m274.4 251.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101829",
    d: "m274.9 251.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "m278.4 251.2-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "m279.4 251.2-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m279.9 251.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#426331",
    d: "m294 251.2.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m294.4 251.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m295 251.2.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m296.4 251.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m298 251.2.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "m298.4 251.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m300.4 251.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m304 251.2.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m304.4 251.2.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m305 251.2.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m305.4 251.2.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "m306.4 251.2.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m223.4 252 .2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m225.7 251.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m227.4 252 .2.3-.2-.3m.8-.3.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m231.8 251.7.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "m234.3 251.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m234.8 251.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m238.8 251.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "m239.3 251.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m239.8 251.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "m250.3 251.7.5.5-.5-.5m1 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "m254.8 251.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "m255.8 251.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m258.3 251.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "m259.2 251.9.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m261.3 251.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada584",
    d: "m261.8 251.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c7b08",
    d: "m263.8 251.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cea508",
    d: "m265.3 251.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9463",
    d: "m265.8 251.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m267.9 251.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m269.4 251.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "m270.4 251.7-1 1.4 1-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m270.9 251.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m273.4 251.7-1 1.4 1-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "m273.9 251.7-1 1.4 1-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "m274.4 251.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "m278.4 251.7-1.5 1.9 1.5-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m279.4 251.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "m294 251.7.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m294.4 251.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "m295 251.7.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "m296.4 251.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m298.4 251.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m300.4 251.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m301 251.7-.6 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m304 251.7.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m304.4 251.7.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m305 251.7.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m306 251.7.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m306.4 251.7.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m308 251.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "m308.5 251.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m309 251.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m309.5 251.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M225.2 252.2v2.4h1v-2.4h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m229.3 252.2.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m231.3 252.2.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m231.8 252.2.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m233.8 252.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m234.3 252.2 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m234.8 252.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m237.8 252.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "m238.3 252.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m238.8 252.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "m239.3 252.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m239.8 252.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "m250.8 252.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "m251.8 252.2 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m252.3 252.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "m255.3 252.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "m256.3 252.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m258.8 252.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "m259.3 252.2 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "m259.8 252.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b5a00",
    d: "M263.8 252.2v5.2h.5l-.5-5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "m269.4 252.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m270.4 252.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "m273.9 252.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314a7b",
    d: "m274.4 252.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "m277.4 252.2.5.5-.5-.5m1 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m294 252.2.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "m294.4 252.2 2.5 4.3h.5l-3-4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m295 252.2.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m295.4 252.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m296.4 252.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m297 252.2.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m298.4 252.2 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m299 252.2.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m301 252.2.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m304 252.2.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m304.4 252.2.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m305 252.2.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m306 252.2.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m306.4 252.2.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m307.4 252.2.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m308 252.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "m305.4 255.5 5-1.4-1-2-4 3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m309.5 252.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m310 252.2.5.5-.5-.5m-86.8.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m223.7 252.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m227.4 253 .2.3-.2-.3m1.3-.4.6.5-.6-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m229.3 252.7.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m231.3 252.7.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m233.8 252.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m234.3 252.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m235.3 252.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m237.3 252.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m237.8 252.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M236.3 259.8h-.5v-5.2h-.5l-.5 2.4h-.5v-2.4h-.5l-3 11h.4l1-2h.5l-1 2.4h.5l2.5-3.3-2 4.3h.5l5.1-7.2 1-7.1c-3.3 1.5-3 4-3 7.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m239.3 252.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "m251.3 252.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m252.8 252.7 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m255.3 252.7 1.5 1.4-1.5-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "m255.8 252.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "m256.8 252.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101829",
    d: "m259.3 252.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m260.3 252.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#210800",
    d: "m268.9 252.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m270.4 252.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "m273.4 252.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m273.9 252.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m276.4 252.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "m276.9 252.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "m277.9 252.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m294 253 .2.3-.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m294.4 252.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "m295.4 252.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m296 252.7.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m296.4 252.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m297 252.7.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m298.4 252.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m301 252.7.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "m304 252.7.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m304.4 252.7.6.4-.6-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m306 252.7.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m307 252.7-1 1.4 1-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m307.4 252.7.6.4-.6-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m310 252.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "m223.7 253.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m228.2 253.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m228.7 253.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m230.8 253.1.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m231.3 253.1-.6 1 .6-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m233.8 253.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "m234.6 253.3.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m235.3 253.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m236.8 253.1-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m237.3 253.1.5.5-.5-.5m1.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m239.3 253.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m251.8 253.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "m252.6 253.3.4.1-.4-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "m256.3 253.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "m257.3 253.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "m259.8 253.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "m260.5 253.4.2.4-.2-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m260.8 253.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m268.4 253.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m269.9 253.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m271.9 253.1-1 1.5 1-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "m272.4 253.1-2.5 2.9 2.5-2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212118",
    d: "m272.9 253.1-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m273.4 253.1-1 1.5 1-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m275.9 253.1-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "m276.4 253.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "m277.4 253.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m293 253.1.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m293.4 253.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m294.4 253.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m295.4 253.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "m296 253.1.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "m297 253.1.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M299 253.1v1.5h.4l-.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m301.3 253.3.3.1-.3-.1m1.1-.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "m304 253.1.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m304.4 253.1.6.5-.6-.5m1 0 .6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m306 253.1.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m307 253.1.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m310 253.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m310.5 253.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "m223.7 253.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M226.7 253.6v.5h1.5l-1.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m228.2 253.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m229.8 253.6.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "m230.3 253.6.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m233.3 253.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m233.8 253.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M233.8 254v.6l1.5.4v-1.4l-1.5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "m235.3 253.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m236.8 253.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m238.6 253.8.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m239.3 253.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "m252.3 253.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212118",
    d: "m252.8 253.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "m253.3 253.6 2 2-2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "m253.8 253.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "m256.8 253.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "m257.8 253.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m259.8 253.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211810",
    d: "m260.8 253.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m261.3 253.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "m268.4 253.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "m268.9 253.6-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m269.4 253.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "m276.2 253.8.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "m276.9 253.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m292.4 253.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m293 253.6.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m293.4 253.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295210",
    d: "m294 253.6.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m294.4 253.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m296 253.6.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m296.4 253.6 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m297 253.6.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m301.4 253.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m303.4 253.6 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m304 253.6.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m305.4 253.6.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m306.4 253.6.6.5-.6-.5m1 0-3 2v.4l1 .5 2-2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m308 253.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "m308.5 253.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m309 253.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m309.5 253.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "m310.5 253.6-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m223.7 254 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m224.2 254 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m226.7 254 .5.6-.5-.5m1 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m228.7 254-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "m229.3 254 .4.6-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m229.8 254 .4.6-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m233.3 254 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m235.3 254 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "m235.8 254 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m236.3 254 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m238 254.4.1.3-.2-.3m.9-.3v3.3h.5l-.5-3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    fillOpacity: 0.5,
    d: "M252.3 254v13h.5l-.5-13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m252.8 254 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211810",
    d: "m253.3 254 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "m254.3 254 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m256.8 254 1.5 1.5-1.5-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212118",
    d: "m257.3 254 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "m258.3 254 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "m260.3 254 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "m260.8 254 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "m261.3 254 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m267.9 254 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "m268.9 254 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "m274.9 254 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "m275.4 254-1.5 2 1.5-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212118",
    d: "m275.9 254 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m276.4 254 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M276.9 254v13h.5l-.5-13m15 0 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m292.4 254 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m294.4 254 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m295 254 .4.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m296.4 254 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m297.4 254 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m301.4 254 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m302 254-.6 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m303.4 254 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m307.4 254-1 1.5 1-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m308 254-1.5 2 1.5-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m309.5 254 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m310.5 254 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m311 254 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m224.2 254.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m226.7 254.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m227.2 254.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m228.7 254.6-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m229.3 254.6.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m229.8 254.6.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m230.3 254.6.4.4-.4-.4m2.4 0 .6.4-.6-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m233.3 254.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m253.3 254.6 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "m253.8 254.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254.8 254.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m255.3 254.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212118",
    d: "m257.8 254.6 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "m258.3 254.6 2 2.3-2-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m258.8 254.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M260.3 254.6v1.4h.5l-.5-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "m260.8 254.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m261.8 254.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m267.4 254.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "m268 254.9.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211810",
    d: "m268.4 254.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m270.4 254.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m271.9 254.6-1 1.4 1-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m273.9 254.6-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "m274.4 254.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211810",
    d: "m275.4 254.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m275.9 254.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m291.4 254.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m292 254.6.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m295 254.6 1.4 1.4-1.5-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m295.4 254.6.5.4-.5-.4m1 0 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m297 254.6.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m297.4 254.6.5.4-.5-.4m1.5 0 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m299.4 254.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m302 254.6.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m303.4 254.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m305 254.6.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m310.5 254.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m311 254.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m224.2 255 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m224.7 255 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m226.6 255.2.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m227.7 255 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "m229.3 255 .4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m229.8 255 .4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "m230.3 255 .4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m230.8 255 .4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m231.3 255 .4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m232.8 255 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m234.3 255 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M235.8 255v4.3h.5l-.5-4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m237.6 255.2.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "m254.3 255 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211810",
    d: "m255.3 255 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m255.8 255 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m259.3 255 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m260.8 255 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392121",
    d: "m261.3 255 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "m261.8 255 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m262.3 255 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m266.9 255 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211810",
    d: "m267.4 255 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m268.4 255 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m269.9 255 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "m273.9 255 .5.5-.5-.5m1 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m275.4 255-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "m291.4 255 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m292.4 255 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m293 255 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m293.4 255 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m296 255 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m297 255 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m297.4 255 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m299.3 255.2.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m302 255 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m303 255 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m303.4 255 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m305 255 .4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m308.1 255.4.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m224.7 255.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m226.4 255.8.2.4-.2-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m227.7 255.5.5.5-.5-.5m1.7.3.2.4-.2-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m230 255.7.4.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "m230.8 255.5.4 4.3h.6l-1-4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "m231.3 255.5.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m231.8 255.5.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m232.3 255.5.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m254.8 255.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "m255.3 255.5 1.5 1v-.5l-1.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212118",
    d: "m255.8 255.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m258.3 255.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m259.8 255.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m261.3 255.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "m261.8 255.5 1.5 1.5-1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "m262.3 255.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m262.8 255.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "m266.9 255.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "m267.4 255.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m267.9 255.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m269.4 255.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m272.9 255.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211810",
    d: "m273.4 255.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "m274.4 255.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m291 255.5.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m291.4 255.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m292 255.5.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m292.4 255.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m293 255.5.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m293.4 255.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m294 255.5.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m295.4 255.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m297.4 255.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m299 255.5.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m299.4 255.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m302 255.5.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m303 255.5.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m305 255.5.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "m306 255.5.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m307 255.5.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "m307.4 255.5.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "m222.7 256 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m223.2 256 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m224.7 256 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "m225.2 256 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m225.7 256 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "m227.2 256 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M229.8 256c-.2 2.5-.7 4.8 2 6.2l-2-6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m230.4 256.3.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m231.8 256 .4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "m232.3 256 .4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m255.3 256 .5.5-.5-.5m1.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m258.8 256 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "m259.8 256 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "m260.3 256 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "m261.8 256 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m262.8 256 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m266.3 256 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "m266.9 256 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m267.4 256 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m267.9 256 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m268.4 256-.5 1.4.5-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m268.9 256 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#210800",
    d: "m269.4 256 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "m269.9 256-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m270.4 256 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m272.4 256 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212118",
    d: "m272.9 256 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "m273.4 256-1 1.4 1-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m273.9 256 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m290.4 256 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m291.2 256.1.4.2-.4-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m292 256 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m294 256 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m294.4 256 .5.5-.5-.5m1.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m296.4 256 .5.5-.5-.5m1 0 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m298 256 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m299.4 256 .5.5-.5-.5m2.5 0 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m303 256 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m304.4 256 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m305.4 256 .6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m306 256-.6 1 .6-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m306.4 256 .6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m307 256 .4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "m307.4 256 .6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m310 256 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m310.5 256 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m222.7 256.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m223.7 256.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1010",
    d: "m224.7 256.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m225.2 256.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m225.7 256.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311000",
    d: "m226.2 256.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m226.7 256.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m227.2 256.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "m229.3 256.5.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m232.3 256.5-.6 1 .6-1m2 0 .4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m255.8 256.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212118",
    d: "m256.3 256.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "m256.8 256.5 2 1.9-2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m257.3 256.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m259 256.8.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "m259.3 256.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m260.8 256.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m261.8 256.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392121",
    d: "m262.3 256.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m263.3 256.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c7b08",
    d: "m265.3 256.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "m265.8 256.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m266.3 256.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m266.9 256.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m268.9 256.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m270.5 256.8.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m271.9 256.5.5.5-.5-.5m1.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m290.4 256.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m291 256.5.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m291.4 256.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "m294.4 256.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m295 256.5.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m296.4 256.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m296.4 257.4 1.5-.4-1.5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m299.4 256.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M302 256.5v1.4h.4l-.5-1.4m1 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m304.4 256.5-.4 1.4.4-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m306 256.5.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m306.4 256.5-.4 1 .4-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m307 256.5.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m307.4 256.5.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m309 256.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "m309.5 256.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "m310 256.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m310.5 256.5-1 1.4 1-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m222.7 257 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m223.2 257 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m223.7 257 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m224.2 257 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m224.7 257 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m226.2 257 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "m226.7 257 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "m229.3 257 .4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m230.6 257.1.3.2-.3-.2m1.7-.2.4.5-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m233.8 257 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#524242",
    d: "m256.3 257 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#210800",
    d: "m256.8 257 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "m257.8 257 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m258.3 257 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m259.5 257.3.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m259.8 257 1 .9-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "m260.3 257 1 .9-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211810",
    d: "m260.8 257 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m261.3 257 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m262.3 257-.5.9.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "m262.8 257 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212118",
    d: "m263.3 257 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b5a10",
    d: "m264.8 257 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m265.3 257 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m266.3 257 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m266.9 257 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m267.4 257 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m268.4 257 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "m268.9 257 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "m270 257.3.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m271.4 257 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "m271.9 257-1.5 1.8 1.5-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#524242",
    d: "m272.9 257 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m290.4 257 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m293 257 .4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m293.4 257 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m294.4 257-.5.9.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m295 257 .4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m297 257 .4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "m297.4 257 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m298 257-.6 1.4.5-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m299.4 257 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "m302.4 257 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m304 257 .4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m305.1 257.3.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m305.4 257 .6.4-.6-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "m306.4 257-3.5 5.2 3.6-5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "m307 257 .4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m308 257 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m308.5 257 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m309 257 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m309.5 257 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M222.7 257.4v1l1-1h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "m223.7 257.4 1 2-1.5-1c.5 2 1 3 3 3.8v.5l-2-.5 1 1.4-1.5-.5 4.5 4.3.5-1.9 1.5 1-3-2.9v-.5l1.5.5a8.8 8.8 0 0 0-5-6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m224.2 257.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m224.7 257.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m225.2 257.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m226.2 257.4 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m226.7 257.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m227.2 257.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m229.3 257.4.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m230.8 257.4.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M231.8 257.4v4.3h.4l-.4-4.3m2.1.4.2.3-.2-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m237.3 257.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#527b31",
    d: "m238.8 257.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    fillOpacity: 0.6,
    d: "M256.3 257.4V268h.5l-.5-10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m256.8 257.4 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311000",
    d: "m257.3 257.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "m258.3 257.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m258.8 257.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M259.8 257.4v1h1l-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "m261.3 257.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m262.3 257.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "m262.8 257.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392121",
    d: "m263.3 257.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#423100",
    d: "m263.8 257.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "m264.3 257.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m264.8 257.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m265.3 257.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m265.8 257.4-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m266.3 257.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m268.9 257.4-2 1v.5l2.5-1-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m270.4 257.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "m270.9 257.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#210800",
    d: "m271.9 257.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m272.4 257.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "m272.9 257.4-.5 11h.5a19 19 0 0 0 0-11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m293.4 257.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m295 257.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m295.4 257.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m297 257.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m297.4 257.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m299.8 257.6.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m302.4 257.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "m304.4 257.4.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m305.4 257.4.6.5-.6-.5m1 0 .6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m307 257.4.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m307.4 257.4.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m308 257.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m308.5 257.4-1 .5v.5l1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "m309 257.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m223.2 257.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m223.7 257.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293100",
    d: "m225.2 257.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311000",
    d: "m225.7 257.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m226.2 257.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m227.2 257.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2121",
    d: "m227.7 257.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m228.2 257.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m228.7 257.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m229.3 257.9.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m237.1 258 .3.2-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "m238.8 257.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M256.8 257.9v10l5.5 1c-1.2-3.6-1.9-9-5.5-11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m257.8 257.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#100808",
    d: "m258.8 257.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m259.3 257.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "m260.8 257.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#524242",
    d: "m261.3 257.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m262 258.2.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m263.8 257.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m264.5 258.2.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m264.8 257.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m266.9 257.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m268.9 257.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#100808",
    d: "m269.4 257.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m269.9 257.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "m270.4 257.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311000",
    d: "m271.4 257.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m271.9 257.9-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "m272.4 257.9-2 1.4 2 6.2-3.5 1 .5 1.9 3.5-.5-.5-10z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m293.4 257.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m294 257.9.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "m295.4 257.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m298 257.9.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m298.4 257.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M300 257.9v1.4h.4l-.5-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m302 257.9.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m302.4 257.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "m304 257.9.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m304.4 257.9.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m305 257.9.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#102110",
    d: "m306.4 257.9.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m307 257.9.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M308 258.4v.5h1.5l-1.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#426331",
    d: "m222.7 258.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m223.7 258.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m224.2 258.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m225.7 258.4 1.5 1.4-1.5-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "m226.2 258.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M228 258.7v.3-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m228.4 258.7.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m228.7 258.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m229.3 258.4.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m233.8 258.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "m238.8 258.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m258.3 258.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "m258.8 258.4 1 1v-1h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m259.8 258.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2121",
    d: "m260.3 258.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m261 258.7.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M262.3 258.4v.5h1.5l-1.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m263.8 258.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m265.8 258.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m266.3 258.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m267.4 258.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "m269.4 258.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "m269.9 258.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m270.9 258.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "m293.4 258.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m294 258.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m294.4 258.4.5.5-.5-.5m1.2.3.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m296 258.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m297.4 258.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "m298 258.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m298.4 258.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m302.1 258.7.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m303.4 258.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m304 258.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m304.4 258.4.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m306 258.4.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m306.4 258.4.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "m307 258.4-.6 1 .6-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m307.4 258.4.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m308.5 258.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m309.5 258.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "m222.7 258.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m224.2 258.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m226.7 258.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m228.7 258.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m233.6 259 .3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m238.8 258.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m258.8 258.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m259.8 258.9 2.5 9.5c3-1 7.8-1.5 9.6-4.3l-9 2.9-3-8.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m260.3 258.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m261.3 258.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m261.8 258.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m264.3 258.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m264.8 258.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m266.3 258.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m268 259.2.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m268.4 258.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m269.2 259 .3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m269.9 258.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m270.4 258.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "m293.4 258.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "m294 258.9 4 15.2h-.6v-1h-.5l.5 4.4h-.5v-1h-.5v3.8h-.5c0-4.8-2-9.2-4.5-13.3l-1 1v.4c3.7 3.5 4.8 11 5 15.7h-1l-2-10h-.5l1.5 13.4h-.5l-2-10h-.5l1.5 15.2h-.5l-1-12.4h-.5l1 12.4h-.5l-.5-6.6h-.5l.5 8h-.5l-.5-6.6h-.5l-1.5 9 5.5-.4v-.5l-3.5-.5v-.5l13 3.4v-.5l-6-1.9v-.5l9 2c-2.8-3.5-6.4-3-10.5-2.5v-.4l11.6.4v-.4l-8-2v-.4l8 .4v-.4c-5.8-1.3-8.7-.6-13 3.3l1-4.8h-.6l-.5 1.5h-.5l2.5-7.2h.5l-.5 5.3 11.6-4.3v-.5l-10.6 2.9c4-3.2 9.9-5.8 15-6.2v-.5a21 21 0 0 0-14 4.7c3.8-4.6 9.7-5.1 15-7.1v-.5c-6.7.5-10 2-15.5 5.7 3.4-3.2 9.2-8.8 14.6-7.6l-1-2.4a27 27 0 0 0-12 6.7c2.3-3.1 10.5-11.8 14.5-11.5-4-3.5-11.9 7.3-14.6 9.6l11-12-9.5 8.2 10.6-13.4v-.5c-5 1.8-6.5 7.7-10 11l7.5-12a19.4 19.4 0 0 0-7 10.6c-2.4.3-1.6 3.9-1.6 5.7h-.5c0-5.8-.7-12.8-4.5-17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m294.4 258.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m295 258.9.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "m296 258.9.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m298 258.9.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m298.4 258.9.5.4-.5-.4m5 0 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m304 258.9.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m304.4 258.9.6.4-.6-.4m1 0 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m306 258.9.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m307 258.9-3 2.3v.5l3-2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m307.4 258.9-.4 1 .4-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m308 258.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#102110",
    d: "m308.5 258.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m309 258.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m222.7 259.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m223.2 259.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m224.7 259.3 1.5 1.5-1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m227.2 259.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733939",
    d: "m227.7 259.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m228.2 259.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m228.7 259.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m230.8 259.3 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m233.3 259.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m235.8 259.3.5.5-.5-.5m2.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m238.8 259.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#100808",
    d: "m259.3 259.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m260.3 259.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m262.3 259.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M262.8 259.3v.5h1.5l-1.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m264.3 259.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m266.3 259.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m267.2 259.5.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m268.4 259.3.5.5-.5-.5m1 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#210800",
    d: "m269.9 259.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m292.4 259.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m293 259.3.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m293.4 259.3-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m294.4 259.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m295 259.3.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "m295.4 259.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m296 259.3.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m296.4 259.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m298 259.3.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "m298.4 259.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m300 259.3 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m300.4 259.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m301.8 259.5.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#102110",
    d: "m303.4 259.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m304 259.3.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m305.4 259.3.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m307.4 259.3.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m308 259.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m308.5 259.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m222.7 259.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m223.2 259.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m227.2 259.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m227.7 259.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m228.7 259.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m229.3 259.8.4.5-.4-.5m1.4 0 .6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m233.3 259.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m235.3 259.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m236.6 260 .3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "m238.3 259.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "m259.3 259.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "m260.3 259.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m261.3 259.8-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m261.8 259.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m262.3 259.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m266.2 260 .3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m266.9 259.8 1 2.9h.5l-1.5-2.9m1.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m269 260.1.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m269.4 259.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "m269.9 259.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m270.4 259.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m292.4 259.8.5.5-.5-.5m1 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m294 259.8.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "m295 259.8.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m295.4 259.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m296 259.8.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "m296.4 259.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m297 259.8.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m298.4 259.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m300 259.8.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m301.4 259.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m303 259.8 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m303.4 259.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m305 259.8.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "m306.4 259.8.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m307 259.8.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m307.4 259.8.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "m308 259.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m308.5 259.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m223.2 260.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m227.7 260.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m228.7 260.3-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "m229.3 260.3.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m233.3 260.3.5.5-.5-.5m1 1 1.5-.5-1.5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m236.3 260.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m238.3 260.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m259.3 260.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m261.3 260.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m262.8 260.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m263.3 260.3.5.5-.5-.5m1.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m265.3 260.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m267.4 260.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m268.2 260.4.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m269.4 260.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m269.9 260.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m270.4 260.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m292.4 260.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "m293 260.3.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m293.4 260.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m294 260.3.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m295 260.3.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "m295.4 260.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m296 260.3.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m296.4 260.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m297 260.3.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m298.8 260.4.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m300.4 260.3.5.5-.5-.5m1 0 .5.5-.5-.5m1.5 0 .5.5-.5-.5m2 0 .6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m306 260.3.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m306.4 260.3.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m307.4 260.3.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m308 260.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m222.7 260.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m223.2 260.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m223.7 260.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "m226.2 260.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m227.7 260.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m229.3 260.8.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m229.8 260.8.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m234.8 260.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "m235.3 260.8-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m235.8 260.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m236.3 260.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "m237.8 260.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m238.3 260.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m259.3 260.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m260.8 260.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m261.8 260.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M262.7 261h.3-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m263.3 260.8 1.5 1.4-1.5-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m265.3 260.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m265.8 260.8 1 1.4-1-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M266.7 261h.3-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m269.4 260.8 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m269.9 260.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#210800",
    d: "m270.4 260.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "m293 260.8.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m293.4 260.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m294 260.8.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m295 260.8.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "m295.4 260.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "m296 260.8.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "m296.4 260.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m297 260.8.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m299 260.8.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m300.4 260.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m301.4 260.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m302.4 260.8 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m303 260.8.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m304.4 260.8.6.4-.6-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "m305.4 260.8-.4 1 .4-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m306 260.8.4.4-.4-.4m1 0-.6 1 .6-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m307.4 260.8.6.4-.6-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m308 260.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m308.5 260.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "m309 260.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c9c84",
    d: "m309.5 260.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m310 260.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m310.5 260.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "m222.7 261.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m223.2 261.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m223.7 261.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m226.2 261.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m226.7 261.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m228.2 261.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m229.8 261.2.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m234.3 261.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m235.3 261.2-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m235.8 261.2.5.5-.5-.5m1.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m237.8 261.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "m259.8 261.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "m260.8 261.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m261.3 261.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m261.8 261.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m264.3 261.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m264.8 261.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m265.3 261.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m266.3 261.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M267.9 261.2v.5h1.5l-1.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m269.4 261.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "m270.4 261.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m270.9 261.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "m293 261.2.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "m293.4 261.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "m294 261.2.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m295.4 261.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m295.4 262.2 1.5-.5-1.5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "m297 261.2.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m297.4 261.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m299 261.2 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m299.4 261.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m302.4 261.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m305.4 261.2.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m307 261.2.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m307.4 261.2.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m308 261.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m308.5 261.2.5.5-.5-.5m1.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m310.5 261.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m311 261.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m311.5 261.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m312.1 261.6.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m222.7 261.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "m223.2 261.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m223.7 261.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m224.2 261.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m224.7 261.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m226.7 261.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m227.4 262 .2.4-.2-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "m228.2 261.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m229.8 261.7.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m230.3 261.7.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m231.8 261.7.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m233.8 261.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m235.3 261.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m236.8 261.7-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m237.3 261.7-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m259.8 261.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m261.3 261.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m262.3 261.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m263.2 261.9.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m263.8 261.7.5.5-.5-.5m1.9.2.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m266.9 261.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m267.4 261.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m270.4 261.7-2 .5v.5l2.5-.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m270.9 261.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m293 261.7.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m293.4 261.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "m294 261.7.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m296 261.7.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "m296.4 261.7 2 8.1h.5c0-2.9-.4-5.8-2.5-8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m297 261.7.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m297.4 261.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m299 261.7.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m301 261.7.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m302.4 261.7.5.5-.5-.5m1.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m304.4 261.7.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m305 261.7.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m306.4 261.7.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m307 261.7.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m307.4 261.7.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m309 261.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m309.5 261.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m310 261.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295210",
    d: "m310.5 261.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "m311 261.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "m311.5 261.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m222.7 262.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m223.2 262.2 1.5 1-1.5-1m1.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m225.2 262.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m225.7 262.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m228.2 262.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m228.7 262.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m230.3 262.2.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M230.8 262.2v.5h1.4l-1.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m233.3 262.2.5.5-.5-.5m1.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "m245.8 262.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m259.8 262.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m261.3 262.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m261.8 262.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m262.3 262.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m263 262.5.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m265 262.5.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m265.5 262.5.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m266 262.5.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m266.3 262.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m266.9 262.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m270.4 262.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#210800",
    d: "m270.9 262.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "m283.4 262.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M283.9 262.2v.5h4.5l-4.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "m288.4 262.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m291.4 262.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m293 262.2.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m293.4 262.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "m294 262.2.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m296 262.2.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m297 262.2.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "m297.4 262.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m298 262.2.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m299.6 262.5.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m302 262.2.4.5-.5-.5m1.5 0 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m304 262.2.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m304.4 262.2.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m306 262.2.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m306.4 262.2.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m307 262.2-.6 1 .6-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m307.4 262.2.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m308.5 262.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m309 262.2-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "m223.2 262.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m226.6 262.8.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m228.7 262.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m230.8 262.7.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m231.3 262.7.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m232.8 262.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m233.3 262.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m234.3 262.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m235.8 262.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m236.3 262.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m240.8 262.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    fillOpacity: 0.3,
    d: "M241.3 262.7v.5h4.5v7.1c2.7-4.3.2-7.6-4.5-7.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m245.8 262.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "m260.3 262.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "m261.3 262.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M262.3 263.1v.5l2.5-.5h-2.5m5-.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m267.9 262.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m268.4 262.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "m270.9 262.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m271.4 262.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m283.4 262.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M283.9 262.7v.5h4.5l-4.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m288.4 262.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "m291.4 262.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m292 262.7.4.5-.5-.5m1.2.3.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m293.4 263.6 1.5-.5-1.5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m296 262.7 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m296.4 262.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m297.4 262.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m298 262.7.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m302 262.7.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "m302.4 262.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m303 262.7.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m306 262.7.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m307 262.7.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m308 262.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m223.2 263.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m224.2 263.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m224.7 263.1.5.5-.5-.5m2.9.2.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "m228.7 263.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m230.8 263.1.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "m231.3 263.1.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m232.8 263.1.5.5-.5-.5m1 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m234.3 263.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m235.3 263.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m235.8 263.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M240.8 263.1v3.9h.5l-.5-3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m260.3 263.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m261.8 263.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m263.3 263.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m265.3 263.1 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m265.8 263.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m266.7 263.3.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m267.4 263.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m268.4 263.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m268.9 263.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m269.7 263.3.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m270.4 263.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m270.9 263.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m271.4 263.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M283.4 263.1v6.2h.5l-.5-6.2m5 0v7.2h.5l-.5-7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "m291.4 263.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "m292 263.1.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "m294 263.1 2.4 8.6h.5l-3-8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m294.4 263.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m296 263.1.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m298.1 263.5.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m299.4 263.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m300 263.1-.6 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m301.4 263.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m302.8 263.3.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m303.4 263.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m305.4 263.1.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m306 263.1.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m306.4 263.1.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m308 263.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m223.2 263.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "m223.7 263.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m225.2 263.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m225.9 264 .2.3-.2-.4m1.8-.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m228.2 263.6 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "m228.7 263.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m230.8 263.6.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m231.3 263.6.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m232.3 263.6.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m233.3 263.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m233.8 263.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "m234.8 263.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m235.3 263.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m260.3 263.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m261.8 263.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m263.3 263.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m263.8 263.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M264.3 263.6v.5h1.5l-1.5-.5m2 0-1.5 1v.5l1.5-1.5m1.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m268.4 263.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m268.9 263.6.5.5-.5-.5m2 0-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#210800",
    d: "m271.4 263.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m291.4 263.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m292 264 .2.3-.1-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m292.4 263.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m293.4 263.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m294.4 263.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m295 263.6-.6 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m296.4 263.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m298.4 263.6-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m300.1 264 .2.3-.2-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m301.4 263.6.5.5-.5-.5m1 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m303.4 263.6.5.5-.5-.5m2 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m306 263.6.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m307.4 263.6.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m308 263.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m309.9 266-2 3.3c1.3-1 2.6-1.8 2-3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m313 263.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m223.7 264.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m224.2 264.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m226.2 264.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m229.3 264.1.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m230.8 264.1.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m231.8 264.1.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m232.3 264.1.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m233.3 264.1.5.5-.5-.5m1 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m234.8 264.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m236.6 264.3.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "m260.8 264.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "m261.8 264.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m262.8 264.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m263.3 264.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m263.8 264.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m267.4 264.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m267.9 264.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m270.9 264.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m271.9 264.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m291.4 264.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m292.4 264.1-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m293 264.1.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m293.6 264.4.1.3-.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m295 264.1.4.5-.5-.5m1.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m297 264.1.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m298.4 264.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m301 264.1.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m301.4 264.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m302 264.1.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m303 264.1.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m305.4 264.1.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m307 264.1.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m307.4 264.1.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m312 264.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "m312.5 264.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m224.2 264.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m226.7 264.6 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m227.2 264.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "m229.3 264.6.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m230 264.7.4.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m230.8 264.6.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m231.8 264.6.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m232.8 264.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m233.3 264.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m234.3 264.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "m236.3 264.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m236.8 264.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m246.3 264.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m260.8 264.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m262.3 264.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m264.3 264.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m266.3 264.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m266.9 264.6.5.5-.5-.5m1.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "m268.9 264.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "m269.4 264.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m271.9 264.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M292.4 264.6 296 276h.5c0-4-1.3-8.3-4-11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m293 264.6.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m295 264.6.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m297 264.6.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m298.6 264.9.2.3-.2-.3m2.3-.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "m301.4 264.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m302 264.6.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m303 264.6.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m305 264.6.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "m307 264.6.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m307.4 264.6.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m308.5 264.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m309 264.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m311 264.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m311.5 264.6-1 1.9 1-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "m312 264.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m224.2 265 1.5 1.5-1.5-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m224.7 265 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m227.7 265 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m229.8 265 .4.5-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m230.3 265 .4.5-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m231.3 265 .4.5-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m231.8 265 .4.5-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m232.8 265 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m233.8 265 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m234.3 265 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m235.8 265 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "m236.8 265 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101829",
    d: "m246.3 265 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m260.8 265 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m262.3 265 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m263 265.4.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m263.3 265 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m263.8 265 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m264.3 265 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m266.9 265 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m267.4 265 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "m267.9 265 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#210800",
    d: "m271.4 265 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m271.9 265 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "m282.9 265 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "m292 265.4.2.3-.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m293 265 .4.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m293.6 265.4.1.3-.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m295.3 265.2.3.2-.4-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m297 265 .4.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m301.3 265.2.3.2-.3-.2m1.1-.1.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m304.4 265 .6.5-.6-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m306.4 265 .6.5-.6-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m307 265 .4.5-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m307.4 265 .6.5-.6-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m308 265 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "m308.5 265 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m309 265 .5.5-.5-.4m1 0 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m310.5 265 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m311 265 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m218.7 265.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m219.2 265.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m225.2 265.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m225.7 265.5 1 1-1-1m3 0 .5.5-.5-.5m1 0 .6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m230.3 265.5.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m230.8 265.5.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "m231.3 265.5.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M232.3 265.5v1h1l-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m232.8 265.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "m233.8 265.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m235.3 265.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m236.8 265.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m237.3 265.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m246.3 265.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m246.8 265.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "m247.3 265.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "m261.3 265.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "m262.3 265.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m263.3 265.5.5.5-.5-.5m1.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m265.3 265.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m266.2 265.7.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "m266.9 265.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "m267.4 265.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "m269.9 265.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m270.4 265.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m281.9 265.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "m282.4 265.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m282.9 265.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m294 265.5-.6 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m295.4 265.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m297 265.5 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m297.4 265.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m298.4 265.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m299 265.5-.6 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m300.6 265.9.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m301.4 265.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "m302 265.5.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m302.4 265.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m304.3 265.7.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m306.4 265.5.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m307 265.5.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m307.8 265.7.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m308.5 265.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m309.5 265.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m310 265.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m310.5 265.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c9c84",
    d: "m218.7 266 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m219.2 266 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m225.7 266 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "m228.7 266 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m229.3 266 .4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "m230.3 266 .4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m231 266.2.4.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311000",
    d: "m231.8 266 .4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m233.8 266 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m234.8 266 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m235.3 266 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M233.1 270.9h-.5c0-2.7-1.1-4.5-4-5.3.1 1.5 1.1 7.2 3.5 5.3h.5l-1 4.3c1.5-1.6 7.7-7.2 5-9.6-2.3-2.1-3.4 4.2-3.5 5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m236.3 266 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m237.3 266 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m247.3 266 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m247.8 266 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31425a",
    d: "m248.3 266 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m248.8 266 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m261.3 266 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m262.8 266 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m263.8 266 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m264.3 266 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "m268.9 266 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m269.4 266 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m280.4 266 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "m280.9 266 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m281.4 266 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m281.9 266 .5.5-.5-.5m8.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m291 266 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m291.4 266 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m292 266 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m294 266 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m295.4 266 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m296 266-.6 1 .5-1m1 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m301.4 266 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m304 266 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m306 266 .4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#102110",
    d: "m306.4 266 .6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m307.3 266.2.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m308 266 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m308.5 266 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m309 266 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m309.5 266-1.5 2.4 2.5-2.4h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m219.2 266.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m219.7 266.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m225.7 266.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m226.2 266.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m226.7 266.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M228.2 266.5v.5h1.5l-1.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m229.8 266.5.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m230.3 266.5.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M232 266.8v.3-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "m232.3 266.5.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m233.3 266.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m233.8 266.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m234.3 266.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m234.8 266.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m236 266.8.1.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m237.4 266.8.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m248.8 266.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m249.3 266.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "m249.8 266.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "m250.3 266.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m250.8 266.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m251.3 266.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m261.3 266.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "m262.8 266.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m263.3 266.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "m263.8 266.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#100808",
    d: "m267.4 266.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "m267.9 266.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#210800",
    d: "m268.4 266.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m277.9 266.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m278.4 266.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "m278.9 266.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525a6b",
    d: "m279.4 266.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m279.9 266.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m280.4 266.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m290.4 266.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m291 266.5 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "m291.4 266.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m292 266.5.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m294 266.5.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m294.4 266.5-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m296 266.5.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m297.4 266.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m301 266.5.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m303.4 266.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M305.4 266.5v.5h2v-.5h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m307.4 266.5.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m308 266.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m308.5 266.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "m310 266.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "m219.2 267 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m219.9 267.3.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m220.2 267 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m220.7 267 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m222.7 267 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m225.2 267 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "m225.7 267 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m226.7 267 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "m227.2 267 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m228.2 267 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "m230.3 267 .4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m230.8 267 .4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m232.3 267 .4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2908",
    d: "m232.8 267-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m233.3 267 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a3131",
    d: "m233.8 267 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m234.3 267 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m240.3 267 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "m240.8 267 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m241.3 267 .5.5-.5-.5m9.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m251.3 267 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m251.8 267 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m252.3 267 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "m261.8 267 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#100808",
    d: "m266.3 267 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b0008",
    d: "m266.9 267 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M264.8 267.4v.5h1.5c-3.8 6-1 14-.5 20.5h.5a46 46 0 0 0 0-20l2 1 .5-2-.5-.4-3.5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#940008",
    d: "m268.4 267 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m268.9 267 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m276.9 267 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m277.4 267 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m277.9 267 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m278.4 267 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m290 267 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m290.4 267 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "m292 267 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m292.4 267 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m294.4 267 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m296 267 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m297.4 267 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m298 267-.6 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m301 267 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m303 267 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m305.4 267 .6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "m306.4 267-.4 1 .4-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "m307.1 267.3.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "m307.4 267 .6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m308 267 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m309.5 267-1.5 1.9 1.5-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m219.2 267.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "m220.2 267.4 1 2.9h.5l.5-1.9-2-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m220.7 267.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m221.2 267.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m221.7 267.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "m222.7 267.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m223.2 267.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m225.2 267.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m225.7 267.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m227.7 267.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "m228.2 267.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m230.8 267.4.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a1000",
    d: "m231.3 267.4.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m231.8 267.4.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m233.8 267.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m235.6 267.6.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "m237.3 267.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m238.3 267.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m238.8 267.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "m239.3 267.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "m239.8 267.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m240.3 267.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "m240.8 267.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m241.3 267.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m261.8 267.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "m263.8 267.4-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad0008",
    d: "m264.3 267.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "m268.9 267.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m290 267.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m290.4 267.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m292 267.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m292.4 267.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m294.4 267.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m295 267.4-.6 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m296 267.4 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m296.4 267.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m298 267.4.4.5-.5-.5m1 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m299.4 267.4.5.5-.5-.5m1 0 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m301 267.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m302.4 267.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m303 267.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m305 267.4 1 1-1-1zm2.4 0 .6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m310 267.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "m310.5 267.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m311 267.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m311.5 267.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c9c84",
    d: "m218.7 268 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "m219.2 268 1.5 2.3-1.5-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m219.7 268 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m221.7 268 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m222.2 268 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m222.7 268 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m223.2 268 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m224.7 268 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m225.6 268 .3.2-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m226.2 268 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b8c73",
    d: "m228.2 268 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m231.3 268 1 .9v-1h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a1000",
    d: "m232.3 268 .4.4-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m233.3 268 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "m237.3 268 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m237.8 268 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m238.3 268 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "m236.8 271.7 1-.4v.4l-3.5 2.9a9.7 9.7 0 0 0 6-5.7l-1.5 1 1-2-3 3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m239.8 268-.5.9.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m240.3 268-.5.9.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "m240.8 268 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m256.3 268 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#845a52",
    d: "m256.8 268 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "m257.3 268 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#842118",
    d: "m257.8 268 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m258.3 268 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m258.8 268 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m261.8 268 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "m262.8 268 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310010",
    d: "m263.8 268 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#180821",
    d: "m264.3 268 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310010",
    d: "m264.8 268 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m265.3 268 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m265.8 268 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m268.9 268 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m270.4 268 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m270.9 268 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m271.4 268 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c4a4a",
    d: "m271.9 268 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m272.9 268 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m290 268 .4.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m292 268 .4.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m292.4 268 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m295 268 .4.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m296 268 .4.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m298 268 .4.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m300.6 268.2.2.4-.2-.4m1.8-.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m306.4 268 .6.4-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m309.5 268 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m310 268 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m311.5 268 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m312 268 1 .9-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m218.9 268.7.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m219.7 268.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m220.2 268.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#102110",
    d: "m222.2 268.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M222.7 268.4v.5l1.5.5-1.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m223.7 268.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m224.7 268.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M225.2 268.4v2.4h-.5l-.5-1.5h-.5l.5 4.8h-.5l-.5-5.2h-.5l-.5 3.8h-.5l-2.5-2 1.5 3h-.5l-2-2.4c1.7 5.6 4.1 4.8 8.1 8 1.5 1.2 2.4 3.7 3.4 5.3l-2-1.4 1 1.4-2.4-1.4 3 2.9.4-1.5h.6c-1.3 2.3-3.5 2.6-6 2.9v-.5l1-1 2.4.5c-1.8-1.8-4-2-6.5-1.4l3 2.4v.5l-3 3.3 6-1-.5 1h.5l3-1.4-6 2.8v.5c5.1-.6 5.7-2.3 8.6-5.7-.4 1.5-.4 2.4 1 3.3l-.8-5.7 6.8-7.6-2.5 1.9 2-2.9c-2.9.6-4 2.6-4 5.3l-3 2.8h-.5c1-3 4-4.7 3-8-2.6 1.8-3.4 4-3.5 7l-2-9.5.5 2h-.5v-1h-.5l.5 6.7h-.5c-1.6-3.7-.2-11-3.6-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m226.2 268.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m228.4 268.7.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m229.8 268.4 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m232.8 268.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311000",
    d: "m233.3 268.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "m237.3 268.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m237.8 268.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "m240.3 268.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m258.3 268.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m258.8 268.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#736b6b",
    d: "m259.3 268.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b2908",
    d: "m259.8 268.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m260.3 268.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m262.3 268.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000818",
    d: "m262.8 268.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m263.3 268.4-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M261.8 285h.5c-.8-6-.4-11 2.5-16.6-5.9 2.9-5.5 12-3 16.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "m264.8 268.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c2118",
    d: "m265.3 268.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce0008",
    d: "m267.4 268.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd0008",
    d: "m268.4 268.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "m268.9 268.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m269.4 268.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b5252",
    d: "m269.9 268.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m270.4 268.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m270.9 268.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m282.9 268.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m289.4 268.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m290 268.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m290.4 268.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m291 268.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m292.4 268.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m293 268.4-.6 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m295 268.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m296.6 268.7.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m298 268.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m302.1 268.7.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m302.4 268.4.5.5-.5-.5m2 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m307.4 268.4.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m308.5 268.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m309 268.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m309.5 268.4.5.5-.5-.5m2.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m220.2 268.9.5.5-.5-.5m2 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m223.4 269.2.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m224.2 268.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "m224.7 268.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "m226.2 268.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m229.8 268.9.4.5-.4-.5m2.4 0 .6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m232.8 268.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m233.3 268.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m237.4 269.2.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m238.8 268.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m239.3 268.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m240.3 268.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "m246.3 268.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m260.3 268.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m260.8 268.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733939",
    d: "m261.3 268.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m261.8 268.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m262.3 268.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m264.3 268.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b5252",
    d: "m264.8 268.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "m267.4 268.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1010",
    d: "m268.4 268.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m268.9 268.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m282.9 268.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "m289.4 268.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m290 268.9.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m290.4 268.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m291 268.9.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m293 268.9.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m295 268.9.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m295.4 268.9-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m298.1 269.2.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m300 268.9 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m300.4 268.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m301.4 268.9 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m305 268.9.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m307 268.9-2 2.4 2-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m307.4 268.9.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m308 268.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m308.5 268.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m309 268.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m310 268.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "m310.5 268.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "m311 268.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m311.5 268.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m312.6 269.2.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m313 268.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m218.9 269.7.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m219.2 269.4.5.4-.5-.4m1 0 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m220.7 269.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m222 269.5.4.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "m224.2 269.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "m224.7 269.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m226.2 269.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m226.7 269.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m228.2 269.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m228.7 269.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m230.3 269.4.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "m232.8 269.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m235.3 269.4-.5.9.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m238.8 269.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m239.8 269.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m240.3 269.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m246.3 269.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733939",
    d: "m246.8 269.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m247.3 269.4.5.4-.5-.4m14.5 0 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "m262.3 269.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m263.8 269.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m264.3 269.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#842118",
    d: "m264.8 269.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m267.4 269.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad0008",
    d: "m267.9 269.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m268.4 269.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#debdb5",
    d: "m281.9 269.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c4a4a",
    d: "m282.4 269.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "m282.9 269.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#946b63",
    d: "m283.6 269.7.1.3-.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "m289.4 269.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m290 269.4.4.4-.5-.4m1 0 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m291.4 269.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m293 269.4.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m293.4 269.4-.5.9.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m295.4 269.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m296.4 269.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m297 269.4-.6.9.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m300.1 269.7.2.3-.2-.3m1.3-.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m304.4 269.4.6.4-.6-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m305 269.4.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m307 269.4.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m307.4 269.4.6.4-.6-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m308 269.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m309.5 269.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m310 269.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m311.5 269.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "m312 269.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m313 269.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m313.5 269.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m216.7 269.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m217.6 270 .3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m218.2 269.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m219.2 269.8 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m220.7 269.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m221.7 269.8-.5 1.5.5-1.5m1.5 0v1.5h.5l-.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "m224.7 269.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m226.7 269.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m228.7 269.8.5.5-.5-.5m2 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m232.8 269.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m235.3 269.8.5.5-.5-.5m1.8.2.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m238.3 269.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m239.8 269.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M246.8 269.8v7.7h-.5l-.5-6.7h-4.5v13.8l2-1 1 3.4 2.5-1.4.5 5.2 4.5-1.4c2.1 1.4 3.5 1.4 4.5-1h1l3 2.9-.5-9-9-.6v-.4l8.5.4v-1.4c-6.3-.1-7-4-7-9l-5.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m247.3 269.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b5252",
    d: "m247.8 269.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m248.3 269.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m261.8 269.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m262.3 269.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "m263.8 269.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c6b5b5",
    d: "m264.3 269.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "m264.8 269.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b0808",
    d: "m266.9 269.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#100808",
    d: "m267.4 269.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a3131",
    d: "m267.9 269.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m280.9 269.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a56363",
    d: "m281.4 269.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m281.9 269.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M277.4 271.3c0 4.8-.5 8.7-6.5 9 1.3 3.6 7.8 1.3 10-.6 3-2.6 2.5-6.3 2.5-9.9l-6 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m288.9 269.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m289.4 269.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "m291.4 269.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m293.4 269.8.5.5-.5-.5m2 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m297 269.8.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m301 269.8.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m301.4 269.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m300.4 274.1 4.6-4.3c-2.5.6-3.6 2.2-4.6 4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m304 269.8.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m306.4 269.8.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "m307 269.8.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m307.4 269.8.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m309 269.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m309.5 269.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m312 269.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m312.5 269.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m313 269.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "m313.5 269.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m314 269.8.5.5-.5-.5m-97.3.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "m217.2 270.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "m218 270.5.4.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m218.9 270.6.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m219.2 270.3.5.5-.5-.5m1 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m220.7 270.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m224.7 270.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m226.7 270.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "m228.7 270.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m230.8 270.3.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M232.8 270.3v1.4h.5l-.5-1.4m2.1.3.2.3-.2-.3m1.9-.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m238.1 270.5.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m239.3 270.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m239.8 270.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "m240.8 270.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a3131",
    d: "m245.8 270.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m248.3 270.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#842118",
    d: "m248.8 270.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c6363",
    d: "m249.3 270.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m249.8 270.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m261.3 270.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m261.8 270.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m263.3 270.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m263.8 270.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c6363",
    d: "m264.3 270.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m266.9 270.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a2129",
    d: "m267.4 270.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m267.9 270.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d6a5a5",
    d: "m279.4 270.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#946b63",
    d: "m279.9 270.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a52921",
    d: "m280.4 270.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m280.9 270.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a2129",
    d: "m283.4 270.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M283.9 270.3v.5h4.5l-4.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212139",
    d: "m288.4 270.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m290.4 270.3 1.5 1v-.5l-1.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m291.4 270.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m292 270.3.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m293.4 270.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m294 270.3-.6 1 .5-1m1.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m296 270.3.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m297 270.3.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m298 270.3.4.5-.5-.5m1 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m300 270.3.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m301 270.3.4.5-.5-.5m2.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "m306 270.3.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m306.4 270.3.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m308.5 270.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m309 270.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m313 270.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "m313.5 270.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m314 270.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m217.2 270.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m217.7 270.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m218.2 270.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "m220.7 270.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m221.7 270.8.5.5-.5-.5m3.7.3.2.3-.2-.3m1.3-.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m227.2 270.8.5.5-.5-.5m1.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m229.3 270.8.4.5-.4-.5m2 0 .4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m236.3 270.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m236.8 270.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m237.8 270.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "m239.3 270.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "m249.8 270.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "m250.3 270.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m250.8 270.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#943131",
    d: "m251.6 271 .4.1-.4-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c6b5b5",
    d: "m252.3 270.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m261.3 270.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "m263.3 270.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m263.8 270.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#943131",
    d: "m264.3 270.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "m266.3 270.8 1 4.3-1-4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b0808",
    d: "m266.9 270.8 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733939",
    d: "m267.4 270.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c69c94",
    d: "m276.9 270.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad3931",
    d: "m277.7 271 .3.1-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m278.4 270.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m278.9 270.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "m279.4 270.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M283.4 270.8v3.8h.5l-.5-3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M283.9 270.8c0 8.8-5.2 12-14 11.4l-.6 9c2 0 4.6.2 5-1.8l2 1.4 2-1.9-.4 2 1-1h.5l3-.5-.5 1.4 1.5-1.9 1 1h1.5v-1.5l1 .5.5-4.3c2.5-2 1-10.7 1-13.8h-4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "m290.4 270.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m292 270.8.4.5-.5-.5m2 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M296 270.8v1.4h.4l-.5-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m297 270.8.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M298.4 270.8v2.4h.5l-.5-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m300.4 270.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m301 270.8.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "m303 270.8.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m305.4 270.8.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m306 270.8.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m308 270.8-1 1.4 1-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m308.5 270.8.5.5-.5-.5m-90.8.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m218.7 271.3 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m219.2 271.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m221.2 271.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m221.7 271.3.5.4-.5-.4m1.5 0v1h1v-1h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m227.2 271.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m229.3 271.3.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m237.3 271.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "m238.8 271.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m239.3 271.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c7373",
    fillOpacity: 0.5,
    d: "M252.3 271.3v4.3h.5l-.5-4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m260.8 271.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "m261.3 271.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "m263.3 271.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m264.3 271.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "m266.9 271.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m290.4 271.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m291 271.3.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m292 271.3.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m294 271.3.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m297 271.3.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m300 271.3 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m300.4 271.3.5.4-.5-.4m2 0 .5.4-.5-.4m2 0L302 274l2.4-2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "m305 271.3.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m305.4 271.3.6.4-.6-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m308 271.3-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m217.7 271.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m218.2 271.7.5.5-.5-.5m1.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m221.9 272 .2.4-.2-.3m3.5 0 .2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "m227.2 271.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m229.3 271.7.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m229.8 271.7.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m232.8 271.7.5.5-.5-.5m3 .5v.5h1.5l-1.5-.5m1.5-.5.5.5-.5-.5m1 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m238.8 271.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m256.6 271.9.4.2-.4-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m257.3 271.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m257.8 271.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m258.3 271.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m260.8 271.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m261.3 271.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "m262.8 271.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m263.3 271.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "m264.3 271.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "m266.9 271.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#940008",
    d: "m267.4 271.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m267.9 271.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m270.9 271.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m271.4 271.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m272.2 271.9.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m272.9 271.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m290.4 271.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m291 271.7.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m291.4 271.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m292 271.7.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m292.4 271.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m294.3 271.9.3.2-.4-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m296.4 271.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m297 271.7.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m297.4 271.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m300 271.7.4.5-.5-.5m2 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m308 271.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "m218.2 272.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m219.7 272.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m223.9 272.5.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "m227.2 272.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m228.7 272.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m229.8 272.2.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m230.3 272.2 1.4 1.4-1.4-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m232.4 272.5.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m236.3 272.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m238.3 272.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M256.8 272.2c0 2.4.3 3.6 3 3.8.4-2.6-.4-3.2-3-3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m257.8 272.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m258.3 272.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "m258.8 272.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "m259.3 272.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m259.8 272.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m260.3 272.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31425a",
    d: "m260.8 272.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "m262.8 272.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m263.8 272.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "m264.3 272.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "m266.9 272.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce0008",
    d: "m267.4 272.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m267.9 272.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m269.4 272.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m269.9 272.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "m270.4 272.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m270.9 272.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m271.4 272.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M268.4 273.2c1.1 4.1 4.4 2.8 4.5-1l-4.5 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m290.4 272.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m291 272.2.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m291.4 272.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m292 272.2.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m292.4 272.2.5.5-.5-.5m2 0 .5.5-.5-.5zm7 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m304 272.2.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m307 272.2.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m307.4 272.2-.4 1 .4-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "m218.2 272.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m219.7 272.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m220.2 272.7.5.5-.5-.5m2 0 .5.5-.5-.5m3 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m228.7 272.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m230.3 272.7 1.4 1.4-1.4-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m235.3 272.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m237.8 272.7-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m238.3 272.7-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m259.8 272.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "m260.3 272.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m260.8 272.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m262.8 272.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b5adad",
    d: "m263.8 272.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b0808",
    d: "m266.9 272.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "m267.4 272.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#524242",
    d: "m267.9 272.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525a6b",
    d: "m268.4 272.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m268.9 272.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m269.4 272.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "m291 272.7.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m291.4 272.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m292 272.7.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "m292.4 272.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m294.4 272.7 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m295 272.7.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m296.6 273 .2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m297 272.7.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m301 272.7.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m303.4 272.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m306.4 272.7.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m218.2 273.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m220.2 273.2.5.5-.5-.5m2.2.3.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m223.7 273.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m229.3 273.2.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m231.8 273.2.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m232.3 273.2.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m234.8 273.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "m260.3 273.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m260.8 273.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m262.3 273.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m262.8 273.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad0008",
    d: "m267.4 273.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#390821",
    d: "m267.9 273.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m291 273.2.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "m291.4 273.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "m292 273.2.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m292.4 273.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m293 273.2.4.5-.5-.5m1.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m297.4 273.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m298.4 273.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m300.4 273.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m303 273.2.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m306 273.2.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m306.4 273.2.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m218.2 273.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m218.7 273.6.5.5-.5-.5m2 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m223.7 273.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "m228.2 273.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m229.3 273.6 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m229.8 273.6 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "m231.8 273.6.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m233.8 273.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m234.3 273.6.5.5-.5-.5m1.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m236.3 273.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m236.8 273.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m237.3 273.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "m260.3 273.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m262.3 273.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b0008",
    d: "m266.9 273.6.5.5-.5-.5m1 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m289.7 273.8.4.2-.4-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m291 273.6.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m291.8 273.8.3.2-.4-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m292.4 273.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m293 273.6.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m295 274 .3.3-.2-.3m1.5 0 .2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m297.4 273.6.5.5-.5-.5m1 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m300 273.6.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m302.4 273.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m305.4 273.6.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m306 273.6.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m308 273.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m308.5 273.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m309 273.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "m309.5 273.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m310 273.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "m218.7 274.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m220.7 274.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m222.2 274.1 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m222.7 274.1.5.5-.5-.5m2.5 0-.5 1h1l-.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "m227.2 274.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "m228.4 274.4.2.4-.2-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m231.3 274.1-.6 1 .6-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m231.8 274.1.4.5-.4-.5m1.6.3.2.4-.2-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m233.8 274.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m234.8 274.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m235.3 274.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m235.8 274.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m260.3 274.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31425a",
    d: "m262.3 274.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b0808",
    d: "m267.5 274.4.2.4-.2-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd0008",
    d: "m267.9 274.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "m268.4 274.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m289.4 274.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m290 274.1.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m291 274.1.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m291.4 274.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m292.4 274.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m293 274.1.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M298.4 274.1v2h.5l-.5-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m299.8 274.3.3.1-.3-.1m1.6-.2-1 1.4 1-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m302 274.1.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m305 274.1-1 2.4h.4l.6-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m305.4 274.1.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m307 274.1.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m307.4 274.1.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m308 274.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m308.5 274.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m310 274.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m310.5 274.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m218.7 274.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m221 274.8.4.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "m227.2 274.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m229 274.8.4.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m230.3 274.6.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m231.3 274.6-.6 1 .6-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M232.8 274.6v1.4l1.5-1.4h-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "m234.3 274.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m234.8 274.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525a6b",
    d: "m256.3 274.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m260.2 274.8.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m262.3 274.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "m268 275 .2.2-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#390821",
    d: "m268.4 274.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "m283.4 274.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "m290 274.6.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "m291.4 274.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m292.4 274.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "m293 274.6.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m293.4 274.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m295.3 274.8.3.1-.4-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m296.4 274.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m299.4 274.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m305 274.6.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m305.4 274.6.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m306 274.6.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "m306.4 274.6.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m307 274.6.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m310.5 274.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m218.7 275 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m219.2 275 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m221.2 275 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m222.7 275 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m224.7 275 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "m227.2 275 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m228.2 275 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m229.4 275.4.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "m231.3 275 .4.6-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m232.8 275 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m233.8 275-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "m234.8 275 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m235.3 275 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733939",
    d: "m240.8 275 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m245.8 275 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m256.3 275 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m261.8 275 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m262.3 275 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m266.9 275 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "m267.4 275 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b0008",
    d: "m268.4 275 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "m272.9 275 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m283.6 275.4.1.3-.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "m290 275 .4.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m290.4 275 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "m291.4 275 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m293.3 275.2.3.2-.4-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m295.4 275 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m297 275 .4.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "m304.4 275 .6.6-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m305 275 .4.6-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m305.4 275 .6.6-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m306 275 .4.6-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m310.5 275 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m311 275 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m219.2 275.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m221.2 275.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m222.7 275.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m223.2 275.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m224.7 275.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m227.4 275.9.2.3-.2-.3m.8-.3.6.4-.6-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m230.8 275.6.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m231.3 275.6-.6 2.3h.6v-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m232.4 275.9.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m234.3 275.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m235 275.9.1.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m235.3 275.6.5.4-.5-.4m4 0 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m239.8 275.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "m240.3 275.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "m240.8 275.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "m246.3 275.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#845a52",
    d: "m252.3 275.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m256.3 275.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "m256.8 275.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m261.8 275.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m262.3 275.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "m266.9 275.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#940008",
    d: "m267.4 275.6 1 .9-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd0008",
    d: "m268.2 275.7.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "m268.9 275.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "m272.4 275.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m272.9 275.6-.5.9.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m290 275.6.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m290.4 275.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m291.4 275.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m292 275.6.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m293.4 275.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m295.4 275.6.5.4-.5-.4zm5 0 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m304 275.6.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m304.4 275.6.6.4-.6-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m305 275.6.4.4-.4-.4m4.3.1.3.2-.3-.2m1.2-.1.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m311 275.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m219.2 276 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m219.7 276 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m221.7 276 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m223.2 276 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m223.7 276 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m224.7 276-.5 1.5.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m228.2 276 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m228.7 276 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m229.8 276 .4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#738c63",
    d: "m232.8 276 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m233.8 276-2 2.4 2-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m234.3 276 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m235.4 276.4.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m237.3 276 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m237.8 276 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "m238.3 276 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M238.8 276v1.5h.5l-.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m239.6 276.2.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m240.3 276 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733939",
    d: "m240.8 276 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m246.3 276 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#943131",
    d: "m252.3 276 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m256.8 276 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "m257.3 276 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "m257.8 276 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m258.7 276.2.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "m259.3 276 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "m261.8 276 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m262.3 276 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m266.9 276 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd0008",
    d: "m267.4 276 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "m268.4 276 2 5.3-2-5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#391810",
    d: "m268.9 276 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "m269.4 276 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "m269.9 276 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525a6b",
    d: "m271.9 276 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c4a42",
    d: "m276.9 276 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "m282.9 276 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m290 276.4.2.3-.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "m290.4 276 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m291.4 276-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m292 276 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m293.4 276 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m295.4 276 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m300 276 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m303.1 276.4.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m303.4 276 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m308 276 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m308.5 276 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m309 276 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m309.5 276 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m310 276 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "m311 276 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m219.7 276.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m220.2 276.5 1 1-1-1m1.5 0 1.5 1v-.5l-1.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m222.2 276.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m224.2 276.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m227.2 276.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m228.2 276.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m228.7 276.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M229.8 276.5v1.4h.4l-.4-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m231.8 276.5.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "m232.3 276.5.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m232.8 276.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m233.8 276.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m234.8 276.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m236.3 276.5-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m236.8 276.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "m237.3 276.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m239.8 276.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m240.3 276.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m246.3 276.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "m252.3 276.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m259.3 276.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m259.8 276.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m261.8 276.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m263.8 276.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "m266.9 276.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b0808",
    d: "m268 276.8.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b0008",
    d: "m268.9 276.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m269.4 276.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad3931",
    d: "m276.9 276.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#842118",
    d: "m282.9 276.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m290.4 276.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m292 276.5.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m293.8 276.7.3.1-.4-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m297 276.5.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m302 276.5 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m302.4 276.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m307 276.5.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m307.4 276.5.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m308 276.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m310 276.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m311 276.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m311.5 276.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m315 276.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m315.6 276.8.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m220.2 277 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "m224.7 277 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m226.7 277 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m227.2 277 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m228.7 277 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m231.8 277 .4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdc6ad",
    d: "m232.3 277 .4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m233.3 277 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m234.3 277 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "m235.4 277.3.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m236.3 277 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m239.3 277 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m239.8 277 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m246.3 277 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "m252.3 277 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a59494",
    d: "m252.8 277 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m259.3 277 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m259.8 277 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "m261.8 277 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c6b5b5",
    d: "m263.8 277 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "m264.5 277.3.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd0008",
    d: "m268.9 277 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m269.4 277 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#debdb5",
    d: "m276.4 277 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "m276.9 277 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m282.9 277 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a7b42",
    d: "m290 277 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m290.4 277 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m291 277 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "m292 277 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m293.4 277 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M294 277v1.4h.4l-.5-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m296 277.3.3.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m297 277 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m299 277 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m301.4 277 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m302 277 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m306 277 .4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "m306.4 277 .6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m307 277 .4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m310.5 277 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m311 277 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m311.5 277 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m313.5 277 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m314 277 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m314.5 277 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "m315 277 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m220.7 277.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m221.2 277.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m224.7 277.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m225.4 277.8.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m227.2 277.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "m228.7 277.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m231.3 277.5-.6 1 .6-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m231.8 277.5.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m232.8 277.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m234.3 277.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m235.8 277.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m238.3 277.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m238.8 277.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "m239.8 277.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "m246.8 277.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#842118",
    d: "m252.8 277.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m259.3 277.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M261.8 277.5v3.8h.5l-.5-3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m263.8 277.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "m266.9 277.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad0008",
    d: "m268.4 277.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733939",
    d: "m269.4 277.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c4239",
    d: "m276.4 277.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "m282.4 277.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m288.9 277.5 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "m290 277.8.2.3-.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m291 277.5.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "m292 277.5.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m298.4 277.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m299 277.5.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m301 277.5.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m301.4 277.5.5.4-.5-.4m3.6 0 .4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "m305.4 277.5.6.4-.6-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m306 277.5.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m311 277.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "m311.5 277.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m312 277.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m312.5 277.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m313 277.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m313.6 277.8.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m314 277.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "m314.5 277.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m315 277.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m221.2 278 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m221.7 278 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "m222.2 278 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m222.7 278 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "m227.2 278 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "m228.7 278 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "m231.3 278 .4.4-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "m232.3 278 .4.4-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m233.8 278 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m234.3 278 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "m235.3 278 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m235.8 278 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m237.8 278 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m238.3 278 .5.4-.5-.5m1 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m239.8 278 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m246.8 278 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "m252.8 278 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m253.3 278 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m259.3 278 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m263.8 278 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m264.3 278 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad0008",
    d: "m267.4 278 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd0008",
    d: "m267.9 278 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b0008",
    d: "m268.4 278 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#940008",
    d: "m269.4 278 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m269.9 278 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a5847b",
    d: "m275.9 278-.5.9.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "m276.4 278 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392121",
    d: "m282.4 278 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "m288.9 278 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m291 278 .4.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m291.4 278 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "m292 278 .4.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m296 278.3.3.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m298 278 1 .9-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m298.4 278 .5.4-.5-.5m2 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m304 278 .4.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m304.4 278 .6.4-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m305 278 .4.4-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m309.3 278.1.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m310 278 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "m310.5 278 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "m311 278 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m311.5 278 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m312 278 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m312.5 278-.5.9.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "m313 278 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m314 278 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m314.5 278 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m222.7 278.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m223.2 278.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "m223.7 278.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m224.2 278.4.5.5-.5-.5m1.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "m227.2 278.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "m230.8 278.4.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m231.3 278.4.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m231.8 278.4.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m233.8 278.4.5.5-.5-.5m1.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m237.3 278.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m237.8 278.4.5.5-.5-.5m1.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m247.3 278.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m253.3 278.4 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a59494",
    d: "m253.8 278.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "m264.3 278.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M267.9 278.4v6.7h1.5l-1.5-6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b0808",
    d: "m268.5 278.7.2.4-.2-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce0008",
    d: "m269.4 278.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m269.9 278.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "m275.9 278.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m281.9 278.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "m288.9 278.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m289.4 278.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "m290 278.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m291 278.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m291.4 278.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c9c84",
    d: "m292 278.7.2.4-.1-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m294 278.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m294.4 278.4-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m298 278.4.4.5-.5-.5m1.5 0-1.5 2 1.5-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m300 278.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m303 278.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m303.4 278.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m304 278.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m304.4 278.4.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m305 278.4.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m305.8 278.6.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "m306.4 278.4.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "m307 278.4.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#426331",
    d: "m307.4 278.4.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m308 278.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m308.5 278.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m309.3 278.6.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m312.5 278.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m313 278.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m313.5 278.4.5.5-.5-.5m-89.3.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "m224.7 278.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m225.2 278.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#422100",
    d: "m225.7 278.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m226.2 278.9 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m227.2 278.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m227.7 278.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "m230.8 278.9.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m231.3 278.9.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m231.8 278.9.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m233.3 278.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m235.3 278.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m237.3 278.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "m239.3 278.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m247.3 278.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m247.8 278.9 1 1.4-1-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c7373",
    d: "m254.3 278.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m254.8 278.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m264.3 278.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "m267.5 279.2.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b2131",
    d: "m269.9 278.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#946b63",
    d: "m274.9 278.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "m275.4 278.9.5.5-.5-.5m6 0-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m281.9 278.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m288.9 278.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "m289.4 278.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m290 278.9.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "m291.4 278.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m294.6 279.2.2.3-.2-.3m1.3-.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m302 278.9.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m302.4 278.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "m303 278.9.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "m303.4 278.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m304 278.9.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m304.4 278.9.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m305 278.9.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m311 278.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m311.5 278.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m312 278.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m312.5 278.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m224.7 279.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m225.2 279.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m226.2 279.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m227.7 279.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m230.3 279.4.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m230.8 279.4.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m231.3 279.4.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m233 279.5.4.2-.3-.2m2 0 .3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m236.8 279.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m238.8 279.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m239.3 279.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m254.8 279.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c7373",
    d: "m255.3 279.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m255.8 279.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#943131",
    d: "m264.5 279.7.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#940008",
    d: "m268.4 279.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad0008",
    d: "m268.9 279.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#940008",
    d: "m269.9 279.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m270.4 279.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a5847b",
    d: "m273.9 279.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c2118",
    d: "m274.4 279.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m281.4 279.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m289 279.7.2.3-.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M289.4 279.4v.5h1.5v-.5h-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m290 279.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m291.4 279.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "m292 279.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m296 279.4.4.5-.5-.5m5.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "m302 279.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m302.4 279.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m310 279.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m310.5 279.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m311 279.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m311.5 279.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "m224.7 279.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#422100",
    d: "m226.7 279.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m227.7 279.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m228.2 279.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m230.3 279.9.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m231.3 279.9.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m232.8 279.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m234.8 279.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m236.3 279.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m236.8 279.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "m238.8 279.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m239.3 279.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "m248.8 279.9.5.4-.5-.4m7 0 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c2929",
    d: "m256.3 279.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#845a52",
    d: "m256.8 279.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a59494",
    d: "m257.3 279.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c6b5b5",
    d: "m257.8 279.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c7373",
    d: "m258.7 280 .3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212139",
    d: "m259.3 279.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m267.4 279.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce0008",
    d: "m268.4 279.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b0808",
    d: "m268.9 279.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce0008",
    d: "m269.9 279.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "m270.4 279.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#946b63",
    d: "m270.9 279.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd8c8c",
    d: "m271.4 279.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a5847b",
    d: "m271.9 279.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c5a52",
    d: "m272.4 279.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad3931",
    d: "m272.9 279.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m273.4 279.9.5.4-.5-.4m7 0 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m280.9 279.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m289.4 279.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m290.6 280.2.1.3-.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m291.4 279.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "m292 279.9.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M294.4 279.9v1.4h.5l-.5-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m301 279.9.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m308.5 279.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m309 279.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m309.5 279.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m310 279.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m310.5 279.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m224.7 280.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m225.2 280.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m226.2 280.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "m226.7 280.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m228.2 280.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "m230.3 280.3.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m230.8 280.3.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m231.3 280.3.4.5-.4-.5m1.4 0 .6.5-.6-.5m1.6 0-1 2h.4l.6-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m234.8 280.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m236.1 280.5.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m238.3 280.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m238.8 280.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m248.8 280.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m249.3 280.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m259.3 280.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c6363",
    d: "m264.3 280.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "m267.5 280.6.2.4-.2-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "m268.9 280.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m270.4 280.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m279.9 280.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m280.4 280.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m289.4 280.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m292 280.3.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m298 280.3.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m300 280.3.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m300.4 280.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m307.4 280.3.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m308 280.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m308.5 280.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m309 280.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m225.2 280.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m225.7 280.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m226.2 280.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m226.7 280.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m227.2 280.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m228.2 280.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "m228.7 280.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m230.3 280.8.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m230.8 280.8.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m231.3 280.8.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m234.3 280.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m235.3 280.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m235.8 280.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m238.3 280.8-1 1.4 1-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m249.8 280.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m250.3 280.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "m259.3 280.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c7373",
    d: "m264.3 280.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b0808",
    d: "m268.9 280.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m270.4 280.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m278.9 280.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#291029",
    d: "m279.4 280.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#29396b",
    d: "m288.4 280.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m289.4 280.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m290.4 280.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m291 280.8.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m292 280.8.4.5-.5-.5m7.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m300 280.8.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m304 280.8 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m304.4 280.8.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M305 280.8v.5h2l-2-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m307 280.8.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m307.4 280.8.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M308 280.8v.5h1.5l-1.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "M309.5 280.8v.5h1.5l-1.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b8c73",
    d: "m311 280.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m311.5 280.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m312 280.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m225.2 281.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m227.2 281.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m228.7 281.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m229.8 281.3.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m230.3 281.3.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733939",
    d: "m230.8 281.3.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m234.3 281.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m234.8 281.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m238.3 281.3-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m250.8 281.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m251.3 281.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m251.8 281.3 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "m259.3 281.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m259.8 281.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425a84",
    d: "m261.8 281.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b5adad",
    d: "m264.3 281.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m267.4 281.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#940008",
    d: "m269.2 281.4.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad0008",
    d: "m269.9 281.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m270.4 281.3 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "m277.4 281.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m277.9 281.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m278.4 281.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "m288.4 281.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396321",
    d: "m289.4 281.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M291 281.3v1.4h.4l-.5-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m292 281.3.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m292.4 281.3-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M294.4 281.3v2.4h1l-1-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m295 281.3.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m299 281.3-1 1.4 1-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m299.4 281.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m303.1 281.6.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m303.4 281.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m304 281.3.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m311 281.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m311.5 281.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "m312 281.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m225.2 281.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m225.7 281.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m226.2 281.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m227.2 281.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m227.7 281.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m229.4 282 .2.4-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m229.8 281.8.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "m230.4 282 .2.4-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M231 282v.4-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m232.8 281.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m236.8 281.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#946b63",
    d: "m240.8 281.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m251.8 281.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m252.8 281.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m253.3 281.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "m253.8 281.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "M254.3 281.8v.4h4l-4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m258.3 281.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "m258.8 281.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m259.3 281.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m259.8 281.8.5.4-.5-.4m2.2.3.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m264.3 281.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "m265 282 .2.4-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000818",
    d: "m269.4 281.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m269.9 281.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#080829",
    d: "m270.4 281.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "m271.4 281.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m275.4 281.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m275.9 281.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1021",
    d: "m276.4 281.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "m276.9 281.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "m288.4 281.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a7b42",
    d: "m289.4 281.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m292.4 281.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m299 281.8.4.4-.5-.4m2.5 0 1 .9-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m302 281.8.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m302.4 281.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m308.5 281.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m309 281.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m309.5 281.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "m310 281.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m310.5 281.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m311 281.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m311.5 281.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m225.2 282.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m225.7 282.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m226.2 282.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "m226.7 282.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m227.2 282.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "m227.7 282.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m229.8 282.2.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m232.6 282.4.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "m236.3 282.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m254.3 282.2.5.5-.5-.5zm3.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#391810",
    d: "m259.8 282.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m264.3 282.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#291029",
    d: "m269.4 282.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M271.9 282.2v.5h3.5l-3.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "m288.4 282.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m288.9 282.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "m289.6 282.6.1.3-.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m292.6 282.6.1.3-.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m298.4 282.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m301 282.2.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m301.4 282.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m306 282.2.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m306.4 282.2.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m307 282.2.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "m307.4 282.2.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m308 282.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m308.5 282.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m309 282.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m225.2 282.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m225.7 282.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "m226.2 282.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m226.7 282.7 1 1v-1h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "m227.7 282.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m228.2 282.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "m229.8 282.7.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m230.3 282.7.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2908",
    d: "m230.8 282.7.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m232.3 282.7.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m235.3 282.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m235.8 282.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m236.3 282.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m259.8 282.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "m260.3 282.7.5.5-.5-.5m1.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m262.3 282.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "m264.8 282.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#390821",
    d: "m269.4 282.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m288.4 282.7 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "m288.9 282.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m291 282.7.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m291.4 282.7-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m297 284.1 1.4-1.4-1.5 1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m300 282.7 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m300.4 282.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m301 282.7.4.5-.5-.5m4 0 .6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "m305.4 282.7.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m306 282.7.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m306.4 282.7.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m219.7 283.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m220.2 283.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "m225.7 283.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m226.7 283.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m228.2 283.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m228.7 283.2.5 1.4h.5l-1-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m230.3 283.2.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m230.8 283.2.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m232 283.3.4.2-.3-.2m1.7-.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "m234.3 283.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m234.8 283.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m235.3 283.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#391810",
    d: "m260.3 283.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m261.8 283.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m262.3 283.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m264.8 283.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m267.4 283.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b0808",
    d: "m269.4 283.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "m289.4 283.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m291.4 283.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m292.4 283.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m293 283.2-.6 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m299.4 283.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m300 283.2.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m304 283.2.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m304.4 283.2.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m305 283.2.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m219.7 283.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "m220.2 283.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m220.7 283.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m221.2 283.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m221.7 283.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m225.7 283.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m227.2 283.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m227.7 283.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m228.7 283.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m231.8 283.7.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m233.3 283.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m233.8 283.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m234.8 283.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m235.3 283.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m239.3 283.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m239.8 283.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m242.8 283.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "m260.8 283.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m262.3 283.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#943131",
    d: "m265 284 .2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "m267.4 283.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m288.9 283.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "m289.4 283.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m291.6 284 .1.3-.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m293 283.7.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m294.8 283.8.3.2-.4-.2m1.7-.1.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m299 283.7.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m299.4 283.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m303 283.7.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "m303.4 283.7.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m304 283.7.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m219.7 284.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m220.2 284.1.5.5-.5-.5zm1.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m222.6 284.3.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "m223.2 284.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "m223.7 284.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m224.2 284.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m224.7 284.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m225.2 284.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m225.7 284.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "m226.2 284.1-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m227.7 284.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m228.2 284.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m231.8 284.1.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m232.8 284.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m233.3 284.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "m234.8 284.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M235.3 284.1v2h.5l-.5-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m235.8 284.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m239.3 284.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "m239.8 284.1 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m240.3 284.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m242.3 284.1-1 1.5 1-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "m242.8 284.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m260.8 284.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m261.3 284.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m262.3 284.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m267.4 284.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M288.9 284.1v1.5h.5l-.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m289.4 284.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m293 284.5.2.3-.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m297 285.6 2.4-1.5-2.5 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m298.4 284.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m302.4 284.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "m303 284.1.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m303.4 284.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "m220.2 284.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m224.7 284.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m225.2 284.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "m226.2 284.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m226.7 284.6 1.5 1.4-1.5-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m228.7 284.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m229.8 284.6.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "m232.8 284.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m234.3 284.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m234.8 284.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "m235.3 284.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m236.3 284.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m239.3 284.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M239.8 284.6c-1.7 3.3-3.4 7 1 9 0-2.7 1-6.8-1-9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m241.3 284.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m242.3 284.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m242.8 284.6-.5 1h1l-.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m243.3 284.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31394a",
    d: "m261.3 284.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525a6b",
    d: "m262.3 284.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c7373",
    d: "m265 285 .2.3-.2-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "m267.4 284.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m287.6 285 .1.3-.1-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m287.9 284.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "m288.4 284.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m289.4 284.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m291.4 284.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m295 284.6-.6 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m298 284.6.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m301.4 284.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m302 284.6.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m302.4 284.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m303 284.6.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m303.8 284.8.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "m304.8 284.8.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295210",
    d: "m305.4 284.6.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m306 284.6.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M306.4 284.6v.5h2.6l-2.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m309 284.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "m309.5 284.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "m310 284.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m310.5 284.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m311 284.6.5.5-.5-.5m-90.8.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m221.7 285 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m222.6 285.3.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m223.4 285.4.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "m226.7 285 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m229.8 285-.6 1.5h.6v-1.4m2.4 0 .6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m232.8 285 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m234.3 285 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M234.8 285c-1.2 3.2-1 5 1 7.7h.5v-7.6h-.5v5.7h-1v-5.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "m236.3 285 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m238.8 285 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "m239.3 285 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "m240.8 285 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293100",
    d: "m241.8 285 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m243.3 285 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m261.3 285 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "m261.8 285 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "m262.3 285 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "m267.4 285 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b5252",
    d: "m267.9 285 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m268.4 285 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#290018",
    d: "m268.9 285 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "m269.4 285 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "m287.9 285 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "m288.4 285 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m289.4 285 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m290 285 .4.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M291.4 285v1.5h.5l-.5-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m293 285 .4.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m297.4 285 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m300 285 .4.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M300.4 285v.6h1.5l-1.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m302.3 285.3.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m303 285 .4.6-.5-.5m3.6 0 .4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m307 285 .4.6-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "m307.4 285 .6.6-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "m308 285 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m308.5 285 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m309 285 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m220.7 285.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m227.2 285.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m229.8 285.6.4.4-.4-.4m2.4 0 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "m232.8 285.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m233.8 285.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m234.3 285.6.5.4-.5-.4m2 0 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m236.8 285.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "m238.8 285.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m240 285.9.1.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m240.8 285.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#100808",
    d: "m241.3 285.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "m241.8 285.6-.5 7.6 1.5-1.4h.5l-.5 1.9c3.9-1.1 4.6-3.7 3.5-7.2l-2.5 5.3h-.5v-6.2h-.5l-1 5.2v-5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m242.3 285.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293100",
    d: "m243.3 285.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m245.8 285.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m246.3 285.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m261.8 285.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#080829",
    d: "m262.3 285.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c6b5b5",
    d: "m264.8 285.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m266.9 285.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m267.4 285.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m287.9 285.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m288.4 285.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m289.2 285.7.4.2-.4-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m293 285.6.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m294.4 285.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m297 285.6.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m299 285.6.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m299.4 285.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m300 285.6.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m304.4 285.6.6.4-.6-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m305 285.6.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "m305.4 285.6.6.4-.6-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "m306 285.6.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m306.4 285.6.6.4-.6-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m307 285.6.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m220.7 286 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m221.2 286 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m227.7 286 1 1v-1h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m228.7 286 .5.5-.5-.4m2 0-.5.9.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m231.3 286 .4.5-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m232.3 286 .4.5-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "m233.8 286 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M235.3 286v2.4h.5l-.5-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "m236.8 286 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m238.3 286 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m238.8 286 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m241.3 286 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M242.3 286v2h.5l-.5-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m243.3 286 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m243.8 286 .5.5-.5-.4m1.5 0-.5.9.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293100",
    d: "m245.8 286 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m246.3 286 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m261.8 286 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "m262.3 286 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m262.8 286 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#842118",
    d: "m266.9 286 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "m288.4 286 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m288.9 286 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m290 286 .4.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m293 286 .4.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m294.4 286 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m298 286 .4.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m298.4 286 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m299 286 .4.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m303 286 .4.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m303.4 286 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "m304 286 .4.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "m304.4 286 .6.5-.6-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m305 286 .4.5-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m305.8 286.2.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m221.7 286.5 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m225.9 286.8.2.4-.2-.4m6.8-.3.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m233.3 286.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m233.8 286.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m237 286.8.1.4-.2-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m237.8 286.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m238.3 286.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m239.8 286.5.5.5-.5-.5m1.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#422100",
    d: "m243.8 286.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m245.3 286.5.5.5-.5-.5m1 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m246.8 286.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m262.3 286.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m263 286.8.2.4-.2-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#736b6b",
    d: "m266.9 286.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m288.4 286.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m288.9 286.5.5.5-.5-.5m1 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m291.4 286.5.5 2h.5l-1-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m292 286.5.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m293 286.5.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m294 286.5.4.5-.5-.5zm3 0 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m297.4 286.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m298 286.5.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m301.4 286.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M302 286.5v.5l2 .5v-.5l-2-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m302.4 286.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m303 286.5.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M303.4 286.5v.5h1.5l-1.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m305.1 286.8.2.4-.2-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M305.4 286.5v.5l2 .5v-.5l-2-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m306.4 286.5.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m307 286.5.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "m307.4 286.5.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m308 286.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m308.5 286.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m221.7 287 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m224.6 287.2.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m225.2 287 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "m229.8 287 .4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "m233.3 287 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "m237.8 287 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m240 287.3.1.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m241.1 287.2.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m243.8 287 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m244.3 287 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m244.8 287 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m246.3 287 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m246.8 287 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m263.3 287-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "m266.3 287 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m266.9 287 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m288.4 287 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "m288.9 287 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m290 287 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m290.4 287 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m293 287 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m297 287 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m300 287 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m300.4 287 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m301 287 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m301.8 287.2.3.1-.3-.1m2.1-.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m304.6 287.3.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "m305.4 287 .6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m306 287 .4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m307.4 287 .6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m308 287 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "m308.5 287 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m309 287 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "m309.5 287 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m310 287 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m222.4 287.8.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "m222.7 287.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m223.2 287.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m223.7 287.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m229.3 287.5.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m229.8 287.5.4.5-.4-.5m2.3.1.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m233.4 287.8.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m236.8 287.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m237.3 287.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m237.8 287.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M240.8 287.5v1.4h.5l-.5-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M243.8 287.5v1h1l-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "m244.3 287.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m245.8 287.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2908",
    d: "m246.8 287.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m263.3 287.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c2118",
    d: "m266.3 287.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m287.4 287.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "m287.9 287.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m289 287.8.2.3-.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m290.2 287.6.4.2-.4-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m296 287.5.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m299.1 287.8.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m299.8 287.6.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M294 293.2c4.7-2.5 8.4-4.3 14-4.3-4.7-2.6-12.5-1-14 4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m304 287.5.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m305 287.5.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m305.4 287.5.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "m306 287.5.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m306.4 287.5.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m307 287.5.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m222.7 288 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m227.2 288 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m227.7 288 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m228.7 288 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m229.3 288 .4.4-.4-.4m2.4 0 .6.4-.6-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m236.8 288 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m237.3 288 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m239.6 288.1.3.2-.3-.2m2.7-.1v1.4h.5l-.5-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m245.3 288 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293100",
    d: "m246.8 288 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m263.3 288 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m263.8 288 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c6363",
    d: "m266.3 288 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m286.9 288 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "m287.4 288 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a7b42",
    d: "m287.9 288 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m290.4 288 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m291.4 288 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m298 288 .4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m298.4 288 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m306.4 288 .6.4-.6-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m307 288 .4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "m307.4 288 .6.4-.6-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m308 288 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m308.5 288 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m221.7 288.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m222.2 288.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m226.2 288.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m226.7 288.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m227.2 288.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m228.7 288.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M232 288.8v.3-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m233.3 288.4.5.5-.5-.5m2 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "m237.1 288.6.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m239.3 288.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m244 288.8.1.3-.2-.4m1.5 0 .2.4-.2-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m246.8 288.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m256.3 288.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m256.8 288.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m263.8 288.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m266.3 288.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m285.9 288.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m286.9 288.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m287.4 288.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396321",
    d: "m287.9 288.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m288.9 288.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m289.4 288.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m290.4 288.4.5.5-.5-.5m1.5 0 .5.5-.5-.5m2.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m297 288.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m297.4 288.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m298 288.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m308 288.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m308.5 288.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m309 288.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m309.5 288.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "m221.7 289 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m224.7 289 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m225.6 289 .3.2-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m226.2 289 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m228.2 289 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m233.4 289.2.2.4-.2-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M234.8 289v1.8h1V289h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "m236.8 289 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "m237.3 289 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M239.3 289v2.3h.5l-.5-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m241 289.2.1.4-.2-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "m256.3 289 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "m256.8 289 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m263.8 289 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m264.3 289 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m264.8 289-.5.9.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd0008",
    d: "m265.3 289 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m265.8 289 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m277.4 289-.5.9.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m278 289.2.2.4-.2-.4m5.4-.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m283.9 289 2 1.3v-.4l-2-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "m285.9 289 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m286.4 289 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m286.9 289 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m287.4 289 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m288 289.2.2.4-.1-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m289.2 289 .4.2-.4-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m290.4 289 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m291.4 289 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m292 289-.6 1.8.5-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m293.4 289 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "m294 289.2.2.4-.1-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m294.4 289 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M295.4 289.4v.5h1.5l-1.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m296.4 289 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m297 289 .4.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m302.4 289 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m303 289 .4.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m303.4 289-1 .4v.5l1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "m304 289 .4.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "M304.4 289v.4h3.6l-3.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295210",
    d: "m308 289 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m308.5 289 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m309 289 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m309.5 289 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "m310 289 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m310.5 289 .5.4-.5-.5m-89.3.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m221.7 289.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m223.7 289.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m224.2 289.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m224.7 289.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "m227.7 289.4.5.5-.5-.5m4 0 .6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m236.3 289.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m236.8 289.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m237.3 289.4.5.5-.5-.5m5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m243.6 289.6.4.1-.4-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m245.3 289.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m251.8 289.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m255.8 289.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m256.3 289.4 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "m256.8 289.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m257.3 289.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c7373",
    d: "m264.8 289.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b0808",
    d: "m265.3 289.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m265.8 289.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000818",
    d: "m274.4 289.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "m277.4 289.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m281.4 289.4 1 1v-1h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "m283.4 289.4.5.5-.5-.5m1.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m285.9 289.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m286.4 289.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m286.9 289.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m287.4 289.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m290.6 289.7.1.3-.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M293 289.4v.5l2.4 1v-.6l-2.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m293.4 289.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m294.4 289.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m296 289.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m301 289.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m301.8 289.6.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m303.4 289.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "m304 289.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m304.4 289.4.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m305 289.4.4.5-.4-.5m4 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m309.5 289.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m310 289.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "m310.8 289.6.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "m221.2 289.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m222.7 289.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m223.2 289.9.5.4-.5-.4m4 0 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m227.7 289.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m229.3 289.9-.6 1 .6-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m229.8 289.9.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m231.3 289.9.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m231.8 289.9.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m232.3 289.9.4.4-.4-.4m1.3.1.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m236.3 289.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m236.8 289.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#426331",
    d: "m237.3 289.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m241 290.2.1.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m242.3 289.9.5.4-.5-.4m1 0 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m245.1 290 .4.2-.4-.2m1.7-.1.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m251.3 289.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "m251.8 289.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m252.3 289.9 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m255.3 289.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m255.8 289.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "m256.3 289.9-1 2.8-1.5-1 1.5 3.9h.5v-2h.5v3.4c2.4-1.5 2.1-4.2 1.5-6.7h-.5v4.8h-.5l-.5-5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m257.3 289.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m257.8 289.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m264.3 289.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b4242",
    d: "m264.8 289.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m265.3 289.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "m274.4 289.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "m274.9 289.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m276.4 289.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m276.9 289.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m277.4 289.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m278.9 289.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "m281.4 289.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m283.4 289.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m285.9 289.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "m286.4 289.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "m286.9 289.9-3 8.6a7.2 7.2 0 0 0 3-8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "m287.4 289.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m287.9 289.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m293 289.9.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m294.8 290 .3.2-.4-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m295.4 289.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m299.4 289.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M299.4 290.3v.5h2.5l-2.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m301 289.9.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M301.4 289.9v.4h3.6l-3.6-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m305 289.9.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "m305.4 289.9-.4 1 .4-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m306 289.9.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m306.4 289.9.6.4-.6-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m311 289.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m220.7 290.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m221.2 290.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m222.2 290.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m222.7 290.3.5.5-.5-.5m3.5 0v1.5h.5l-.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m226.7 290.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m229.3 290.3.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m231.3 290.3.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "m232.3 290.3.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m233.8 290.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "m236.3 290.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "m237.3 290.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m242.1 290.5.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m243.4 290.7.2.3-.2-.3m1.4-.4.5.5-.5-.5m2 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m251.3 290.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m251.8 290.3 1 2.4h1.5l-2.5-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311000",
    d: "m252.3 290.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#422100",
    d: "m255.3 290.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M256.8 290.3v2h.5l-.5-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m257.8 290.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m264.3 290.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "m264.8 290.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m265.3 290.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#083121",
    d: "m274.4 290.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m274.9 290.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m275.4 290.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#102110",
    d: "m276.4 290.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "m276.9 290.3-.5 4.3h.5v-4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#083121",
    d: "m277.4 290.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000818",
    d: "m278.9 290.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m280.9 290.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "m281.4 290.3-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "m282.9 290.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m283.4 290.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "m283.9 290.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "m284.4 290.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "m284.9 290.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "m285.4 290.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m285.9 290.3-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "m286.4 290.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m287.4 290.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m287.9 290.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m290.6 290.7.1.3-.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m293 290.3.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m294 290.3.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m298.4 290.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m299 290.3.4.5-.5-.5m3 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M302.4 290.3v.5h1.5l-1.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "m304.3 290.5.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m305.4 290.3.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m306 290.3.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m306.4 290.3.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m307 290.3.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m307.4 290.3 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m220.7 290.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m224.2 290.8.5 2h.5l-1-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m225.6 291 .3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m227.7 290.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m228.2 290.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m228.7 290.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "m230.8 290.8.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m231.3 290.8.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m232.3 290.8.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m232.8 290.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2908",
    d: "m233.3 290.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m233.8 290.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "m234.3 290.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "m236.3 290.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m237.3 290.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m240.8 290.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m244.8 290.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "m246.8 290.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "m247.3 290.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313918",
    d: "m251.3 290.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m251.8 290.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293100",
    d: "m252.8 290.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1010",
    d: "m253.3 290.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "m254.2 291 .3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2121",
    d: "m254.8 290.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m255.3 290.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m257.8 290.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m258.3 290.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m264.3 290.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m264.8 290.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m271.9 290.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "m272.4 290.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103921",
    d: "m274.4 290.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "m274.9 290.8-.5 6.2c1.8-1.7 1.8-4 .5-6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#102121",
    d: "m275.4 290.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212139",
    d: "m275.9 290.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m276.4 290.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "m277.4 290.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "m277.9 290.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31425a",
    d: "m278.4 290.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m278.9 290.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31425a",
    d: "m279.4 290.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "m280.2 291 .3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m281.6 291.1.1.4-.1-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "m281.9 290.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "m282.4 290.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "m282.9 290.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "m283.9 290.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m284.4 290.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m284.9 290.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m285.9 290.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m286.4 290.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m291.4 290.8.5.5-.5-.5m1 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m293 290.8.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m294 290.8.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m297.4 290.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m298 290.8.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m298.4 290.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m303 290.8.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m303.4 290.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m304 290.8.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m304.4 290.8.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m305 290.8.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m306 290.8.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m306.4 290.8-.4 1 .4-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m307 290.8.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m307.4 290.8.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m220.7 291.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m221.2 291.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m221.7 291.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "m222.2 291.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "m222.7 291.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m223.6 291.4.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "m225.6 291.4.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m227 291.4.4.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m227.7 291.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "m230.3 291.3.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m230.8 291.3.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "m232.8 291.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m234.4 291.6.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m234.8 291.3.5 1.9h.5l-1-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m236.4 291.6.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m237.3 291.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m237.8 291.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m240.8 291.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m243.3 291.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m244.3 291.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m246.3 291.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m246.8 291.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "m247.3 291.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "m247.8 291.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m248.3 291.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m248.8 291.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m249.3 291.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m249.8 291.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "m251.3 291.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "m251.8 291.3 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m252.3 291.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m253.8 291.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m254.3 291.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "m254.8 291.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "m258.3 291.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b5252",
    d: "m258.8 291.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m259.3 291.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m259.8 291.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "m269.4 291.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "m269.9 291.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "m270.4 291.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m270.9 291.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m271.4 291.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m271.9 291.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m272.4 291.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m275.4 291.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m275.9 291.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m278.4 291.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m280.4 291.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m280.9 291.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m282.4 291.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m283.9 291.3 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m284.4 291.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "m284.9 291.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m285.4 291.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m285.9 291.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m286.4 291.3.5.5-.5-.5m4 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m291.6 291.6.1.3-.1-.3m.8-.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m293.4 291.3 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m294 291.3.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m296.4 291.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m297 291.3.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m297.4 291.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m304.4 291.3.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m305 291.3.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "m305.4 291.3.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M221 292h.4-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m222.2 291.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m222.7 291.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "m223.7 293.7 1-1.4c-1.3-.3-2 .4-1 1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M225.6 292h.3-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m226.2 291.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m229.3 291.8.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m229.8 291.8.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m230.3 291.8.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2121",
    d: "m232.8 291.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m237.8 291.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m238.3 291.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m241 292 .1.4-.2-.3m1.9-.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m246.3 291.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m247.3 291.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m247.8 291.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "m248.3 291.8.5 3.3 2.5 2 3.5.4.5-.5c-.3-1.3-4.4-6.9-5-3.8l-1-1.4h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M249.3 291.8v1l1-1h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m250.3 291.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M251.1 292h.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m252 292 .1.4-.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m252.8 291.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m254.3 291.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m254.8 291.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "m258.3 291.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m259.8 291.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m260.3 291.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m260.8 291.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m261.3 291.8.5.4-.5-.4m6.5 0 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m268.4 291.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m268.9 291.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m269.4 291.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m269.9 291.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m275.4 291.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m275.9 291.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m277.9 291.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m278.4 291.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m279.9 291.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "m280.4 291.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "m280.9 291.8-3.5 5.7c3.9 0 5.6-2 6-5.7h-.5l-3.5 5.2 1.5-5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "m281.4 291.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m282.4 291.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m283.4 291.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m283.9 291.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m284.9 291.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "m285.4 291.8-3.5 6.2c2.3-1.1 4-3.7 3.5-6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "m285.9 291.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m286.4 291.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m290.4 291.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m293.4 291.8.5.4-.5-.4m2.5 0 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m296.4 291.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M298.3 292h.3-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m299 291.8.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M299.4 291.8v.4h1.5l-1.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m301 291.8.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M301.8 292h.3-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m302.4 291.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m303.1 292 .2.4-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m303.4 291.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m306 291.8.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m306.4 291.8.6.4-.6-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m307 291.8.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m222.2 292.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m223.7 292.3-.5.9h1l-.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m224.2 292.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m228.2 292.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "m228.7 292.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m229.3 292.3.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m231.3 292.3.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m231.8 292.3.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c9c84",
    d: "m232.3 292.3.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "m232.8 292.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#422100",
    d: "m233.3 292.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2908",
    d: "m233.8 292.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311000",
    d: "m234.3 292.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m235.3 292.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "m236.3 292.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "m238.3 292.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m242.8 292.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m245.8 292.3-.5.9.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m246.3 292.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m247.8 292.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m248.8 292.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m252.3 292.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m253.3 292.3-.5.9.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m254.8 292.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m257 292.6.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m258.5 292.6.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m260.8 292.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m261.3 292.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m261.8 292.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m267.4 292.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m267.9 292.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m268.4 292.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m275.9 292.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m277.9 292.3-.5.9.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m278.4 292.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m279.9 292.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m280.4 292.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m281.7 292.4.4.2-.4-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m282.4 292.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m283.4 292.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "m283.9 292.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "m284.4 292.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m284.9 292.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m285.9 292.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m290.4 292.3.5.4-.5-.4m1 0 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m293.4 292.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M294.4 292.7v.5h1.5l-1.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m295.4 292.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m296 292.3.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "m303.4 292.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "m304 292.3.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "m304.4 292.3.6.4-.6-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m305 292.3.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m305.4 292.3.6.4-.6-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m306.3 292.4.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m307 292.3.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m307.4 292.3.6.4-.6-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "m222.2 292.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m225.7 292.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m226.2 292.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m226.7 292.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "m227.2 292.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m227.7 292.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m228.2 292.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m229 292.9.4.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m229.8 292.7.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "m230.3 292.7.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "m230.8 292.7.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m231.3 292.7.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M230.3 293.2v.5h4.5v.5h-4.6v.4h1v.5c-2.7.2-4 1.1-5.5 3.4l8.6-.5v.5c-2.3.7-5.7.4-6.6 2.8 3.2-1.2 7.9-1.7 9.6-4.8l-3 1.5 1.5-2-4.5-.4v-.5l8 .5v.5h-1.5v.4l6.5-.4v-.5h-1.5v-.5h3v-.5l-4 1-11.5-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m235.8 292.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "m236.3 292.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m238.3 292.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m238.8 292.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m240.8 292.7 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m242.6 292.9.3.2-.3-.2m2.2-.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m245.8 292.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m247.8 292.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m248.3 292.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m249.6 292.9.4.2-.4-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m253.3 292.7 1.5 1v-.5l-1.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m254 293 .1.4-.1-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m255.3 292.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m261.8 292.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "m262.3 292.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m262.8 292.7.5.5-.5-.5m3.5 0-1 1.5 1-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m266.9 292.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m267.4 292.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m275.9 292.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m277.9 292.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "m278.4 292.7-3 4.8c1.9-1 3.6-2.6 3-4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m278.9 292.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m279.4 292.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m279.9 292.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m280.9 292.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m281.4 292.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m281.9 292.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m283.4 292.7 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m283.9 292.7 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m284.4 292.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m285.4 292.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m285.9 292.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m289.4 292.7.5.5-.5-.5zm4 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m295 292.7.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m304 292.7.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m304.4 292.7.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m305 292.7.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m305.4 292.7.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m306 292.7.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "m306.4 292.7.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m307 292.7.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m307.4 292.7.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m308 292.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m222.4 293.5.2.3-.2-.3m1.3-.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "m224.2 293.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m225 293.4.4.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m225.7 293.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m226.2 293.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m228.2 293.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m228.7 293.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m229.3 293.2.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m229.8 293.2.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "m236.3 293.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m236.8 293.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m238.3 293.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m238.8 293.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m239.3 293.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "m240.8 293.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m241.8 293.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m242.3 293.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m243.8 293.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m244.3 293.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m244.8 293.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m247.8 293.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m248.3 293.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m250.3 293.2 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m255.3 293.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M256.8 293.2v1.9h.5l-.5-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m258.3 293.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m262.8 293.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m263.3 293.2 1.5 1.9-1.5-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m266.3 293.2-1 1.4 1-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m266.9 293.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m276 293.5.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m277.4 293.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m277.9 293.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "m278.9 293.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m279.4 293.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m280.9 293.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m281.4 293.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m281.9 293.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m283.4 293.2.5.5-.5-.5m2 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m289.4 293.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m294 293.2.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m294.4 293.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m304.4 293.2.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "m305 293.2.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m305.4 293.2.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m307 293.2.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m307.4 293.2.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "m308 293.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "m308.5 293.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m221.7 293.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "m222.7 293.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m223.2 293.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m223.7 293.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m228.7 293.7 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m229.3 293.7.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M229.8 293.7v.5h2.4l-2.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m232.3 293.7.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m232.8 293.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m233.3 293.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m233.8 293.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m234.3 293.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "m236.8 293.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m237.3 293.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m237.8 293.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m238.3 293.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m239.3 293.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m239.8 293.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m240.3 293.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m240.8 293.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "m241.3 293.7-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m241.8 293.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m242.3 293.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m242.8 293.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#102110",
    d: "m243.3 293.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m243.8 293.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m244.3 293.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "m248.3 293.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m251.3 293.7 1.5 1.4-1.5-1.4m3 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m256 294 .1.3-.1-.3m2.3-.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "m274.4 293.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m276.9 293.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m277.4 293.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "m278.9 293.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m279.4 293.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "m280.9 293.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m281.4 293.7.5.5-.5-.5m1.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m283.7 293.8.4.2-.4-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m285.4 293.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m286.9 293.7 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m294 293.7.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m295.4 293.7 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m296 293.7.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M296.4 293.7v.5h1.5l-1.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m298 293.7.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M298.4 293.7v.5h2.5l-2.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m301 293.7.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m301.4 293.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m302 293.7.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m302.4 293.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m305.4 293.7 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m306 293.7.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m221.7 294.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "m222.2 294.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m222.7 294.2-1 .4v.5l1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m229.8 294.2.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m234.8 294.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m235.3 294.2.5.4-.5-.4m2 0 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#391810",
    d: "m237.8 294.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#423100",
    d: "m240.1 294.3.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m241.3 294.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m241.8 294.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293100",
    d: "m242.3 294.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M242.8 294.2v.4h2l-2-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m244.8 294.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "m245.3 294.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "m245.8 294.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m246.3 294.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "m248.3 294.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m251.3 294.2.5.4-.5-.4m3 0 .5 1.4h.5l-1-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "m258.3 294.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m264.8 294.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "m274.4 294.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m276.9 294.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m278.4 294.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m278.9 294.2-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m280.4 294.2 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m280.9 294.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m282.9 294.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m283.4 294.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m284.9 294.2 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m285.4 294.2.5.4-.5-.4m1.5 0 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m294.4 294.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m295 294.2.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m295.4 294.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m301.4 294.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m302 294.2.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "m302.4 294.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m303 294.2.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "m303.4 294.2.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m304 294.2.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m304.4 294.2.6.4-.6-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m306.4 294.2.6.4-.6-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m228.2 294.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "m228.7 294.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m229.3 294.6.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m229.8 294.6.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m230.6 294.8.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m237.8 294.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293100",
    d: "m238.3 294.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m238.8 294.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m239.3 294.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m239.8 294.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m240.3 294.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m240.8 294.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "m241.3 294.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m245.8 294.6-1.5 1.5 1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M246.3 294.6v1h1l-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "m246.8 294.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m247.3 294.6 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m248.3 294.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m251.8 294.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m254.3 294.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m255.8 294.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m258.3 294.6.5.5-.5-.5m6.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "m274.4 294.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m276.9 294.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m278.9 294.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m280.4 294.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m282.4 294.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m282.9 294.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m283.4 294.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m284.9 294.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m286.9 294.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m288.9 294.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m289.7 294.8.4.2-.4-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m290.4 294.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m291 294.6-.6 1 .5-1m2 0 .5.5-.5-.5m9.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "m303 294.6.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m303.4 294.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m304 294.6.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m304.4 294.6.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m305 294.6.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "m305.4 294.6.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m306 294.6.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m306.4 294.6.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m307 294.6 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m227.2 295.1-1 1.4 1-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m227.7 295.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m228.2 295.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m231.6 295.3.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m232.4 295.4.2.4-.2-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m239.6 295.3.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240.8 295.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m241.3 295.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M242.8 295.1v.5h1.5l-1.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m247.3 295.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m248.3 295.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m248.8 295.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m249.3 295.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#422100",
    d: "m249.8 295.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a4208",
    d: "m250.3 295.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m252.3 295.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M252.8 295.1v1h1l-1-1zm5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m258.3 295.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m273.9 295.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m274.4 295.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m275.9 295.1 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m277.9 295.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m278.4 295.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m279.9 295.1 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m280.4 295.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m282.7 295.3.4.1-.4-.1m2.2-.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m286.4 295.1 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m286.9 295.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m291 295.1.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m291.4 295.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m292 295.1.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m292.4 295.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m296 295.1.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m296.4 295.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M297 295.1v1h1l-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m297.4 295.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m303.4 295.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m304 295.1.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m306 295.1.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "m306.4 295.1.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "m307 295.1.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m308 295.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m227.2 295.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m232.8 295.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M233.3 295.6v.5h2l-2-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m235.3 295.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M235.8 295.6v1.4l2-1.4h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m238.1 295.8.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m238.8 295.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m241.8 295.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m242.3 295.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m244.8 295.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m245.3 295.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m245.8 295.6-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M246.3 295.6v1h1l-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m247.6 295.8.4.1-.4-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m248.8 295.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m249.3 295.6.5.5-.5-.5zm1 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m250.8 295.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m255.2 295.8.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "m257.8 295.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m273.9 295.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m275.9 295.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m277.4 295.6 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m277.9 295.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m280 296 .2.2-.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m281.9 295.6 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "m282.4 295.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m284.7 295.8.4.1-.4-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m286.4 295.6.5.5-.5-.5m6.2.3.1.3-.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m293 296 .2.2-.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m293.4 295.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m295 295.6.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m295.4 295.6-1 1.4 1-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M298 295.6v.5h1.4l-1.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m299.4 295.6 1 1v-1h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m300.4 295.6.5.5-.5-.5m3.6 0 1.4 1.4-1.4-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m304.4 295.6 1.6 1.4-1.6-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m307 295.6.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m307.8 295.8.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m226.7 296 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "m235.8 296 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m242.8 296 2 1v-.5l-2-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m243.3 296 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "m243.8 296 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m244.3 296 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m244.8 296 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m245.8 296 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m247.3 296 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "m248.8 296 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#423100",
    d: "m250.8 296 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m255.5 296.4.1.3-.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m257.3 296 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m257.8 296 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "m273.9 296 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m275.5 296.4.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m275.9 296 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m277.4 296 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m279.4 296 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m282 296.4.2.3-.1-.3m2.3-.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m286.4 296 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m287.9 296 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m288.4 296 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M287.4 296.5v.5l4.5-.5h-4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m292 296-.6 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m293.4 296 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m294 296 .4.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m295.4 296 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m296 296 .4.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m296.4 296 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m300.4 296 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "m301 296 .4.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "m301.4 296 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m302 296 .4.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m302.4 296 .5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m226.2 296.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m232.8 296.5-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m233.3 296.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m235.3 296.5-.5 1.5.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m237.3 296.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "m237.8 296.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "m238.3 296.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m238.8 296.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M239.3 296.5v.5h2l-2-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m241.3 296.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m241.8 296.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "m242.3 296.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "m240.3 299 10.5-1.5c-3.3-1.3-8-1.2-10.5 1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M246.3 296.5v.5h1.5l-1.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M247.8 296.5v.5h1.5l-1.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#422100",
    d: "m249.3 296.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2908",
    d: "m249.8 296.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m250.3 296.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m250.8 296.5 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m257.3 296.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m273.4 296.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m276.4 297.5 1.5-1-1.5 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m279.4 296.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m281.4 296.5-1 1.5h1.5l-.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m284.2 296.7.4.2-.4-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m285.9 296.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m286.7 296.7.4.2-.4-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m290.4 296.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m292 296.5-.6 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M292.4 296.5v.5l7 2v-.5l-7-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m294 296.5.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m296.4 296.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m297 296.5.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m297.4 296.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m300.4 296.5 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m301 296.5.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m301.4 296.5 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m302 296.5.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m302.4 296.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "m303 296.5.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m303.4 296.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m304 296.5.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m225.7 297 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m226.2 297 .5.5-.5-.5m2 0v1h1.5v-1h-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m229.8 297 .4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m230.3 297 .4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m230.8 297 .4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m231.6 297.2.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m237.3 297 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m238.8 297 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M239.3 297v.5h2l-2-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "m241.3 297 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m241.8 297 .5.5-.5-.5m9 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M251.8 297v.5h1.5l-1.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m253.3 297 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m254.8 297 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m255.3 297 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "m257.3 297 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd8c8c",
    d: "m258.2 297.2.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#845a52",
    d: "m258.8 297 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c4a42",
    d: "m264.3 297 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad524a",
    d: "m264.8 297 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#845a52",
    d: "m270.4 297 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd8c8c",
    d: "m271.2 297.2.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "m273.4 297 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "m274.9 297 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m281.4 297 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m283.4 297-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m283.9 297 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m285.4 297 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m285.9 297 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "m285.9 298.4 12.5 2v1.9c1.4-4.2-10.1-7-12.5-3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m292 297 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m292.4 297 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m293 297 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m293.4 297 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m297.4 297 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "m298 297 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m298.4 297 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m299 297 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m301.4 297 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m304 297 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m304.4 297 .6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m305.3 297.2.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m306 297 .4.5-.4-.5m-80.8.5-1 1.4 1-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m225.7 297.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m226.7 297.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m227.6 297.7.3.1-.3-.1m6.6-.2.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "m236.8 297.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m240.3 297.5-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "m240.8 297.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m249.6 297.7.4.1-.4-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m250.3 297.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#423100",
    d: "m250.8 297.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#422100",
    d: "m251.6 297.7.4.1-.4-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2908",
    d: "m252.3 297.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M252.8 297.5v.5h1.5l-1.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M254.3 297.5v.5h1.5l-1.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m255.8 297.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M244.3 306v-.4l-3 .5v-.5a92 92 0 0 1 47.1 0v.5l-2.5-.5c2.5 3.6 9.2 1.4 7-2.8-2-3.6-8.9-4-12.5-4.5a112.6 112.6 0 0 0-31.6.1c-3.6.6-8 .9-11 3.3-2 1.7-1.2 5.2 1.5 6 1.7.4 3.6-.9 5-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m273.4 297.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m275.4 297.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m276.2 297.7.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b2908",
    d: "m276.9 297.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m278.9 297.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m279.4 297.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m279.9 297.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m280.9 297.5.5.5-.5-.5m2.5 0-.5 1 .5-1m2 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m293 297.5.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m294.3 297.7.3.1-.4-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m295 297.5-.6 1 .5-1m3 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m298.4 297.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m299 297.5 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m299.4 297.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "m300 297.5.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m300.4 297.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "m302 297.5.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m302.4 297.5 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m305 297.5.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m305.4 297.5.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#102110",
    d: "m306 297.5.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m306.4 297.5.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m225.2 298 3 1.4-3-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m233.4 298.3.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m233.8 298 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m236.3 298 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m236.8 298 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m240.3 298 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m246.3 298 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m246.8 298 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m247.3 298 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#422100",
    d: "m247.8 298 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "m248.3 298 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m248.8 298 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m249.3 298 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m249.8 298 .5.5-.5-.5m29.6 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m279.9 298 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m280.4 298 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m280.9 298 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#422100",
    d: "m281.4 298 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a4208",
    d: "m281.9 298 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m282.4 298 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m283.4 298 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m284.9 298 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m285.4 298 .5.5-.5-.5m1 0 2.5.5-2.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m288.4 298 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m295 298 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "m295.4 298 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m296 298 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m296.4 298 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m299 298 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m300.4 298 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "m301 298 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m301.4 298 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m302 298 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m302.4 298 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m306 298 .4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m306.4 298 .6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "m224.7 298.4.5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M228.2 298.4v1h1v-1h-1m3.7.4.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m232.6 298.6.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m235.3 298.4.5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m235.8 298.4.5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m236.3 298.4.5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m239.8 298.4.5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m242.1 298.6.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m243.1 298.6.4.2-.4-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "m243.8 298.4.5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "m244.3 298.4.5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "m244.8 298.4.5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m245.3 298.4.5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m245.8 298.4.5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m246.3 298.4.5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m246.8 298.4.5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "m257.8 298.4.5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "m258.3 298.4.5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "m258.8 298.4.5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "m260.8 298.4.5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "m261.3 298.4.5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "m265.2 298.6.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "m265.8 298.4.5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "m268.7 298.6.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "m269.4 298.4.5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m282.9 298.4.5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m283.4 298.4.5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m283.9 298.4.5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2908",
    d: "m284.4 298.4.5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293100",
    d: "m284.9 298.4.5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m285.4 298.4.5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m285.9 298.4.5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M288.9 298.4v.5h1.5l-1.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m290.4 298.4 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m291 298.4.4.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m296 298.4.4.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "m296.4 298.4.5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "m297 298.4.4.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m297.4 298.4.5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m298 298.4.4.5-.5-.4m1.5 0 1 .9-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m300 298.4.4.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m301.4 298.4.5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m302 298.4.4.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m302.4 298.4.5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m303 298.4.4.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m224.2 299 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m229.3 299 .4.4-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m229.8 299 .4.4-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m230.3 299 .4.4-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m231 299 .4.2-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m234.3 299 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m234.8 299 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m235.3 299 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m239.3 299 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m240.1 299 .3.2-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M239.3 299.9v.5l3-1-3 .5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293100",
    d: "m242.3 299 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2908",
    d: "m242.8 299 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m243.3 299 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m243.8 299 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "m250.3 299 .5.4-.5-.5zm2 0 1 .9-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "m257.3 299 .5.4-.5-.5zm2 0 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "m261.3 299 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "m266.9 299 1 .9-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "m267.9 299 1 .9-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "m269.9 299 1 .9-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "m270.4 299 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "m272.4 299 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "m273.4 299-.5 3.3.5-3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "m273.9 299 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "m274.9 299 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "m275.4 299 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "m275.9 299 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "m276.9 299 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "m278.9 299 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m285.4 299 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m285.9 299 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a1000",
    d: "m286.4 299 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293100",
    d: "m286.9 299 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m287.9 299 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M288.4 299v.4l5 1-5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m290.4 299 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m291.4 299 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m292 299 .4.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m292.6 299.3.1.3-.1-.4m4.3-.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m297.4 299 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m298 299 .4.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m298.4 299 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m299 299 .4.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m299.4 299 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m300.4 299 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m302.4 299 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m303 299 .4.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m303.4 299 .5.4-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m227.2 299.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m227.7 299.4.5.5-.5-.5m4.6 0 .4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m232.8 299.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "m233.3 299.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "m233.8 299.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m234.3 299.4.5.5-.5-.5m4.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m239.3 299.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m241.3 299.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m241.8 299.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "m247.8 299.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "m252.3 299.4.5.5-.5-.5m1.5 0 .5.5-.5-.5m3.9.2.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "m258.3 299.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "m259.2 299.6.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "m266.9 299.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "m269.7 299.6.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "m271.9 299.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "m275 299.7.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "m279.9 299.4 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "m281.4 299.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "m283.4 299.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m287.4 299.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m287.9 299.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293100",
    d: "m288.4 299.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m288.9 299.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m293 299.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "m293.4 299.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m294 299.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m294.4 299.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m295 299.4.4.5-.5-.5m2.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m298 299.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m298.4 299.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m299 299.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m299.4 299.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m300.3 299.6.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m301 299.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m227.2 299.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m230.3 299.9.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "m230.8 299.9.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "m231.3 299.9.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m231.8 299.9.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m232.3 299.9.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m232.8 299.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m238.3 299.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "m238.8 299.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a1000",
    d: "m239.8 299.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m240.3 299.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "m243.6 300 .4.2-.4-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "m247.3 299.9.5.5-.5-.5zm2.7.3.1.3-.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "m251.3 299.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "m251.8 299.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "m252.8 299.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "m258.8 299.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "m259.3 299.9.5.5-.5-.5m1 0 .5.5-.5-.5zm1.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M265.8 299.9v1.4h.5l-.5-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "m266.3 299.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "m268.4 299.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "m268.9 299.9.5 1.4-.5-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "m271.9 299.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "m272.4 299.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "m279.4 299.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "m279.9 299.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "m280.9 299.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "m281.9 299.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "m282.9 299.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "m283.4 299.9-.5 1.4.5-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "m284 300.2.2.3-.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "m285.4 299.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "m285.9 299.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m288.9 299.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2908",
    d: "m289.4 299.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m290 299.9.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m290.4 299.9.5.5-.5-.5m3.2.3.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m294 299.9.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "m294.4 299.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m295 299.9.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "m295.4 299.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m296 299.9.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m296.4 299.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m298.4 299.9 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m299 299.9.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m300 299.9.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m300.4 299.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "m301 299.9.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m227.2 300.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m229.3 300.4.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "m229.8 300.4.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m230.3 300.4.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "m238.3 300.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311000",
    d: "m238.8 300.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m239.3 300.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "m241.8 300.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "m242.3 300.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "m242.8 300.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "m243.3 300.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "m243.8 300.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "m248.3 300.4.5.4-.5-.4zm4.5 0 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "m261.2 300.5.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "m266.3 300.4.5.4-.5-.4m5.5 0 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "m274.9 300.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "m275.9 300.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M280.4 300.4v1.9l2-.5-2-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "m281.9 300.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "m282.9 300.4.5.4-.5-.4m2.8.1.4.2-.4-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "m286.9 300.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "m287.4 300.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m290 300.4.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m290.4 300.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m291.2 300.5.4.2-.4-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m292 300.4.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m292.8 300.5.3.2-.4-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "m294 300.4.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m294.4 300.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m295 300.4.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m295.4 300.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m296 300.4.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m296.4 300.4 1 1.4-1-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m297 300.4.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m297.4 300.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m298 300.4.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m299.4 300.4.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m228.2 300.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m228.7 300.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m229.3 300.8.4.5-.4-.5m8 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#524242",
    d: "m237.8 300.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m238.3 300.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "m240.1 301 .3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "m241.8 300.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "m242.8 300.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "m245.8 300.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "m246.3 300.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "m248.5 301.1.1.4-.1-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "m259.3 300.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "m259.8 300.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "m260.5 301.1.2.4-.2-.4m1.5 0 .2.4-.2-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "m266.7 301 .3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "m268.4 300.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "m271.4 300.8.5.5-.5-.5zm6 0-.5 2 .5-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "m278.9 300.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "m279.6 301.1.1.4-.1-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "m280 301.1.2.4-.1-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "m282.4 300.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "m283.4 300.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "m284 301.1.2.4-.1-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "m284.9 300.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "m286.9 300.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "m287.4 300.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m291 300.8.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#210800",
    d: "m291.4 300.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "m292 300.8.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "m292.4 300.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m293 300.8.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m293.4 300.8 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m294 300.8.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "m294.4 300.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m295 300.8.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m295.4 300.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "m296 300.8.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m297.4 300.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "m298 300.8.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m299 300.8.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m299.4 300.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m227.7 301.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m228.2 301.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m236.8 301.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m237.3 301.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m237.8 301.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "m238.8 301.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "m239.3 301.3.5.5-.5-.5zm1.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "m241.8 301.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "m242.8 301.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "m244.8 301.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "m247.3 301.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "m251.3 301.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "m251.8 301.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "m257.6 301.5.4.1-.4-.1m1.5 0 .4.1-.4-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "m259.8 301.3-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "m261.2 301.5.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "m262.3 301.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "m265.8 301.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "m266.9 301.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "m267.4 301.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "m269.7 301.5.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "m271.4 301.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "m272.4 301.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "m276.4 301.3.5.5-.5-.5zm6.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "m283.4 301.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "m284.9 301.3.5.5-.5-.5m1.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "m286.9 301.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "m287.4 301.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "m288.9 301.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "m289.6 301.6.1.3-.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m292 301.3.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m292.4 301.3 1 1v-1h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m293.4 301.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m295.4 301.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m296 301.3.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m296.4 301.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "m298 301.3.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m299 301.3.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "m227.7 301.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m236.3 301.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631818",
    d: "m236.8 301.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "m238.3 301.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "m238.8 301.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "m239.8 301.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "m240.3 301.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "m241.8 301.8.5.5-.5-.5m3 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "m245.8 301.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "m246.3 301.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "m247.8 301.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "m248.3 301.8-.5 1 .5-1zm7 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "m257.3 301.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "m259.8 301.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "m260.3 301.8.5.5-.5-.5m1.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "m262.3 301.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "m266.3 301.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "m267.9 301.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "m271.4 301.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "m272.4 301.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "m279.4 301.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "m279.9 301.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "m280.9 301.8 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "m281.9 301.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "m282.4 301.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "m285.4 301.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "m286.4 301.8-.5 1 .5-1zm1 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "m288.4 301.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m292.4 301.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "m293.4 301.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m294 302.1.2.3-.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m294.4 301.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m295 301.8.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m298 301.8.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "m299 301.8.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m235.8 302.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631818",
    d: "m236.3 302.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "m239.8 302.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "m240.3 302.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "m241.3 302.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "m242 302.6.1.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "m243 302.6.1.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "m243.3 302.3 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "m244.8 302.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "m245.8 302.3.5.4-.5-.4zm4 0 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "m253.3 302.3.5.4-.5-.4zm4.5 0 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "m258.3 302.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "m258.8 302.3.5.4-.5-.4m1.4.1.3.2-.3-.2m2 0 .3.2-.3-.2zm6.1-.1.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "m268.9 302.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "m269.4 302.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "m270.9 302.3.5.4-.5-.4m1 0 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M272.4 302.3v.4h1.5l-1.5-.4m2.5 0 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "m275.4 302.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "m279.4 302.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "m282.9 302.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "m284 302.6.2.3-.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "m284.9 302.3.5.4-.5-.4m1.5 0 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "m287.4 302.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m293 302.3.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m293.4 302.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m294.4 302.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m295 302.3.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m295.4 302.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m298.1 302.6.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m298.4 302.3.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m299 302.3.4.4-.5-.4m-63.1.4.5.5-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m236.3 302.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "m238.8 302.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "m239.3 302.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "m241.3 302.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "m242.3 302.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "m243.3 302.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "m244.3 302.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "m245.3 302.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "m245.8 302.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "m248.3 302.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "m248.8 302.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "m249.3 302.7.5.5-.5-.5m30.6 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "m280.4 302.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "m280.9 302.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "m281.4 302.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "m282.4 302.7.5.5-.5-.5m1 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "m284.4 302.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "m285 303 .2.4-.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "m285.7 302.9.4.2-.4-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "m287.4 302.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "m287.9 302.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "m288.9 302.7.5.5-.5-.5zm1.2.4.1.3-.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#736b6b",
    d: "m293.4 302.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m294 302.7.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m294.4 302.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "m295 302.7.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "m295.4 302.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m296 302.7.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m298.4 302.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m299 302.7.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b4242",
    d: "m235.8 303.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "m240.3 303.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "m240.8 303.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "m242.3 303.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "m244.3 303.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "m245.3 303.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "m245.8 303.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M256.8 303.2v.5h3l-3-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m259.8 303.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M260.3 303.2v.5h9.6l-9.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M269.9 303.2v.5h3l-3-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m272.9 303.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "m283.4 303.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "m283.9 303.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "m284.4 303.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "m285.7 303.4.4.1-.4-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "m286.9 303.2 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "m287.4 303.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "m288.9 303.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631818",
    d: "m293.4 303.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m295.6 303.5.2.4-.2-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m296 303.2.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m296.4 303.2.5.5-.5-.5m1.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "m298.4 303.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m229.8 303.7.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m230.3 303.7.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b4242",
    d: "m230.8 303.7.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m232.8 303.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m233.3 303.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m233.8 303.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b2908",
    d: "m235.8 303.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "m239.3 303.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "m240 304 .1.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "m241.3 303.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "m243.3 303.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "m243.8 303.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m250.6 303.9.4.1-.4-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m251.3 303.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m251.8 303.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733129",
    d: "m252.3 303.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "m253.1 303.9.4.1-.4-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#845a52",
    d: "m253.8 303.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M254.3 303.7v.5h2l-2-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m256.3 303.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M256.8 303.7v.5h1.5l-1.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m258.3 303.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m258.8 303.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m259.3 303.7 1.5 1.4-1.5-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M259.8 303.7c1.3 1.6 2.4 2.3 4.5 1.9l-4.5-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m262.8 303.7 1 2.4h1l-2-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m263.3 303.7 1.5 1.4-1.5-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m265.3 303.7-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m265.8 303.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "m266.3 306 4-1.8c-2-.8-4.4-.6-4 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m270.4 303.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m270.9 303.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#946b63",
    d: "m275.4 303.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "m276.2 303.9.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c3939",
    d: "m276.9 303.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m277.4 303.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m277.9 303.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m278.7 303.9.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m279.4 303.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "m286.7 303.9.4.1-.4-.1m1.2-.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "m288.4 303.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "m288.9 303.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "m290 303.7.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m293.4 303.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m296 303.7.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m296.4 303.7.5.5-.5-.5zm2.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m299.4 303.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m229.3 304.2.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631818",
    d: "m229.8 304.2.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m230.3 304.2.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M229.8 308.5c5.2-3 12 5.2 16-1.5l-.5-.4c-1.7.5-3.7 2-5.5 1.7-1.3-.2-14-8.4-10 .2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m233.3 304.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m233.8 304.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631818",
    d: "m234.3 304.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m234.8 304.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m235.3 304.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "m235.8 304.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "m239.3 304.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "m240.3 304.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m246.3 304.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m246.8 304.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m247.3 304.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733129",
    d: "m247.8 304.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "m248.3 304.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c6363",
    d: "m248.8 304.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m249.6 304.3.4.2-.4-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m250.6 304.3.4.2-.4-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m251.3 304.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m259.3 304.2 1.5 1.4-1.5-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "m265.3 304.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m269.9 304.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m270.4 304.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m278.7 304.3.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m279.7 304.3.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c7373",
    d: "m280.4 304.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "m280.9 304.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733939",
    d: "m281.4 304.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m281.9 304.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m282.4 304.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m282.9 304.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "m287.4 304.2.5.5-.5-.5m1.7.3.1.3-.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b2908",
    d: "m293.4 304.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m294 304.2.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m294.4 304.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733129",
    d: "m295 304.2.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m295.4 304.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m296 304.2.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M284.9 306.6c-.7 6.6 11.8 0 15 1.9 1.8-3.7-2.3-5.3-5.4-3.4-1.5.9-2.2 2.8-4.1 3.1-1.9.3-3.9-1-5.5-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m299 304.2.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m299.4 304.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m300 304.2.4.5-.5-.5m-71.2.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m229.3 304.6.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m235.3 304.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "m235.8 304.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m236.3 304.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "m239.8 304.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "m240.3 304.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m243.3 304.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m243.8 304.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m244.3 304.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b2908",
    d: "m244.8 304.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "m245.3 304.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m245.8 304.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m246.3 304.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m246.8 304.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "m264.8 304.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m265.3 304.6 1 1.5-1-1.5m3.5 0-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "m269.4 304.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m269.9 304.6-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m282.4 304.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m282.9 304.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m283.4 304.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "m283.9 304.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733129",
    d: "m284.4 304.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m284.9 304.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m285.4 304.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m285.9 304.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "m289.4 304.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "m293.4 304.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m294 304.6.4.5-.5-.5m6 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m300.4 304.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m228.2 305.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#842118",
    d: "m228.7 305.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m235.8 305.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m236.3 305.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m241.8 305.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "m243.8 305.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m244.3 305.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m260.8 305.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m264.8 305.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "m268.9 305.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m284.9 305.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#391810",
    d: "m285.4 305.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m285.9 305.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m286.4 305.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m286.9 305.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m287.4 305.1 1 1-1-1m5.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m293.4 305.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m300.4 305.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m301 305.1.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m228.2 305.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m228.7 305.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m236.3 305.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m236.8 305.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m241.6 305.8.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631818",
    d: "m244.3 305.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m244.8 305.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m258.8 305.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m259.3 305.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "M259.8 305.6v.5h1.5l-1.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293100",
    d: "m261.3 305.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m261.8 305.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m264.8 305.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "m265.3 305.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m267.4 305.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m267.9 305.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "m268.4 305.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733939",
    d: "m268.9 305.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "m269.4 305.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#736b6b",
    d: "m269.9 305.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m270.4 305.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m284.4 305.6-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1010",
    d: "m284.9 305.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m285.4 305.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m287.4 305.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m292.4 305.6 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m293 305.6.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#736b6b",
    d: "m301 305.6.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c6363",
    d: "m228.2 306 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "m236.8 306 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m237.3 306 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m243.8 306 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m244.3 306-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#100808",
    d: "m244.8 306 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m245.3 306 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m256.8 306 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m257.3 306 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m257.8 306 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "m258.3 306 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m258.8 306 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m259.3 306 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "m258.8 308.5 4 .5c-.2-3-3.4-3.7-4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m261.8 306 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m262.3 306 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "m262.8 306 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#422100",
    d: "m263.3 306 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m263.8 306 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M264.3 306v.6h1.5l-1.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311000",
    d: "m265.8 306 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293100",
    d: "m266.3 306 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m266.9 306 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m267.4 306 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "m266.9 306.6.5 2.3 3.5-.4c-.4-2.4-1.8-2.4-4-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m270.4 306 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#423131",
    d: "m270.9 306 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m271.4 306 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m271.9 306 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m272.4 306 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m272.9 306 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "m284.4 306 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m284.9 306 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m285.4 306 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "m292.4 306 .5.6-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "m301.1 306.4.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m228.2 306.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m236.8 306.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m237.3 306.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m242.8 306.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m243.3 306.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m244.3 306.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m245.3 306.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m245.8 306.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m254.8 306.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m255.3 306.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#736b6b",
    d: "m255.8 306.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631818",
    d: "m256.3 306.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m256.8 306.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m257.3 306.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "m257.8 306.6-2 .4v2.9c1.7-.7 2.7-1.5 2-3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m258.3 306.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "m262.8 306.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M263.3 306.6v2.8h3v-2.8h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "m266.3 306.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m270.9 306.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m271.4 306.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m271.9 306.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m272.4 306.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m272.9 306.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b4242",
    d: "m273.4 306.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m273.9 306.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m274.4 306.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m283.4 306.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1010",
    d: "m283.9 306.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m284.4 306.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m285.4 306.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m285.9 306.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m286.4 306.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m292 306.6.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m292.4 306.6.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m228.4 307.4.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m228.7 307 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m231.3 307 .4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m231.8 307 .4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m237.3 307 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m237.8 307 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m241.8 307 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "m242.3 307 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m242.8 307 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m245.8 307 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m255 307.4.1.3-.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m255.3 307 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M258.3 307v2h.5l-.5-2m4.5 0v2h.5l-.5-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m266.3 307 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m266.9 307 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m270.9 307-1.5 2.4h1.5v-1l1 .6v-2h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M271.9 307v2.4l2 .5.5-2.4-2.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m273.9 307 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b4242",
    d: "m274.4 307 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m283.4 307 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m283.9 307 .5.5-.5-.5m2.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "m286.9 307 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m287.4 307 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m291.4 307 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m292 307 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m297.8 307.2.3.2-.3-.2m2.6-.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m301 307 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m224.7 307.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m225.2 307.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m227.7 307.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1010",
    d: "m228.7 307.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m230.3 307.5.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m230.8 307.5.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m231.3 307.5.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m231.8 307.5.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m232.3 307.5.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m232.8 307.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m233.3 307.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m233.8 307.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m237.8 307.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m238.4 307.8.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m240.8 307.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m241.3 307.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m241.8 307.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m242.3 307.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m245.3 307.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m245.8 307.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m255.3 307.5.5.5-.5-.5m11 0v1h1v-1h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m274.5 307.8.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m283.4 307.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m283.9 307.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m287.4 307.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m287.9 307.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m288.4 307.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m291 307.5.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "m291.4 307.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m292 307.5.4.5-.5-.5m3.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m296 307.5.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m296.8 307.7.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m297.4 307.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m298 307.5.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m298.4 307.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m299 307.5.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "m300.4 307.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m301.3 307.7.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m304.3 307.7.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m223.2 308 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m223.7 308 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733129",
    d: "m224.2 308 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m224.7 308 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M222.2 309.4c2 4.1 12.6 5.3 15 1-5.8.7-9.5-3.7-15-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m227.7 308 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m228.2 308 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m228.7 308 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m230.8 308 .4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M236.8 309.9c-4.7-3.6-7.8 1 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m233.3 308 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m233.8 308 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "m234.3 308 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m234.8 308 .5.5-.5-.5zm6 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m241.3 308 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2121",
    d: "m245.3 308 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m255.3 308 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#736b6b",
    d: "m283.9 308 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m284.4 308 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m288.4 308 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m288.9 308 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m294.4 308 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m295.3 308.1.3.2-.4-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m296 308 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M293 309.4v.5c2.5.3 5.4 1.2 6-2l-6 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "m299 308 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m300 308 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m300.4 308-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m301 308 .4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m301.4 308 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M292.4 310.4c2.5 4.3 13 3 15-1-5.4-2.7-9.2 1.7-15 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m304.4 308 .6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b2908",
    d: "m305 308 .4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#736b6b",
    d: "m305.4 308 .6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m306 308 .4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m306.4 308 .6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m222.2 308.5-1 1.4 1-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a3131",
    d: "m222.7 308.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m223.2 308.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m229.3 308.5.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m234.8 308.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m235.6 308.6.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m236.3 308.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631818",
    d: "m244.8 308.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m245.3 308.5-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m255.3 308.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M258.8 308.5v.5l2 .4-2-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m266.3 308.5 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m266.9 308.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m268.9 308.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m270.9 308.5 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m273.9 308.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m274.4 308.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m283.9 308.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2121",
    d: "m284.4 308.5 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m293 308.5.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m293.4 308.5-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m294 308.5.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m294.4 308.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m299 308.5.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m299.4 308.5.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m306 308.5.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2121",
    d: "m306.4 308.5.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m307 308.5.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631818",
    d: "m222.2 309 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m229.3 309 .4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#210800",
    d: "m229.8 309 .4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m230.3 309-.6.9.6-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m235.8 309 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m236.3 309 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "m236.8 309 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m237.3 309 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m243.8 309 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1010",
    d: "m244.3 309 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "m255.3 309 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m257.8 309 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "m258.3 309 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m259 309.3.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m259.7 309.1.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m260.8 309 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m261.3 309 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m261.8 309 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m262.3 309 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "m262.8 309 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "m266.3 309 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M267.4 309v.4h1.5l-1.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m268.9 309 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m269.9 309 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "m270.9 309 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m273.9 309 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m274.4 309 .5.4-.5-.4m10 0 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m285.4 309 .5.4-.5-.4m6.5 0 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "m292.4 309 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m293.4 309 .5.4-.5-.4m5.5 0 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#210800",
    d: "m299.4 309 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m300 309 .4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m307 309 .4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m307.4 309 .6.4-.6-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631818",
    d: "m221.7 309.4 2.5 2.9-2.5-2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "m230.3 309.4.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#842118",
    d: "m236.8 309.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m237.3 309.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#524242",
    d: "m237.8 309.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m238.3 309.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m238.8 309.4.5.5-.5-.5m4 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m243.3 309.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m243.8 309.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m244.3 309.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#845a52",
    d: "m255.3 309.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m256.3 309.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631818",
    d: "m256.8 309.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b5252",
    d: "m257.3 309.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m257.8 309.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m258.3 309.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M259.3 309.4v.5h2l-2-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m261.3 309.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m261.8 309.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m262.3 309.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "m262.8 309.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "m263.3 309.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m263.8 309.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m264.7 309.6.3.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m265.3 309.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311000",
    d: "m265.8 309.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "m266.3 309.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a1000",
    d: "m266.9 309.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m267.4 309.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m267.9 309.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M268.4 309.4v.5h2l-2-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m270.4 309.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1010",
    d: "m270.9 309.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m271.4 309.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m271.9 309.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b2131",
    d: "m272.4 309.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m272.9 309.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m273.9 309.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m285.4 309.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631818",
    d: "m285.9 309.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m286.4 309.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m290.4 309.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m291 309.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733939",
    d: "m291.4 309.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m292 309.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631818",
    d: "m292.4 309.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m307.4 309.4.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m308 309.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m221.2 309.9 2 1.9-2-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m230.3 309.9.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m230.8 309.9 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m234.8 309.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m235.4 310.2.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m236.1 310 .3.2-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m236.8 309.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392121",
    d: "m237.3 309.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m238.3 309.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m238.8 309.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m239.3 309.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b2131",
    d: "m239.8 309.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m240.3 309.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c4239",
    d: "m240.8 309.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad524a",
    d: "m241.3 309.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "m241.8 309.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m242.3 309.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m242.8 309.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m243.3 309.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m255.3 309.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b2131",
    d: "m255.8 309.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m256.3 309.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m256.8 309.9.5.5-.5-.5m1.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "m258.8 309.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M259.3 309.9v.5h2l-2-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m261.3 309.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m261.8 309.9-.5 1.9.5-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "m262.7 310 .3.2-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "m263.3 309.9-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m263.8 309.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m264.7 310 .3.2-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m265.3 309.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m265.8 309.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m266.3 309.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M266.9 309.9c1.8 2.1 5 4.8 7.5 2.4l-7.5-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m267.9 309.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M268.4 309.9v.5h2l-2-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m270.4 309.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m270.9 309.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m272.9 309.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#524242",
    d: "m273.4 309.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1010",
    d: "m273.9 309.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m286.4 309.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m286.9 309.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "m287.4 309.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad524a",
    d: "m288.2 310 .4.2-.4-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m288.9 309.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733129",
    d: "m289.4 309.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#736b6b",
    d: "m290 309.9.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m290.4 309.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m291 309.9.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "m292 309.9.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m292.4 309.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m293.3 310 .3.2-.4-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m294 310.2.2.3-.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m294.4 309.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m298.4 309.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631818",
    d: "m307.4 309.9.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m308 309.9-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m308.5 309.9.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m220.7 310.4 2 1.9-2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m221.2 310.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m230.8 310.4.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m232 310.5.4.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m232.8 310.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m233.3 310.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m233.8 310.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m234.6 310.5.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m237.3 310.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m237.8 310.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m255.3 310.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m257.8 310.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "m258.3 310.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m258.8 310.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M255.8 312.3c2.4 2.2 4.9.1 6.5-2l-6.5 2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m263.3 310.4-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m266.3 310.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m266.9 310.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m270.9 310.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "m271.4 310.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m271.9 310.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m273.9 310.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "m292 310.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m294.4 310.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m295 310.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m295.4 310.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m296 310.4.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m296.4 310.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M297 310.4v.5h1.4l-1.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m298.4 310.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "m307 310.4.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m308 310.4-1 1.4 1-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m308.5 310.4.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m220.2 310.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m221.7 310.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m237.3 310.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m237.8 310.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m257.3 310.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m257.8 310.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m262.3 310.9-.5.9.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m266.9 310.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "m267.4 310.9.5.4-.5-.4m4.5 0 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m272.4 310.9.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m292 310.9.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m306.4 310.9.6.4-.6-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "m307 310.9.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m308 310.9-1 1.4 1-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m308.5 310.9-.5.9.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m220.7 311.3.5.5-.5-.5m1.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m236.8 311.3-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m237.3 311.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m256.3 311.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "m256.8 311.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m257.3 311.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m262.3 311.3.5.5-.5-.5m5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m267.9 311.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m268.4 311.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m272.4 311.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m272.9 311.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m273.4 311.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m292 311.3.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m292.4 311.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m306 311.3-1 1.5 1-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "m306.4 311.3-1 1.5 1-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m309 311.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m220.2 311.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m221.2 311.8 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m221.7 311.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m222.7 311.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m223.2 311.8 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a3131",
    d: "m236.8 311.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m255.3 311.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m255.8 311.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m256.3 311.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m260.8 311.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m261.3 311.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m268.4 311.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m268.9 311.8.5.5-.5-.5m4.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m273.9 311.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m274.4 311.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m292.4 311.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m293 311.8.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m306.4 311.8.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a59494",
    d: "m307.4 311.8.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m308.5 311.8.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m309 311.8-.5 1.4.5-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m220.7 312.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m222.2 312.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m222.7 312.3 3.5 2.8-3.5-2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m223.2 312.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "m224.2 312.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m228.7 312.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m229.3 312.3.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c3939",
    d: "m229.8 312.3.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#843129",
    d: "m233.3 312.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b5252",
    d: "m235.8 312.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m236.3 312.3.5.5-.5-.5m18.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "m255.3 312.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m259.8 312.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "m260.3 312.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m260.8 312.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m268.9 312.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "m269.4 312.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "m274.4 312.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m274.9 312.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m293 312.3.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#736b6b",
    d: "m293.4 312.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m294 312.3.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#842118",
    d: "m296 312.3.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c4a4a",
    d: "m296.4 312.3.5.5-.5-.5zm3 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "m300 312.3.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m300.4 312.3.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m301 312.3.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m306 312.3-1.6 1.9 1.6-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m306.4 312.3-2.4 3.3 2.4-3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m307.3 312.4.3.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m220.7 312.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m221.2 312.8 1 1.4-1-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m222.2 312.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m223.7 312.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "m224.2 312.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m224.7 312.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "m227.2 312.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m227.7 312.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#736b6b",
    d: "m228.2 312.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m228.7 312.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m254.8 312.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "m255.3 312.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "m255.8 312.8 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m259.3 312.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m259.8 312.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m260.3 312.8.5.4-.5-.4m9 0 .5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m269.9 312.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "m270.4 312.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m273.9 312.8-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "m274.4 312.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m274.9 312.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m300.4 312.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m301 312.8.4.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631818",
    d: "m301.4 312.8.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m302 312.8.4.4-.5-.4m2.5 0-.5 1 .5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "m305 312.8.4.4-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m307 312.8.4.4-.4-.4m1 0-1.6 1.9 1.6-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m221.7 313.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m222.7 313.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "m224.7 313.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "m225.2 313.2.5.5-.5-.5m1.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m227.2 313.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m227.7 313.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m255.8 313.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m258.3 313.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m258.8 313.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m259.3 313.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m270.4 313.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "m270.9 313.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m271.4 313.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "m273.9 313.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m302 313.2.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m302.4 313.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "m304.4 313.2.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m306.4 313.2.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m308 313.2-1 1.5 1-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m223.2 313.7 2 2-2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m223.7 313.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "m225.2 313.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "m225.7 313.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "m226.2 313.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m226.7 313.7.5.5-.5-.5m29.6 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "m256.8 313.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "m257.3 313.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "m257.8 313.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m258.3 313.7.5.5-.5-.5m13 0 .6.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "m271.9 313.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "m272.4 313.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "m272.9 313.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m273.4 313.7.5.5-.5-.5m29 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "m303 313.7.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "m303.4 313.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#391810",
    d: "m304 313.7.4.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m306 313.7.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m224.2 314.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "m225.7 314.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m226.2 314.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m256.8 314.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "m257.3 314.2.5.5-.5-.5m15 0 .6.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "m272.9 314.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m303 314.2 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "m303.4 314.2.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m304 314.2.4.5-.5-.5m1.5 0 .5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m222.7 314.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "m223.2 314.7 2 1.9-2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m224.7 314.7.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m305 314.7.4.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m306 314.7-.6 1 .6-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "m306.4 314.7-.4 1 .4-1m-83.2.5.5.4-.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m225.2 315.1.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "m304.4 315.1.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m223.7 315.6 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m225.2 315.6.5.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m305 315.6.4.5-.4-.5m-81.3.5 1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m304.4 316.1.6.5-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "m305.4 316.1-.4 1 .4-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecca5e",
    d: "m248.2 228.2.8-.2.3.3h.5a.8.8 0 0 0 .4 0 .2.2 0 0 0 .1-.3.2.2 0 0 0 0-.1.7.7 0 0 0-.4-.1 4.7 4.7 0 0 1-1.3-.2.8.8 0 0 1-.4-.7.8.8 0 0 1 .2-.6c.2-.2.5-.4 1-.4h1l.4.6-.7.2a.5.5 0 0 0-.2-.2.7.7 0 0 0-.4 0 1 1 0 0 0-.5 0 .2.2 0 0 0 0 .2v.2l.8.1 1 .2c.2.2.3.3.3.6a.9.9 0 0 1-.3.7c-.2.3-.5.4-1 .4a2 2 0 0 1-1 0 1.2 1.2 0 0 1-.6-.7zm-3.6-.2.1-.8.5-.6c.2-.2.5-.3.8-.3.5 0 .9 0 1.2.3.3.2.5.6.6 1 0 .5 0 .9-.3 1.2a2 2 0 0 1-1.1.6 1.9 1.9 0 0 1-.8-.1 1.3 1.3 0 0 1-.7-.5c-.2-.2-.3-.5-.3-.8zm.8-.1c0 .3.2.5.3.7.2 0 .4.2.6.1a.7.7 0 0 0 .5-.3c.1-.2.2-.4.1-.7a1 1 0 0 0-.3-.6.7.7 0 0 0-.5-.2.7.7 0 0 0-.5.3c-.2.2-.2.4-.2.7zm-2.5-1.6-.1-.7.8-.1.1.7-.8.1zm.4 3.3-.4-2.9.9-.1.3 3h-.8zm-4.8-3.5 1.6-.2h.8c.2 0 .5.1.7.3l.5.6.2 1v.8c0 .3-.2.6-.4.8l-.5.4-.8.2-1.6.2-.5-4.1zm1 .6.3 2.7.6-.1.5-.1a.8.8 0 0 0 .4-.2.8.8 0 0 0 .1-.4v-.8l-.1-.7a1 1 0 0 0-.3-.4.9.9 0 0 0-.5-.1h-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecca5e",
    fillRule: "evenodd",
    d: "m250 239.5 12.2 15.3-.6.7-12.2-15.3zm31.4-1.1-13.6 18-1-.4 13.5-18zm-34.5 4.1 14.4 13.4-.5.8-14.4-13.4zm-3.4 3.1 15.9 11.9-.4.8-15.9-11.9zm40-2.3-14.3 13.5-.8-.4 14.2-13.5zm3 2.5-16 11.7-.6-.6 16-11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b5a00",
    fillOpacity: 0.6,
    d: "m277 244 3.3-4.2-.4-.3-2.9 4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b5a00",
    fillOpacity: 0.5,
    d: "m269.5 253.9 3.3-4.2-.4-.3-2.9 4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b5a00",
    fillOpacity: 0.7,
    d: "m273.3 249.1 3.2-4.2-.3-.3-3 4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b5a00",
    fillOpacity: 0.5,
    d: "m281 249.6 4.6-2.8-.3-.4-4.3 3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b5a00",
    fillOpacity: 0.4,
    d: "m275 251.3 4-3.5-.3-.3-3.8 3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M236 286h-.6c0-2.7-1.1-4.5-4-5.2 0 1.4 1.1 7.1 3.5 5.2h.5l-1 4.3c1.5-1.6 7.7-7.1 5-9.6-2.3-2-3.4 4.3-3.5 5.3zm-4-34h-.5c-.1-2.7-1.2-4.5-4-5.3 0 1.5 1.1 7.2 3.5 5.3h.5l-1 4.3c1.5-1.6 7.7-7.2 5-9.6-2.3-2.1-3.5 4.2-3.5 5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecca5e",
    d: "M297.1 230.6h-.7v-.5a1.3 1.3 0 0 1-.5.3 1.2 1.2 0 0 1-1.4-.5c-.2-.2-.3-.6-.2-1.1 0-.5.2-.9.5-1.1.3-.3.6-.4 1-.3.3 0 .6.2.8.5l.2-1.5.8.1-.5 4zm-2-1.8v.7a.6.6 0 0 0 .6.4.6.6 0 0 0 .5-.2c.2-.1.2-.4.3-.7l-.1-.7a.6.6 0 0 0-.5-.3.6.6 0 0 0-.5.2 1 1 0 0 0-.3.6zm-3.3-.9-.7-.2c.1-.3.3-.4.5-.6s.5-.1 1 0l.7.1.4.4v.7l-.1 1a3 3 0 0 0 0 .5v.4h-.7a2.4 2.4 0 0 1-.1-.3v-.1a1.4 1.4 0 0 1-1 .3 1 1 0 0 1-.7-.4.8.8 0 0 1-.3-.6.8.8 0 0 1 .6-.7l.7-.1.8-.1v-.4l-.5-.2a.6.6 0 0 0-.3 0 .6.6 0 0 0-.3.3zm1 .8h-.5a2 2 0 0 0-.4.1l-.2.3v.3l.4.1a.7.7 0 0 0 .4 0 .5.5 0 0 0 .3-.3v-.5zm-2-1.8-.1.6h-.6l-.1 1.2v.4l.1.1a1 1 0 0 0 .4 0v.6h-.7a1 1 0 0 1-.4 0 .6.6 0 0 1-.2-.3.7.7 0 0 1-.1-.3 3.5 3.5 0 0 1 0-.5l.2-1.3h-.4l.1-.7h.4v-.5l1-.4-.2 1 .6.1zm-3.4 2.6h-.8l.4-3h.7v.5l.4-.4a.7.7 0 0 1 .3 0c.2 0 .4 0 .6.2l-.4.6a.7.7 0 0 0-.3-.1.5.5 0 0 0-.3 0l-.3.3-.2 1v1zm-2.2-1.2.8.2a1 1 0 0 1-.5.6c-.3.2-.6.2-1 .2-.5 0-.8-.3-1-.7a1.6 1.6 0 0 1-.2-1c0-.5.2-.9.5-1.1.3-.3.7-.4 1-.3.5 0 .9.2 1.1.5.3.4.3.8.2 1.4l-2-.2.1.5c.1.2.3.3.5.3a.5.5 0 0 0 .3 0 .6.6 0 0 0 .2-.4zm.2-.8-.1-.5a.6.6 0 0 0-.4-.2.6.6 0 0 0-.5.1.7.7 0 0 0-.3.5l1.3.1zm-5.8 1.2.5-4.1h.9l-.2 1.5c.3-.2.6-.3 1-.3.3 0 .6.2.8.5.2.3.3.7.2 1.2 0 .5-.2.9-.5 1.1a1.2 1.2 0 0 1-1.5.1 1.3 1.3 0 0 1-.4-.4v.4h-.8zm1-1.5.1.7a.7.7 0 0 0 .5.4.6.6 0 0 0 .5-.2c.2-.1.3-.4.3-.7l-.1-.7a.6.6 0 0 0-.5-.3.6.6 0 0 0-.5.2l-.3.6zm-2.2-2 .1-.8.8.1v.7h-.9zm-.4 3.3.4-3 .8.1-.4 3-.8-.1zm-3.6-.4.5-4h.8l-.4 3.4 2.2.2-.1.7-3-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M227 261.4h-.5c-.1-2.7-1.2-4.5-4-5.3 0 1.5 1 7.2 3.5 5.3h.5l-1 4.3c1.5-1.6 7.7-7.2 5-9.6-2.3-2.1-3.5 4.2-3.5 5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fac349",
    fillRule: "evenodd",
    d: "M244.7 246.2c0 .4-.4.7-1 .7s-.9-.3-.9-.7c0-.3.5-.6 1-.6s.9.3.9.6zm3.1-3.3c0 .4-.4.7-.9.7s-1-.3-1-.7c0-.4.5-.6 1-.6s1 .3 1 .6zm3-3c0 .3-.5.6-1 .6s-1-.3-1-.7c0-.3.5-.6 1-.6s1 .3 1 .6zm30.8-1.3c0 .4-.4.7-1 .7s-.8-.3-.8-.7c0-.4.4-.7.9-.7s1 .3 1 .7zm2.2 4.3c0 .4-.4.7-.9.7s-1-.3-1-.7c0-.4.5-.6 1-.6s1 .3 1 .6zm3.3 2.8c0 .3-.4.6-1 .6s-.9-.3-.9-.6c0-.4.4-.7 1-.7s.9.3.9.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecca5e",
    d: "m270.8 222.4-.7-.2c0-.2.2-.5.4-.6l1-.2.8.1.3.4.1.7v.9a1.8 1.8 0 0 0 .2 1h-.8a3.2 3.2 0 0 1-.1-.3l-.5.2-.5.1a1.1 1.1 0 0 1-.8-.3.8.8 0 0 1-.2-.6.8.8 0 0 1 .5-.7l.6-.2.8-.2v-.4l-.5-.1a.6.6 0 0 0-.4 0 .6.6 0 0 0-.2.4zm1.1.6a5.7 5.7 0 0 1-.5.1l-.4.2-.2.2.1.3.4.2.4-.2a.5.5 0 0 0 .2-.2v-.6zm-3.4-2v-.7h.9v.8h-.8zm0 3.4v-3h.9v3h-.9zm-1.5 0h-.9v-3h.8v.5l.4-.4a.7.7 0 0 1 .4-.1l.5.1-.3.7a.8.8 0 0 0-.4-.1.5.5 0 0 0-.3 0l-.1.4a4.5 4.5 0 0 0-.1 1v.9zm-1.4-3v.6h-.5v1.7a.3.3 0 0 0 .2.1h.3v.5l-.6.2a1 1 0 0 1-.4-.1.6.6 0 0 1-.3-.2.7.7 0 0 1 0-.3 3.4 3.4 0 0 1 0-.6V222h-.4v-.6h.3v-.6l.9-.4v1h.5zm-4.1.9-.8-.1c.1-.3.2-.5.5-.7l.9-.2c.3 0 .6 0 .8.2.2 0 .3.2.4.3v1.6a1.8 1.8 0 0 0 .2 1h-.8a3.2 3.2 0 0 1 0-.3 1.3 1.3 0 0 1-1 .3 1.1 1.1 0 0 1-.8-.2.8.8 0 0 1-.3-.7.8.8 0 0 1 .1-.4.8.8 0 0 1 .4-.3l.7-.2.8-.2-.1-.4h-.5a.6.6 0 0 0-.3 0 .6.6 0 0 0-.2.3zm1 .6a5.8 5.8 0 0 1-.4.2h-.5l-.2.4s0 .2.2.2l.3.2c.1 0 .3 0 .4-.2a.5.5 0 0 0 .2-.2v-.6zm-5.7 1.4v-4h2.5c.2 0 .4.2.6.4.2.2.3.5.2.8l-.1.6a1.1 1.1 0 0 1-.4.4 1.3 1.3 0 0 1-.4.2 5 5 0 0 1-1 0h-.5v1.6h-.9zm1-3.4v1.2h1.1a.6.6 0 0 0 .3-.6.5.5 0 0 0 0-.4.6.6 0 0 0-.4-.1 4.4 4.4 0 0 0-.7 0h-.4zm1.6 78.9h-.5a.8.8 0 0 1 .2-.6l.7-.2h.6c.1 0 .3 0 .3.2l.2.5v.7l.2.4.1.3h-.6a2.7 2.7 0 0 1 0-.2 1 1 0 0 1-.8.4.8.8 0 0 1-.6 0 .6.6 0 0 1-.2-.5.6.6 0 0 1 .2-.6l.5-.2.6-.3-.2-.2h-.3a.5.5 0 0 0-.2 0 .4.4 0 0 0-.2.3zm1 .3a3.9 3.9 0 0 1-.4.2 1 1 0 0 0-.3.1l-.1.2a.3.3 0 0 0 .1.2h.3a.6.6 0 0 0 .3 0 .4.4 0 0 0 0-.3v-.3zm-1.9-.2-.6.2a.4.4 0 0 0-.1-.3.4.4 0 0 0-.3 0 .5.5 0 0 0-.4.2v.5c0 .3 0 .4.2.5 0 .2.2.2.4.2a.4.4 0 0 0 .3-.2v-.3h.7a1 1 0 0 1-.3.6c-.1.2-.4.3-.7.3a1 1 0 0 1-.8-.2 1.2 1.2 0 0 1-.5-.8c0-.3 0-.6.2-.9l.8-.4.7.1.4.5zm-3.4-.5v-.5l.5-.1.1.5-.6.1zm.4 2.5-.3-2.2h.6l.3 2.1-.6.1zm-1.2.2-.5-3 .6-.1.5 3h-.6zm-2.8.4-.5-3 .6-.2.2 1.2a.9.9 0 0 1 .6-.4 1 1 0 0 1 .8.1l.4.8-.1 1a.9.9 0 0 1-.7.3.9.9 0 0 1-.4 0 1 1 0 0 1-.4-.2v.3h-.5zm.4-1.3c0 .3.1.4.2.5.2.2.3.2.5.2a.4.4 0 0 0 .3-.2v-.5c0-.3 0-.5-.2-.6a.5.5 0 0 0-.4 0 .5.5 0 0 0-.3.1v.5zm-1.6 1.5v-.4a.8.8 0 0 1-.3.4 1 1 0 0 1-.4.1.9.9 0 0 1-.4 0 .6.6 0 0 1-.4-.3 1.2 1.2 0 0 1-.1-.4l-.2-1.4.6-.1.1 1 .2.6a.3.3 0 0 0 .1.1.5.5 0 0 0 .5 0 .4.4 0 0 0 .1-.3v-.6l-.1-1h.6l.3 2.2h-.6zm-4.6-1.6.6-.1v.3a.9.9 0 0 1 .7-.5c.3 0 .5 0 .7.2.3.2.4.5.5.8 0 .4 0 .7-.2 1a.9.9 0 0 1-.6.3.8.8 0 0 1-.4 0 1.3 1.3 0 0 1-.4-.2l.2 1.1-.6.1-.5-3zm.8 1 .2.5a.5.5 0 0 0 .4 0 .5.5 0 0 0 .4-.1v-.6c0-.2 0-.4-.2-.5a.5.5 0 0 0-.4 0 .5.5 0 0 0-.3.1l-.1.5zm-1.7.6h.7a1 1 0 0 1-.3.6 1 1 0 0 1-.6.2c-.4.1-.8 0-1-.2a1 1 0 0 1-.3-.7c-.1-.4 0-.7.1-1a1 1 0 0 1 .7-.3c.4-.1.7 0 .9.2.2.1.4.5.4.9l-1.5.2.2.4a.5.5 0 0 0 .4.1.4.4 0 0 0 .2-.1.5.5 0 0 0 .1-.3zm0-.6-.2-.3a.4.4 0 0 0-.4-.1.4.4 0 0 0-.3.2.5.5 0 0 0 0 .4l.9-.2zm-4.4 2-.5-3 1.4-.3h.7c.2 0 .3.1.4.3.2 0 .2.2.3.4a.8.8 0 0 1-.2.6 1 1 0 0 1-.5.4l.3.2.5.4.5.6h-.8l-.6-.5a4.4 4.4 0 0 0-.4-.4.5.5 0 0 0-.2-.1 1.2 1.2 0 0 0-.3 0h-.2l.2 1.3h-.6zm.4-1.9h.4l.6-.1.2-.2v-.2a.4.4 0 0 0-.1-.3.4.4 0 0 0-.3 0h-1l.2.8zm47.7.4-.5-.2a.8.8 0 0 1 .4-.4l.7-.1.6.2.2.2v1.3l-.1.4v.3h-.5a3 3 0 0 1 0-.3l-.5.1a1 1 0 0 1-.3 0 .8.8 0 0 1-.6-.2.6.6 0 0 1-.1-.5.6.6 0 0 1 .4-.5h.5a3.7 3.7 0 0 0 .6-.1v-.3l-.3-.2a.5.5 0 0 0-.3 0 .4.4 0 0 0-.2.3zm.8.5h-.4a1 1 0 0 0-.3.1l-.2.2v.3h.6a.4.4 0 0 0 .2-.2v-.4zm-2 .8h-.7l.2-1.2v-.4a.3.3 0 0 0 0-.2.3.3 0 0 0-.3-.1.5.5 0 0 0-.3 0 .5.5 0 0 0-.2.3l-.1.4-.2 1h-.6l.4-2.2h.5v.4a1 1 0 0 1 .8-.3 1 1 0 0 1 .4.1l.2.2a.6.6 0 0 1 0 .3v.4l-.2 1.3zm-4-2-.5-.2c0-.2.2-.4.4-.4l.7-.1.6.2.2.3v1.2a1.3 1.3 0 0 0 0 .7h-.6v-.3l-.5.1a1 1 0 0 1-.4 0 .8.8 0 0 1-.5-.2.6.6 0 0 1-.1-.5.6.6 0 0 1 .4-.5h.5l.6-.1v-.4h-.3a.5.5 0 0 0-.3 0 .4.4 0 0 0-.2.2zm.8.6h-.4a1 1 0 0 0-.4 0l-.1.2v.3h.3a.6.6 0 0 0 .3 0c.1 0 .2 0 .2-.2v-.3zm-1.7-.8h-.6a.4.4 0 0 0-.1-.2.4.4 0 0 0-.3-.2.5.5 0 0 0-.4.1l-.2.5v.6l.4.2a.4.4 0 0 0 .3 0l.2-.3.6.1a1 1 0 0 1-.4.6c-.2 0-.5.1-.8 0-.3 0-.6-.1-.7-.3a1.1 1.1 0 0 1-.2-1c0-.3.2-.5.4-.7.2-.2.5-.3.9-.2.3 0 .5.1.6.3.2 0 .3.3.3.5zm-3.1-1.4v-.5h.7l-.1.6h-.6zm-.4 2.5.3-2.2.7.1-.4 2.2h-.6zm-.6 0-.6-.1.2-1.1v-.5a.3.3 0 0 0-.1-.2.4.4 0 0 0-.2 0 .5.5 0 0 0-.3 0 .4.4 0 0 0-.2.2l-.2.5-.1 1-.6-.1.3-2.2h.6v.4a1 1 0 0 1 .8-.3 1 1 0 0 1 .3.1l.2.2a.6.6 0 0 1 .1.3v.4l-.2 1.4zm-3-3v-.5h.7v.6h-.7zm-.4 2.5.4-2.2h.6l-.3 2.3h-.7zm-3.6-2.7h.5v.3c.2-.2.5-.2.8-.2a.8.8 0 0 1 .3.1l.3.3.3-.2a.9.9 0 0 1 .4 0l.4.1a.6.6 0 0 1 .2.3v.5l-.2 1.4h-.6l.2-1.3v-.4l-.2-.2a.4.4 0 0 0-.5.2l-.1.5-.2 1h-.6l.2-1.2v-.5a.3.3 0 0 0 0-.1.3.3 0 0 0-.2 0 .5.5 0 0 0-.3 0 .4.4 0 0 0-.2.1l-.1.5-.2 1h-.6l.4-2.2zm-3 .7c0-.2 0-.4.2-.6a1 1 0 0 1 .5-.3l.6-.1c.4 0 .7.2.8.4l.3.9a1.1 1.1 0 0 1-.5.8 1.2 1.2 0 0 1-1 .2l-.5-.2a1 1 0 0 1-.4-.5 1.3 1.3 0 0 1 0-.6zm.6 0v.6l.5.2a.6.6 0 0 0 .4 0l.2-.6v-.5a.5.5 0 0 0-.4-.2.6.6 0 0 0-.5 0l-.2.6zm-3.4-2.4 1.2.2.6.1.4.4.2.5a2.2 2.2 0 0 1-.2 1.4c0 .2-.2.4-.4.5a1 1 0 0 1-.5.2 2.1 2.1 0 0 1-.6 0l-1.2-.2.5-3zm.5.6-.3 2 .5.1h.4a.6.6 0 0 0 .3 0 .6.6 0 0 0 .2-.3l.1-.6v-.5a.7.7 0 0 0 0-.3.6.6 0 0 0-.3-.2 3.4 3.4 0 0 0-.6-.1h-.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDo);
export default __webpack_public_path__ + "static/media/do.d2287a1e1eee0805fc2703cc75c35d9f.svg";
export { ForwardRef as ReactComponent };